import { getSiteLanguage, SiteLanguage } from "./language";

const siteTextsPt = {
  common: {
    loading: "Carregando...",
    save: "Salvar",
    apply: "Aplicar",
    clear: "Limpar",
    cancel: "Cancelar",
    remove: "Remover",
    edit: "Editar",
    close: "Fechar",
    confirm: "Confirmar",
    removing: "Removendo...",
    backToProfile: "Voltar ao perfil",
    apiError: "Erro na API",
    passwordVisibility: {
      show: "Mostrar senha",
      hide: "Ocultar senha",
    },
    timePicker: {
      open: "Abrir seletor de horário",
    },
    locationActions: {
      openMap: "Abrir localização no mapa",
      copyAddress: "Copiar endereço",
      copied: "Endereço copiado.",
      copyError: "Não foi possível copiar o endereço.",
    },
    infoTooltip: {
      ariaLabel: "Ver informação",
    },
    info: {
      challengeModel:
        "Padrão TNP usa as regras oficiais da plataforma. Personalizado permite ajustar jogadores, quadras e forma de disputa dentro dos limites.",
      tnpStandard:
        "Padrão TNP utiliza as regras oficiais definidas pela plataforma.",
      customChallenge:
        "Personalizado permite ajustar quantidade de jogadores, quadras e forma de disputa, respeitando os limites mínimos.",
      gameType: "Define se a partida será controlada por games ou por tempo.",
      byGames: "Por games encerra a disputa quando a pontuação configurada é atingida.",
      byTime: "Por tempo exibe um cronômetro regressivo na tela de execução.",
      gameCount: "Quantidade de games que orienta o encerramento da partida.",
      gameDuration:
        "Tempo de duração de cada jogo. O cronômetro regressivo usa esse valor.",
      courtsCount:
        "Quantidade de quadras disponíveis para montar jogos simultâneos.",
      playersCount:
        "Quantidade total de jogadores do desafio, respeitando os limites do modelo selecionado.",
      category:
        "A categoria é usada para validar elegibilidade técnica e organizar inscrições.",
      openCategory:
        "Categorias Livre não possuem restrição de gênero, mas respeitam a regra técnica da categoria.",
      ranking:
        "Quando ativo, o evento contabiliza pontos no ranking conforme as regras do TNP.",
      organizerRanking:
        "Quando ativo, o evento contabiliza pontos apenas no ranking próprio do organizador.",
      eventShirts:
        "Habilite camisetas para permitir escolha de tamanhos durante a inscrição.",
      shirtsByPeriod:
        "Camisas por período ficam disponíveis somente até a data limite configurada.",
      shirtsByQuantity:
        "Camisas por quantidade ficam disponíveis até acabar o limite configurado.",
      tournamentCategories:
        "Categorias separam inscrições, horários e vagas dentro do torneio.",
      tournamentFormat:
        "O formato define como os confrontos serão organizados no torneio.",
      groupStage:
        "Fase de grupos organiza os participantes em grupos antes da etapa eliminatória.",
      knockout:
        "Mata-mata elimina participantes conforme avançam os confrontos.",
      americanSystem:
        "Sistema americano gera jogos rotativos para somar desempenho entre participantes.",
      valuePerPlayer:
        "Valor cobrado de cada jogador. Em dupla fixa, o total considera os dois jogadores.",
      slotLimit: "Limite máximo de inscrições disponíveis para esta categoria.",
      categoryTime: "Horário previsto para a categoria dentro do evento.",
      registrationCategory:
        "A categoria é validada conforme seu perfil e as regras do evento.",
      fixedPair:
        "Dupla fixa exige selecionar ou informar seu parceiro antes de concluir a inscrição.",
      externalPayment:
        "Pagamento externo abre o provedor de cobrança fora da plataforma TNP.",
      pix: "PIX costuma confirmar mais rápido, conforme retorno do provedor de pagamento.",
      credit:
        "Crédito pode incluir taxa do método e depende da confirmação do provedor.",
      discountCoupon:
        "O cupom será aplicado ao valor total da inscrição, quando válido.",
      shirt:
        "A inscrição continua disponível mesmo quando a camisa não estiver mais disponível.",
      shirtUnavailable:
        "Camisa indisponível significa que o prazo terminou ou o limite configurado acabou.",
      referral: "Indique quem convidou você para participar do evento.",
      incompatibleCategory:
        "Categoria incompatível indica que a dupla ou atleta não atende às regras desta categoria.",
      modality: "Filtra o ranking pelo tipo de evento considerado.",
      period: "Define a janela de eventos usada no cálculo do ranking.",
      allTime: "Sempre considera todo o histórico do ranking.",
      last4:
        "Últimas 4 etapas considera apenas os quatro eventos mais recentes da modalidade e categoria selecionadas.",
      consideredStages:
        "Etapas consideradas são os eventos usados na soma de pontos atual.",
      countedEvents:
        "Eventos contabilizados indica quantos eventos entraram no cálculo atual.",
      rankedAthletes:
        "Atletas ranqueados mostra quantas pessoas aparecem na seleção atual.",
      points:
        "Os pontos são somados por pessoa dentro da categoria selecionada.",
      tiebreakers:
        "Em caso de empate, o sistema aplica os critérios de desempate definidos no regulamento.",
      currentCategory:
        "A categoria atual define em quais eventos você pode se inscrever.",
      rankingPosition:
        "A posição no ranking considera sua categoria atual no ranking geral.",
      titles: "Títulos conquistados contam eventos finalizados como campeão.",
      runnerUps:
        "Vice-campeonatos contam eventos finalizados em segundo lugar.",
      categoryChange:
        "A troca de categoria precisa ser aprovada pela equipe TNP.",
      openRegistrations:
        "Liberar inscrições torna o evento disponível para inscrição pública.",
      closeRegistrations:
        "Fechar inscrições impede novas inscrições sem apagar registros existentes.",
      remove:
        "Remover exclui o item selecionado. Use apenas quando tiver certeza.",
      eventStatus: "Status indica se o evento está a iniciar, em andamento ou finalizado.",
      eventDateTime:
        "Data e horário indicam quando o evento está previsto para acontecer.",
      participants: "Participantes são os jogadores selecionados ou inscritos no evento.",
      registrations: "Inscrições reúnem os registros recebidos pelo formulário público.",
      split:
        "Split define como os valores recebidos são divididos entre plataforma e organizador.",
      users: "Usuários são contas cadastradas com permissões e dados esportivos.",
      userCategory: "Categoria do usuário usada para validação de inscrições.",
      userRole: "Perfil do usuário define permissões de acesso no sistema.",
      shareRanking: "Compartilhar ranking gera uma arte ou link da seleção atual.",
      shareResult: "Compartilhar resultado gera uma arte ou link do resultado exibido.",
      shareChampionship:
        "Compartilhar campeonato usa os dados públicos do torneio atual.",
      downloadPng: "Baixar PNG salva a arte gerada no dispositivo.",
      copyLink: "Copiar link envia o endereço da tela atual para a área de transferência.",
      methodFee: "Taxa do método varia conforme a forma de pagamento escolhida.",
      subtotal: "Subtotal antes de desconto e taxas do método de pagamento.",
      registrationTotal:
        "Total da inscrição após desconto e taxa do método, quando aplicáveis.",
    },
    dateRange: {
      placeholder: "Selecionar período",
      until: "até",
      openEnded: "...",
    },
    userAvatar: {
      sex: {
        female: "feminino",
        male: "masculino",
        other: "outro",
        notInformed: "não informado",
      },
      customAltPrefix: "Foto de perfil de",
      defaultAltPrefix: "Avatar padrão",
      defaultAltConnector: "de",
      fallbackUser: "usuário",
    },
    searchInput: {
      clear: "Limpar busca",
    },
    pageSize: {
      ariaLabel: "Itens por página",
      perPage: "{count} por página",
      all: "Todos",
    },
    filters: {
      allCategories: "Todas as categorias",
      allSexes: "Misto",
    },
    sex: {
      notInformed: "Não informar",
      male: "Masculino",
      female: "Feminino",
      other: "Outro",
    },
    challengeGender: {
      male: "Masculino",
      female: "Feminino",
      mixed: "Mista",
      open: "Livre",
      maleShort: "Masc.",
      femaleShort: "Fem.",
    },
    category: {
      notInformed: "Não informar",
      c7a: "Iniciante (7ª)",
      c6a: "6ª",
      c5a: "5ª",
      c4a: "4ª",
      c3a: "3ª",
      c2a: "2ª",
      open: "Open",
      free: "Livre",
    },
    serverUnavailable: {
      title: "Não foi possível conectar com nosso servidor",
      description:
        "Estamos com dificuldades para acessar o sistema no momento. Isso pode ser temporário, tente novamente em instantes.",
      actions: {
        retry: "Tentar novamente",
      },
      supportHint: "Se o problema persistir, entre em contato com o suporte.",
    },
    language: {
      label: "Idioma",
      modalTitle: "Escolha seu idioma",
      modalDescription:
        "Selecione como deseja navegar pelo site. Você poderá alterar depois no header.",
      options: {
        pt: "Português",
        en: "English",
        es: "Español",
      },
    },
  },
  header: {
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
    nav: {
      about: "Sobre",
      challenges: "Desafios",
      tournaments: "Torneios",
      ranking: "Ranking",
      athletes: "Atletas",
      matches: "Partidas",
      clubs: "Clubes",
      admin: "Painel",
      profile: "Perfil",
      createAccount: "Criar conta",
      login: "Login",
      logout: "Sair",
    },
    hello: "Olá",
    fallbackPlayerName: "Padelista",
    notifications: {
      ariaLabel: "Abrir notificações",
      title: "Notificações",
      loading: "Carregando notificações...",
      empty: "Nenhuma notificação.",
      error: "Erro ao carregar notificações.",
      markAllRead: "Marcar todas como lidas",
      markRead: "Marcar como lida",
      removeAll: "Excluir todas",
      remove: "Excluir",
      actions: {
        paymentPending: "Pagamento pendente",
        payNow: "Pagar agora",
        registrationConfirmed: "Inscrição confirmada",
        viewRegistration: "Ver inscrição",
        viewGames: "Ver jogos",
        acceptInvite: "Aceitar convite",
        declineInvite: "Recusar convite",
      },
    },
  },
  footer: {
    description: "Desafios, eventos e comunidade conectada.",
    instagramAriaLabel: "Instagram Todos no Padel",
    instagramHandle: "@todosnopadel",
    privacyPolicy: "Política de Privacidade",
    termsOfUse: "Termos de Uso",
  },
  auth: {
    login: {
      title: "Login",
      subtitle: "Acesse sua conta para participar dos desafios.",
      submit: "Entrar",
      error: "Falha ao entrar. Verifique e-mail/CPF e senha.",
      footerCta: "Ainda não tem conta?",
      footerLink: "Criar conta",
      identifierLabel: "E-mail ou CPF",
      passwordLabel: "Senha",
    },
    register: {
      title: "Criar conta",
      subtitle: "Cadastro inicial com nome, e-mail e senha.",
      submit: "Criar conta",
      error: "Falha ao criar conta. Verifique os dados e tente novamente.",
      invalidCpf: "CPF inválido.",
      invalidPhone: "Informe o telefone completo com código do país e DDD.",
      footerCta: "Já possui cadastro?",
      footerLink: "Entrar",
      nameLabel: "Nome",
      emailLabel: "E-mail",
      cpfLabel: "CPF",
      phoneLabel: "Telefone",
      passwordLabel: "Senha",
      sexLabel: "Sexo",
      categoryLabel: "Categoria",
    },
    forgotPassword: {
      title: "Recuperar senha",
      link: "Esqueci minha senha",
      subtitle: "Informe seu e-mail ou CPF para receber as instruções.",
      submit: "Enviar link de redefinição",
      backToLogin: "Voltar ao login",
      genericMessage:
        "Se os dados informados estiverem cadastrados, enviaremos um e-mail com as instruções para redefinir sua senha.",
      resetSuccess:
        "Senha redefinida com sucesso. Faça login com sua nova senha.",
    },
    resetPassword: {
      title: "Redefinir senha",
      subtitle: "Crie uma nova senha para acessar sua conta.",
      submit: "Redefinir senha",
      newPassword: "Nova senha",
      confirmPassword: "Confirmar nova senha",
      invalidToken: "Token inválido ou expirado.",
      minLength: "A nova senha deve ter ao menos {count} caracteres.",
      mismatch: "As senhas informadas não são iguais.",
      success:
        "Senha redefinida com sucesso. Faça login com sua nova senha.",
      error:
        "Não foi possível redefinir sua senha. Solicite um novo link.",
    },
    confirmEmail: {
      title: "Confirmar e-mail",
      missingToken: "Token de confirmação ausente.",
      success: "E-mail confirmado com sucesso.",
      error: "Não foi possível confirmar o e-mail.",
      loading: "Confirmando e-mail...",
      goToProfile: "Ir para perfil",
    },
    context: {
      invalidSession: "Sessão inválida",
      hookOutOfScope: "useAuth deve ser usado dentro de AuthProvider",
    },
  },
  paymentSuccess: {
    title: "Pagamento iniciado",
    description:
      "Recebemos seu retorno. A confirmação oficial da inscrição será atualizada automaticamente via webhook da Asaas.",
    viewRegistrations: "Ver minhas inscrições",
    backToChallenges: "Voltar aos desafios",
  },
  publicPlayerProfile: {
    title: "Perfil esportivo",
    subtitle: "Histórico público do atleta no TNP.",
    categoryPrefix: "Categoria",
    categoryFallback: "Categoria não informada",
    notFound: "Perfil não encontrado.",
    loadError: "Não foi possível carregar este perfil.",
    openPhoto: "Ampliar foto do atleta",
    photoDialogTitle: "Foto do atleta",
    photoAlt: "Foto de perfil de {name}",
    shareProfile: "Compartilhar perfil",
    shareTitle: "Perfil esportivo de {name}",
    shareText: "Confira o perfil esportivo de {name} no Todos no Padel.",
    ranking: {
      title: "Ranking atual",
      subtitle: "Melhor posição ativa encontrada.",
      empty: "Este atleta ainda não possui pontuação no ranking.",
      positionSuffix: "º lugar",
      pointsSuffix: "pontos",
      noPosition: "Sem posição",
      myCategoryRanking: "Minha categoria",
      byTypeTitle: "Colocação por tipo",
      openRanking: "Abrir ranking",
    },
    stats: {
      title: "Estatísticas",
      subtitle: "Números consolidados do histórico esportivo.",
      participations: "Participações",
      points: "Pontos",
      wins: "Vitórias",
      losses: "Derrotas",
      titles: "Títulos",
      runnerUps: "Vices",
      gamesBalance: "Saldo",
    },
    achievements: {
      title: "Conquistas",
      subtitle: "Badges desbloqueados pelo atleta.",
      empty: "Nenhuma conquista pública desbloqueada.",
    },
    participations: {
      title: "Histórico esportivo",
      subtitle: "Eventos com resultado registrado.",
      empty: "Nenhuma participação pública registrada.",
    },
  },
  athletesPage: {
    title: "Atletas",
    subtitle: "Encontre atletas cadastrados no TNP.",
    searchPlaceholder: "Buscar por nome",
    categoryFilter: "Categoria",
    allCategories: "Todas as categorias",
    sexFilter: "Sexo",
    allSexes: "Misto",
    empty: "Nenhum atleta encontrado.",
    loadError: "Não foi possível carregar os atletas.",
  },
  clubs: {
    title: "Clubes",
    subtitle: "Encontre clubes de padel para jogar, reservar quadra e acompanhar seus lances.",
    filtersLabel: "Filtros de clubes",
    searchPlaceholder: "Buscar clube",
    cityFilter: "Cidade",
    cityPlaceholder: "Digite a cidade",
    stateFilter: "Estado",
    allStates: "Todos",
    listView: "Lista",
    mapView: "Mapa",
    useLocation: "Usar minha localização",
    locationUnavailable: "Não foi possível usar a localização neste dispositivo.",
    locationApplied: "Clubes próximos carregados.",
    locationDenied: "Permissão de localização negada. A busca manual continua disponível.",
    loadError: "Não foi possível carregar os clubes.",
    empty: "Nenhum clube encontrado.",
    noMapCoordinates: "Nenhum clube desta busca possui coordenadas cadastradas.",
    requestClub: {
      action: "Adicionar clube",
      title: "Solicitar cadastro de clube",
      subtitle:
        "Envie os dados principais para avaliarmos o cadastro no diretório.",
      close: "Fechar solicitação de clube",
      success: "Solicitação enviada. Nossa equipe vai analisar o clube.",
      error: "Não foi possível enviar a solicitação do clube.",
      saving: "Enviando...",
      submit: "Enviar solicitação",
      requiredHint: "Nome, cidade e UF são obrigatórios.",
      contactHint:
        "Informe um contato, site, Instagram, endereço ou observação para ajudar a localizar o clube.",
      fields: {
        requesterName: "Seu nome",
        requesterEmail: "Seu e-mail",
        requesterPhone: "Seu telefone",
        clubName: "Nome do clube",
        city: "Cidade",
        state: "UF",
        address: "Endereço",
        websiteUrl: "Site",
        instagramUrl: "Instagram",
        notes: "Observações",
      },
      placeholders: {
        requesterName: "Como podemos te identificar",
        requesterEmail: "voce@email.com",
        requesterPhone: "(00) 00000-0000",
        clubName: "Nome público do clube",
        city: "Cidade do clube",
        state: "SC",
        address: "Rua, número e bairro",
        websiteUrl: "https://...",
        instagramUrl: "@clubedepadel",
        notes: "Links, contato do clube ou detalhes úteis",
      },
    },
    actions: {
      viewClub: "Ver clube",
      instagram: "Instagram",
      booking: "Reservar quadra",
      lances: "Ver meus lances",
      directions: "Como chegar",
      site: "Site",
    },
    detail: {
      notFound: "Clube não encontrado.",
      back: "Voltar para clubes",
      tabs: {
        navigation: "Seções do clube",
        about: "Sobre",
        location: "Endereço e mapa",
        contact: "Contato",
        matches: "Partidas",
        events: "Eventos",
      },
      about: "Sobre o clube",
      noDescription: "Este clube ainda não possui descrição cadastrada.",
      matchesTitle: "Próximas partidas neste clube",
      noMatches: "Ainda não há partidas abertas publicadas para este clube.",
      viewAllMatches: "Ver todas as partidas",
      createMatch: "Criar partida neste clube",
      address: "Endereço",
      street: "Rua",
      neighborhood: "Bairro",
      cityState: "Cidade/UF",
      zipCode: "CEP",
      contact: "Contato",
      phone: "Telefone",
      whatsapp: "WhatsApp",
      email: "E-mail",
      noContact: "Nenhum contato público cadastrado.",
      upcomingEventsTitle: "Próximos eventos no clube",
      upcomingEventsSubtitle: "Desafios e torneios marcados neste local.",
      loadingEvents: "Carregando eventos...",
      noUpcomingEvents: "Nenhum próximo evento cadastrado neste clube.",
      dateFallback: "Data a definir",
    },
  },
  openMatches: {
    title: "Partidas",
    subtitle:
      "Encontre vagas abertas, publique sua quadra e organize partidas compatíveis com o perfil dos jogadores.",
    loadError: "Não foi possível carregar as partidas abertas.",
    emptyTitle: "Nenhuma partida aberta encontrada.",
    emptyDescription:
      "Ajuste os filtros ou publique a primeira partida desta região.",
    hero: {
      openCount: "Abertas",
      upcomingCount: "Próximas 7 dias",
      clubCount: "Clubes com partidas",
    },
    actions: {
      create: "Criar partida",
      createLogin: "Entrar para criar",
      viewDetails: "Ver detalhes",
      edit: "Editar",
      openMap: "Abrir no mapa",
      share: "Compartilhar",
      retry: "Tentar novamente",
      clearFilters: "Limpar filtros",
      showFilters: "Abrir filtros",
      hideFilters: "Fechar filtros",
      closeModal: "Fechar",
    },
    filters: {
      searchPlaceholder: "Buscar por clube, cidade ou organizador",
      date: "Data",
      club: "Clube",
      city: "Cidade",
      category: "Categoria",
      gender: "Gênero",
      side: "Lado",
      time: "Horário",
      timeFromShort: "De",
      timeToShort: "Até",
      timeFrom: "Hora inicial a partir de",
      timeTo: "Hora inicial até",
      anyTime: "Qualquer horário",
      allClubs: "Todos os clubes",
      allCities: "Todas as cidades",
      allCategories: "Todas as categorias",
      allGenders: "Todos os gêneros",
      allSides: "Todos os lados",
      availableOnly: "Somente com vagas",
    },
    card: {
      organizer: "Organizador",
      availableSlots: "vagas disponíveis",
      filledSlots: "vagas preenchidas",
      estimatedPerPlayer: "por pessoa",
      priceInfo:
        "O valor por pessoa depende do número de jogadores confirmados. Com reservas, a divisão pode variar até a partida ser confirmada.",
      priceInfoAriaLabel: "Entender valor por pessoa",
      priceRangeSeparator: "a",
      approvalRequired: "Requer aprovação",
      instantEntry: "Entrada direta",
      organizerPlays: "Organizador joga",
      organizerOnly: "Apenas organiza",
      categories: "Categorias",
      side: "Lado",
      gender: "Preferência",
      playersLabel: "jogadores",
      slotsPreview: "Prévia das vagas",
      emptySlot: "Vaga livre",
      pendingSlot: "A confirmar",
      waitingList: "Reservas",
      waitingListOpen: "Reservas disponíveis",
      waitingListClosed: "Sem vaga disponível",
      statusOpen: "Aberta",
      statusFull: "Cheia",
      statusApproval: "Requer aprovação",
      statusCanceled: "Cancelada",
      statusConfirmed: "Confirmada",
      statusFinished: "Finalizada",
    },
    results: {
      title: "Partidas encontradas",
      countSingular: "resultado",
      countPlural: "resultados",
      sortLabel: "Ordenar",
      sortRecent: "Mais recentes",
      sortUpcoming: "Próximas datas",
      sortLowestPrice: "Menor valor",
      sortMostSpots: "Mais vagas",
    },
    detail: {
      notFound: "Partida não encontrada.",
      back: "Voltar para partidas",
      club: "Clube",
      viewClub: "Ver detalhe do clube",
      map: "Mapa",
      sideRequirementAny: "Tanto faz",
      leftSidePlayersNeeded: "esquerda(s)",
      rightSidePlayersNeeded: "direita(s)",
      responsibilityTitle: "Responsabilidade do organizador",
      responsibilityNotice:
        "Esta partida é organizada por um jogador. A reserva da quadra e a cobrança dos participantes não são feitas pelo TNP.",
      payment: "Pagamento",
      details: "Detalhes da partida",
      notes: "Observações",
      description: "Descrição",
      schedule: "Data e horário",
      location: "Local",
      slots: "Vagas",
      categories: "Categorias aceitas",
      duration: "Duração",
      join: "Quero jogar",
      joinCourtAction: "Quero participar",
      joinReserveAction: "Entrar como reserva",
      matchSoldOut: "Partida lotada",
      joinLogin: "Entrar para jogar",
      joinLoading: "Solicitando...",
      joinPending: "Solicitação enviada para o organizador.",
      joinConfirmed: "Participação confirmada.",
      joinWaitlist: "Solicitação enviada.",
      canceledAlertTitle: "Partida cancelada",
      canceledAlertDescription:
        "Esta partida foi cancelada pelo organizador. Os jogadores confirmados foram notificados.",
      joinWaitlistAction: "Quero participar",
      joinError: "Não foi possível solicitar participação.",
      joinCategoryBlocked: "Categoria não permitida.",
      fullNoWaitlist: "Partida cheia.",
      acceptInvite: "Aceitar convite",
      declineInvite: "Recusar convite",
      declineInviteSuccess: "Convite recusado.",
      confirmMatch: "Confirmar partida",
      confirmMatchLoading: "Confirmando...",
      confirmMatchSuccess: "Partida confirmada.",
      confirmMatchError: "Não foi possível confirmar a partida.",
      confirmedMatchNotice: "Partida confirmada pelo organizador.",
      finishedMatchNotice: "O horário desta partida já terminou.",
      confirmMatchBlocked: "Esta partida não pode ser confirmada agora.",
      participantsTitle: "Participantes e solicitações",
      confirmedPlayersTitle: "Jogadores confirmados",
      noConfirmedPlayers: "Nenhum jogador confirmado ainda.",
      courtPlayersTitle: "Jogadores em quadra",
      reservePlayersTitle: "Reservas",
      reservePlayersDescription:
        "Jogadores que participam do rodízio durante a partida.",
      emptyCourtSlot: "Vaga em quadra",
      reserveSlot: "Vaga para reserva",
      noReserveSlots: "Sem reservas configuradas.",
      summaryTitle: "Resumo",
      participantsSummary: "{filled} de {total} participantes",
      onCourtSummary: "{count} em quadra",
      reserveSummary: "{count} reservas",
      courtVacancies: "{count} vagas em quadra",
      reserveVacancies: "{count} vagas para reserva",
      organizerNotice:
        "O organizador cuida da reserva da quadra e da cobrança.",
      organizerPlayer: "Organizador joga",
      manageParticipantsTitle: "Gerenciar participantes",
      noParticipants: "Ainda não há participantes nesta partida.",
      participantFallback: "Participante",
      participantNotRegistered: "Não cadastrado",
      addParticipant: "Adicionar participante",
      addParticipantLoading: "Adicionando...",
      addParticipantSuccess: "Participante adicionado.",
      addParticipantError: "Não foi possível adicionar participante.",
      addParticipantType: "Tipo de participante",
      addParticipantRegistered: "Atleta cadastrado",
      addParticipantExternal: "Participante externo",
      addParticipantPlaceholder: "Vaga preenchida",
      addParticipantName: "Nome do participante",
      addParticipantNamePlaceholder: "Nome de quem vai jogar",
      addParticipantCpf: "CPF",
      addParticipantCpfPlaceholder: "CPF opcional",
      inviteSearch: "Buscar atleta",
      inviteSearchPlaceholder: "Digite nome ou categoria",
      inviteAthlete: "Atleta",
      inviteSelect: "Selecione um atleta",
      inviteNoResults: "Nenhum atleta disponível.",
      invite: "Convidar",
      inviting: "Convidando...",
      inviteSuccess: "Convite enviado.",
      inviteError: "Não foi possível enviar o convite.",
      approveParticipant: "Confirmar",
      waitlistParticipant: "Reserva",
      declineParticipant: "Recusar",
      cancelParticipant: "Remover",
      cancelParticipantSelf: "Cancelar participação",
      cancelParticipantLoading: "Cancelando...",
      cancelParticipantSelfBlocked:
        "Cancelamento disponível até 4 horas antes da partida.",
      cancelParticipantSuccess: "Participação cancelada.",
      cancelParticipantError: "Não foi possível cancelar a participação.",
      reviewSuccess: "Participante atualizado.",
      reviewError: "Não foi possível atualizar o participante.",
      messageBoardTitle: "Conversa",
      noMessages: "Nenhuma mensagem na conversa ainda.",
      messageLabel: "Mensagem",
      messagePlaceholder: "Escreva para os participantes confirmados.",
      messageSend: "Enviar mensagem",
      messageSending: "Enviando...",
      messageError: "Não foi possível enviar a mensagem.",
      messageReadOnly:
        "Esta conversa foi encerrada. As mensagens ficarão disponíveis até {date}.",
      messageNoAccess:
        "A conversa aparece somente para o organizador e jogadores confirmados.",
      messageCharacters: "{count}/{limit}",
      messageRemoved: "Mensagem removida",
      messageRemove: "Remover mensagem",
      messageLoading: "Carregando conversa...",
      messageSystemAuthor: "Sistema",
      organizerBadge: "Organizador",
      participantStatuses: {
        invited: "Convidado",
        pending: "A confirmar",
        confirmed: "Participação confirmada",
        waitlist: "Reserva",
        declined: "Recusado",
        canceled: "Cancelado",
      },
    },
    form: {
      title: "Criar partida",
      subtitle:
        "Publique uma nova partida aberta usando um clube já cadastrado no TNP.",
      editTitle: "Editar partida",
      editSubtitle:
        "Atualize os dados da sua partida diretamente da lista pública.",
      club: "Clube",
      matchTitle: "Nome da partida",
      matchTitlePlaceholder: "Ex.: Racha da Stephany",
      date: "Data",
      startTime: "Início",
      endTime: "Fim",
      duration: "Duração calculada",
      durationPending: "Informe início e fim",
      durationInvalid: "Horário inválido",
      totalPlayers: "Total de jogadores",
      initialParticipants: "Vagas já preenchidas",
      initialParticipantsHint:
        "Preencha atletas já confirmados, convidados externos ou apenas bloqueie uma vaga.",
      editParticipants: "Adicionar jogadores",
      editParticipantsHint:
        "Inclua novas pessoas confirmadas nesta partida sem alterar quem já estava nela.",
      addInitialParticipant: "Adicionar vaga",
      noInitialParticipants: "Nenhuma vaga preenchida inicialmente.",
      participantType: "Tipo de vaga",
      participantRegistered: "Atleta cadastrado",
      participantExternal: "Participante externo",
      participantPlaceholder: "Vaga preenchida sem identificação",
      participantSearch: "Buscar atleta",
      participantSearchPlaceholder: "Digite nome ou categoria",
      participantSelect: "Selecionar atleta",
      participantNoResults: "Nenhum atleta disponível.",
      participantNotRegistered: "Não cadastrado",
      participantAlreadySelected: "Esse atleta já foi adicionado.",
      participantName: "Nome",
      participantCpf: "CPF",
      removeInitialParticipant: "Remover vaga",
      categories: "Categorias aceitas",
      genderPreference: "Preferência de gênero",
      sidePreference: "Preferência de lado",
      leftPlayersCount: "Qtd. esquerdas",
      rightPlayersCount: "Qtd. direitas",
      sidePlayersTotalError:
        "A soma de esquerdas e direitas não pode passar do total de atletas configurado.",
      totalPrice: "Valor total da reserva",
      totalPricePlaceholder: "Opcional",
      totalPriceHint: "Preencha apenas se quiser mostrar uma estimativa de divisão.",
      playerPrice: "Valor por jogador",
      playerPricePlaceholder: "Opcional",
      playerPriceHint:
        "Preencha apenas se cada jogador pagar um valor fixo.",
      priceMode: "Tipo de valor",
      pricePending: "A definir",
      paymentMode: "Forma de pagamento",
      details: "Detalhes da partida",
      detailsPlaceholder:
        "Adicione aqui observações, combinação de pagamento, nível esperado ou qualquer recado útil para os jogadores.",
      paymentInstructions: "Instruções de pagamento",
      description: "Descrição",
      notes: "Observações",
      organizerPlays: "Também vou jogar",
      approvalRequired: "Exigir aprovação para entrar",
      waitlistEnabled: "Permitir reservas",
      responsibility:
        "Confirmo que sou responsável pela reserva da quadra, organização da partida e cobrança dos participantes.",
      selectClub: "Selecione um clube",
      clubSearchPlaceholder: "Digite o nome, cidade ou endereço do clube",
      clubNoResults: "Nenhum clube encontrado.",
      dateRequired: "Selecione uma data para a partida.",
      categoriesHint: "Escolha uma ou mais categorias.",
      submit: "Publicar partida",
      submitting: "Publicando...",
      editSubmit: "Salvar alterações",
      editSubmitting: "Salvando...",
      cancelMatch: "Cancelar partida",
      cancelMatchSubmitting: "Cancelando...",
      cancelMatchConfirm:
        "Tem certeza que deseja cancelar esta partida? Ela deixará de aparecer na lista pública.",
      cancelMatchSuccess: "Partida cancelada.",
      cancelMatchError: "Não foi possível cancelar a partida.",
      success: "Partida publicada com sucesso.",
      editSuccess: "Partida atualizada com sucesso.",
      saveError: "Não foi possível publicar a partida.",
      editError: "Não foi possível atualizar a partida.",
    },
    options: {
      genderAny: "Qualquer gênero",
      genderFemale: "Feminino",
      genderMale: "Masculino",
      genderMixed: "Misto",
      genderPreferFemale: "Preferencialmente feminino",
      genderPreferMale: "Preferencialmente masculino",
      sideAny: "Lado indiferente",
      sideLeft: "Procura esquerda",
      sideRight: "Procura direita",
      sideBoth: "Procura os dois lados",
      sidePreferLeft: "Preferencialmente esquerda",
      sidePreferRight: "Preferencialmente direita",
      paymentOrganizer: "Pagamento ao organizador",
      paymentClub: "Pagamento ao clube",
      paymentOnsite: "Pagamento presencial",
      paymentPix: "Pagamento por Pix",
      paymentCustom: "A combinar",
      paymentFree: "Partida gratuita",
      paymentUndefined: "Valor a definir",
      priceModeCourt: "Por quadra",
      priceModePlayer: "Por jogador",
    },
  },
  profile: {
    user: {
      title: "Perfil do usuário",
      subtitle: "Dados da sua conta.",
      emptyMessage: "Você precisa fazer login para acessar seu perfil.",
      goToLogin: "Ir para login",
      saveError: "Falha ao salvar dados do perfil.",
      completeProfile: "Completar perfil",
      roleLabels: {
        admin: "ADM",
        organizer: "Organizador",
        user: "Jogador",
      },
      unconfirmedEmail: "E-mail não confirmado",
      avatarAriaLabel: "Foto do perfil",
      editAvatarPhoto: "Editar foto",
      saveAvatarCrop: "Salvar recorte",
      avatarSaveSuccess: "Foto de perfil atualizada com sucesso.",
      shareProfile: "Compartilhar perfil",
      stats: {
        runnerUps: "Vice-campeonatos",
        currentCategory: "Categoria atual",
        rankingPosition: "Posição no ranking",
        memberSince: "Membro desde",
      },
      tabs: {
        profile: "Meu perfil",
        security: "Segurança",
        challenges: "Meus eventos",
        registrations: "Minhas inscrições",
      },
      labels: {
        avatar: "Foto de perfil",
        personalInfo: "Informações pessoais",
        name: "Nome",
        email: "E-mail",
        cpf: "CPF",
        phone: "Telefone",
        sex: "Sexo",
        category: "Categoria",
        club: "Clube vinculado",
        noClub: "Sem clube vinculado",
        sidePreference: "Lado preferencial",
      },
      sidePreference: {
        both: "Jogo dos dois lados",
        left: "Prefiro esquerda",
        right: "Prefiro direita",
      },
      cpfInfoAriaLabel: "Por que não posso editar o CPF?",
      cpfInfo:
        "O CPF não pode ser editado pelo usuário porque é um dado sensível. Apenas administradores podem alterar.",
      categoryLocked:
        "Categoria já definida. Para alterar, envie uma solicitação para o time ADM.",
      loadingCategoryRequests: "Carregando solicitações...",
      pendingCategoryRequestPrefix: "Solicitação pendente:",
      pendingCategoryRequestTo: "para",
      requestCategoryChange: "Solicitar troca de categoria",
      noChanges: "Nenhuma alteração para salvar.",
      saveSuccess: "Dados atualizados com sucesso.",
      outdatedServer:
        "Servidor desatualizado. Reinicie o backend (`npm run server`) e tente novamente.",
      cancel: "Cancelar",
      saveChanges: "Salvar alterações",
      saving: "Salvando...",
      notProvided: "Não informado",
      dashboard: {
        stats: {
          matches: "Partidas disputadas",
          playedMatches: "Partidas jogadas",
          titles: "Títulos conquistados",
          runnersUp: "Vice-campeonatos",
          category: "Categoria atual",
          rankingPosition: "Posição no ranking",
          events: "Eventos disputados",
        },
        shareProfile: "Compartilhar perfil",
        eventsTitle: "Meus eventos",
        eventsSubtitle: "Acompanhe sua jornada no TNP.",
        overviewTitle: "Perfil do usuário",
        overviewSubtitle: "Dados da sua conta.",
        personalInfo: "Informações pessoais",
        memberSince: "Membro desde",
        requestReviewHint: "Sua solicitação será analisada pela equipe TNP.",
        requestApprovalHint: "A alteração só será aplicada após aprovação.",
        requestReason: "Motivo da solicitação",
        selectRequestReason: "Selecione o motivo da solicitação",
        observationOptional: "Observação (opcional)",
        observationPlaceholder: "Conte mais detalhes sobre sua solicitação...",
        searchEvent: "Buscar evento",
        filtersAria: "Filtros",
        eventStatusAria: "Status do evento",
        eventTypeAria: "Tipo do evento",
        eventEmpty: "Nenhum evento encontrado.",
        eventFilters: {
          all: "Todos",
          pending: "A iniciar",
          started: "Em andamento",
          finished: "Finalizado",
          tournaments: "Torneios",
          challenge: "Challenge",
          super8: "Super8",
          poco: "Poço",
        },
        categoryReasons: [
          "Evolução técnica",
          "Reclassificação por desempenho",
          "Correção cadastral",
          "Orientação da organização",
          "Outro motivo",
        ],
        requestReasonRequired: "Selecione o motivo da solicitação.",
        pendingRequest:
          "Você já possui uma solicitação de troca de categoria em análise.",
        share: {
          dialogAria: "Compartilhar perfil",
          title: "Compartilhar perfil",
          description: "Arte Story 1080x1920 com sua jornada no TNP.",
          closeAria: "Fechar compartilhamento",
          previewAlt: "Prévia da arte de perfil",
          generating: "Gerando arte...",
          unavailable: "Arte indisponível.",
          share: "Compartilhar",
          downloadPng: "Baixar PNG",
          copyLink: "Copiar link",
          generateError: "Não foi possível gerar a arte do perfil.",
          copied: "Link copiado.",
          copyError: "Não foi possível copiar o link.",
          shareTitle: "Meu perfil TNP",
          directUnavailable:
            "Compartilhamento direto indisponível. A arte foi baixada.",
          journey: "Minha jornada no TNP",
          sportsProfile: "PERFIL ESPORTIVO",
          athleteFallback: "Atleta TNP",
          categoryFallback: "Categoria não informada",
          rankingSuffix: "no ranking",
          rankingProgress: "Ranking em evolução",
          noRankingPosition: "Sem posição",
          noRankingHint: "Ainda sem pontuação",
          rankingPositionLabel: "posição",
          rankingStatusLabel: "status",
        },
      },
      achievements: {
        title: "Conquistas",
        description: "Badges desbloqueados pela sua jornada no TNP.",
        loading: "Carregando conquistas...",
        loadError: "Não foi possível carregar as conquistas.",
        unlockedCountPrefix: "Desbloqueadas",
        unlockedAt: "Conquistada em",
        locked: "Bloqueada",
        types: {
          athlete: "Atleta",
          organizer: "Organizador",
          event: "Evento",
          ranking: "Ranking",
          participation: "Participação",
        },
      },
      notificationPreferences: {
        title: "Preferências de notificações",
        description: "Escolha quais avisos deseja receber dentro do TNP.",
        loading: "Carregando preferências...",
        loadError: "Não foi possível carregar as preferências.",
        saveError: "Não foi possível salvar as preferências.",
        saveSuccess: "Preferências salvas.",
        save: "Salvar preferências",
        saving: "Salvando...",
        options: {
          inApp: "Notificações no site",
          email: "Notificações por e-mail",
          events: "Notificações de eventos",
          ranking: "Notificações de ranking",
          payments: "Notificações de pagamentos",
          achievements: "Notificações de conquistas",
        },
      },
      organizerStatistics: {
        title: "Estatísticas do Organizador",
        description: "Acompanhe o desempenho dos seus eventos no TNP.",
        adminScope: "Todos os organizadores",
        loading: "Carregando estatísticas...",
        loadError: "Não foi possível carregar as estatísticas.",
        emptyValue: "Sem dados",
        emptyChart: "Sem dados para este período.",
        dateFrom: "Data inicial",
        dateTo: "Data final",
        invalidDateRange: "A data final deve ser posterior à data inicial.",
        periods: {
          all: "Sempre",
          current_year: "Ano atual",
          last_30: "Últimos 30 dias",
          last_90: "Últimos 90 dias",
          custom: "Período personalizado",
        },
        chartPeriods: {
          lastMonth: "Último mês",
          lastSixMonths: "Últimos 6 meses",
          lastYear: "Último ano",
          allTime: "Todo o período",
          allPeriods: "Todos os períodos",
        },
        cards: {
          completedEvents: "Eventos realizados",
          futureEvents: "Eventos futuros",
          uniqueAthletes: "Atletas únicos",
          totalRegistrations: "Total de inscrições",
          soldOutEvents: "Eventos lotados",
          estimatedRevenue: "Receita estimada",
          averageAthletes: "Média de atletas por evento",
          popularCategory: "Categoria mais popular",
        },
        byTypeTitle: "Estatísticas por tipo de evento",
        internalRankingTitle: "Ranking interno do organizador",
        eventTypes: {
          challenge: "Challenge",
          super8: "Super8",
          poco: "Poço",
          tournament: "Torneios",
        },
        metrics: {
          completed: "Realizados",
          registrations: "Inscritos",
          average: "Média",
        },
        ranking: {
          mostParticipations: "Atleta com mais participações",
          mostTitles: "Atleta com mais títulos",
          mostRecurring: "Atleta mais recorrente",
          topCategory: "Categoria com mais inscritos",
          topEvent: "Evento com maior número de inscritos",
        },
        charts: {
          registrationsByMonth: "Inscrições por mês",
          revenueByMonth: "Receita estimada por mês",
          eventsByMonth: "Eventos por mês",
          categories: "Categorias mais populares",
        },
        chartDescriptions: {
          registrationsByMonth: "Inscrições confirmadas agrupadas por mês.",
          revenueByMonth:
            "Receita estimada a partir das inscrições confirmadas.",
          eventsByMonth: "Quantidade de eventos realizados em cada mês.",
          categories: "Categorias com maior volume de inscritos.",
        },
        chartMetricLabels: {
          registrationsByMonth: "inscrições por mês",
          revenueByMonth: "receita estimada por mês",
          eventsByMonth: "eventos por mês",
          categories: "inscrições por categoria",
        },
        chartEmptyMessages: {
          insufficientData: "Sem dados suficientes para exibir este gráfico.",
          noData: "Nenhum dado encontrado neste período.",
          noRevenue: "Nenhuma receita confirmada neste período.",
        },
        chartNote:
          "Os dados são atualizados em tempo real conforme novos eventos e inscrições são registrados.",
      },
      organizerRanking: {
        title: "Ranking do Organizador",
        description:
          "Defina a tabela de pontuação usada apenas nos rankings dos seus eventos.",
        info:
          "O Ranking Oficial do TNP sempre utiliza a pontuação oficial da plataforma. Esta configuração altera apenas o ranking próprio deste organizador.",
        scoringMode: "Modo de pontuação",
        modes: {
          tnp_standard: "Padrão TNP",
          duplicate: "Duplicar padrão TNP",
          custom: "Personalizado",
        },
        modeDescriptions: {
          tnp_standard: "Usa a pontuação oficial, sem edição.",
          custom: "Permite editar a pontuação dos seus eventos.",
        },
        modalities: {
          super8: "Super 8",
          challenge: "Challenge",
          poco: "Poço",
          tournament: "Torneios",
        },
        fields: {
          first: "1º Lugar",
          second: "2º Lugar",
          third: "3º Lugar",
          fourth: "4º Lugar",
          fifth: "5º Lugar",
          sixth: "6º Lugar",
          seventh: "7º Lugar",
          eighth: "8º Lugar",
          participation: "Participação",
          champion: "Campeão",
          runnerUp: "Vice",
          semifinal: "Semifinal",
          quarterfinal: "Quartas",
        },
        loading: "Carregando pontuação...",
        save: "Salvar pontuação",
        saving: "Salvando...",
        restoreDefault: "Restaurar padrão TNP",
        restoreConfirm:
          "Deseja restaurar o modo Padrão TNP? Sua pontuação personalizada deixará de ser usada.",
        duplicateOfficial: "Duplicar pontuação oficial do TNP",
        duplicateAgain: "Duplicar novamente do TNP",
        duplicatedNotice:
          "Esta tabela foi criada a partir da pontuação oficial do TNP. Agora ela pode ser alterada sem afetar o Ranking Oficial.",
        replaceConfirm:
          "Deseja substituir sua pontuação atual pela pontuação oficial do TNP?",
        validationError: "Informe uma pontuação válida.",
        loadError: "Não foi possível carregar a pontuação do organizador.",
        saveError: "Não foi possível salvar a pontuação do organizador.",
        saveSuccess: "Pontuação do organizador salva.",
        resetSuccess: "Pontuação restaurada para o padrão TNP.",
      },
      visualIdentity: {
        title: "Identidade Visual",
        description:
          "Personalize as cores usadas nos materiais dos seus eventos.",
        info:
          "As configurações desta seção serão utilizadas apenas nos eventos organizados por você. O restante da plataforma continuará utilizando a identidade oficial do TNP.",
        logoTitle: "Logo do organizador",
        publicName: "Nome público do organizador",
        publicNamePlaceholder: "Nome exibido na vitrine",
        logoDescription:
          "Use uma imagem em PNG, JPG, JPEG ou WEBP com até 2MB.",
        logoHelp:
          "A logo fica salva no seu perfil e pode ser reutilizada nos eventos organizados por você.",
        logoPreviewAlt: "Preview da logo do organizador",
        uploadLogo: "Enviar logo",
        replaceLogo: "Trocar logo",
        removeLogo: "Remover logo",
        invalidLogo: "Envie uma imagem PNG, JPG, JPEG ou WEBP válida.",
        logoTooLarge: "A logo deve ter no máximo 2MB.",
        logoInvalidDimensions:
          "A logo deve ter entre 64 e 4096 pixels de largura e altura.",
        mode: "Modo de identidade",
        backgroundNotice:
          "Escolha o fundo usado nas telas públicas dos seus eventos.",
        backgroundTitle: "Fundo das telas",
        backgrounds: {
          blue: "Azul (padrão)",
          black: "Preto",
          white: "Branco",
        },
        modes: {
          tnp_standard: "Padrão TNP",
          custom: "Personalizado",
        },
        modeDescriptions: {
          tnp_standard:
            "Usa as cores oficiais do TNP nos materiais dos seus eventos.",
          custom:
            "Permite escolher suas próprias cores para materiais e telas vinculadas aos seus eventos.",
        },
        fields: {
          primaryColor: "Cor Primária",
          secondaryColor: "Cor Secundária",
          accentColor: "Cor de Destaque",
        },
        usage: {
          primaryColor:
            "Usada em botões, links, títulos, ícones principais e barras de progresso.",
          secondaryColor:
            "Usada em gradientes, cards, botões secundários e badges.",
          accentColor:
            "Usada em campeão, cronômetro, alertas, últimas vagas, destaques visuais e glow.",
        },
        previewTitle: "Preview da identidade visual",
        previewRanking: "Ranking do Organizador",
        previewShare: "Compartilhar Ranking",
        previewPlayers: ["João Silva", "Maria Souza", "Pedro Lima"],
        hexPlaceholder: "#2B9CDF",
        loading: "Carregando identidade visual...",
        save: "Salvar identidade",
        saving: "Salvando...",
        restoreDefault: "Restaurar padrão TNP",
        validationError: "Informe cores HEX válidas no formato #2B9CDF.",
        contrastWarning:
          "Essa combinação pode dificultar a leitura. Recomendamos utilizar cores com maior contraste.",
        loadError: "Não foi possível carregar a identidade visual.",
        saveError: "Não foi possível salvar a identidade visual.",
        saveSuccess: "Identidade visual salva.",
        resetSuccess: "Identidade visual restaurada para o padrão TNP.",
      },
      categoryRequest: {
        title: "Solicitar troca de categoria",
        newCategory: "Nova categoria desejada",
        selectCategory: "Selecione uma categoria",
        reason: "Motivo (opcional)",
        reasonLabel: "Motivo da solicitação",
        reasonSelectPlaceholder: "Selecione o motivo da solicitação",
        reasonSelectShortPlaceholder: "Selecione o motivo",
        observation: "Observação (opcional)",
        observationPlaceholder: "Conte mais detalhes sobre sua solicitação...",
        modalObservationPlaceholder:
          "Digite uma observação para ajudar na análise.",
        reviewHint: "Sua solicitação será analisada pela equipe TNP.",
        approvalHint: "A alteração só será aplicada após aprovação.",
        currentUserCategory: "Categoria atual do usuário",
        reasonPlaceholder: "Explique rapidamente o motivo da troca.",
        observationPrefix: "Observação:",
        sending: "Enviando...",
        submit: "Enviar solicitação",
        categoryRequired: "Selecione a categoria desejada.",
        differentCategory:
          "A categoria solicitada deve ser diferente da atual.",
        success: "Solicitação enviada para análise dos administradores.",
        error: "Não foi possível enviar a solicitação.",
        historyEyebrow: "Histórico",
        historyTitle: "Histórico de solicitações",
        historyEmpty: "Nenhuma solicitação de troca de categoria registrada.",
        historyTo: "para",
        requestedAt: "Solicitada em",
        resolvedAt: "Respondida em",
        adminResponse: "Resposta do administrador",
        noAdminResponse: "A solicitação foi recusada sem mensagem adicional.",
        statuses: {
          pending: "Pendente",
          approved: "Aceita",
          rejected: "Recusada",
        },
      },
      security: {
        description: "Troca de senha e configurações de acesso.",
        emailTitle: "E-mail de acesso",
        pendingEmailPrefix: "E-mail pendente de confirmação:",
        generatingLink: "Reenviando...",
        confirmEmail: "Reenviar e-mail de confirmação",
        updateEmail: "Atualizar e-mail",
        emailSaving: "Salvando...",
        emailUpdated: "E-mail atualizado.",
        emailUpdateError: "Não foi possível atualizar o e-mail.",
        emailRequestRegisteredPrefix:
          "Solicitação registrada. Enviamos um e-mail de confirmação para:",
        confirmationLinkSuccess: "E-mail de confirmação reenviado.",
        confirmationLinkError:
          "Não foi possível reenviar o e-mail de confirmação.",
        passwordTitle: "Alterar senha",
        currentPassword: "Senha atual",
        newPassword: "Nova senha",
        confirmNewPassword: "Confirmar nova senha",
        passwordUpdating: "Atualizando senha...",
        updatePassword: "Atualizar senha",
        passwordRequired: "Informe a senha atual e a nova senha.",
        passwordMinLength: "A nova senha deve ter ao menos 4 caracteres.",
        passwordMismatch: "A confirmação da nova senha não confere.",
        passwordUpdated: "Senha alterada com sucesso.",
        passwordUpdateError: "Não foi possível alterar a senha.",
      },
      challenges: {
        matchesSuffix: "partidas",
        viewDetails: "Ver detalhes",
        openMap: "Abrir localização no mapa",
        copyLocation: "Copiar endereço",
        locationCopied: "Endereço copiado.",
        copyLocationError: "Não foi possível copiar o endereço.",
        empty: "Nenhum desafio nesta seção.",
        paginationAria: "Paginação de eventos",
        previousPage: "Página anterior",
      },
    },
    myGames: {
      title: "Jogos de torneios e desafios",
      subtitle:
        "Acompanhe seus jogos de torneios e desafios, horários, quadras e resultados.",
      empty: "Nenhum jogo encontrado.",
      loadError: "Não foi possível carregar seus jogos.",
      modalSubtitle: "Jogos liberados para esta inscrição.",
      closeModal: "Fechar jogos",
      upcomingTitle: "Próximos jogos",
      confirmedOpenMatchesTitle: "Partidas abertas confirmadas",
      historyTitle: "Histórico e resultados",
      noUpcoming: "Você não possui próximos jogos agendados.",
      noConfirmedOpenMatches:
        "Nenhuma partida aberta confirmada pelo organizador.",
      openMatchConfirmed: "Participação confirmada pelo organizador",
      noHistory: "Nenhum resultado publicado ainda.",
      categoryFallback: "Categoria",
      courtFallback: "Quadra a definir",
      viewTournament: "Ver torneio",
      scorePending: "Resultado pendente",
      unscheduled: "Horário a definir",
      result: {
        win: "Vitória",
        loss: "Derrota",
        finished: "Finalizado",
        pending: "Pendente",
      },
    },
    openMatches: {
      title: "Partidas abertas",
      subtitle:
        "Gerencie partidas que você criou e acompanhe seus convites e solicitações.",
      empty: "Nenhuma partida aberta encontrada.",
      emptyHint:
        "Quando você criar uma partida ou participar de uma, ela aparecerá aqui.",
      loadError: "Não foi possível carregar suas partidas abertas.",
      groupEmpty: "Nenhuma partida nesta seção.",
      view: "Ver partida",
      edit: "Editar",
      updateSuccess: "Partida atualizada.",
      clubFallback: "Clube a definir",
      slotsSuffix: "vagas disponíveis",
      requestsTitle: "Solicitações e convites",
      groups: {
        created: "Criadas por mim",
        confirmed: "Confirmadas",
        invites: "Convites",
        pending: "Solicitações pendentes",
        waitlist: "Reservas",
        history: "Histórico",
        canceled: "Canceladas",
      },
    },
    registrations: {
      title: "Minhas inscrições",
      subtitle: "Acompanhe o status das suas inscrições nos eventos.",
      filters: {
        all: "Todas",
        confirmed: "Confirmadas",
        pending: "Pendentes",
        waitlist: "Lista de espera",
        canceled: "Canceladas",
        overdue: "Vencidas",
      },
      statuses: {
        confirmed: "Confirmada",
        pending: "Pendente",
        waitlist: "Lista de espera",
        canceled: "Cancelada",
        overdue: "Vencida",
      },
      hints: {
        confirmedDefault: "Pagamento confirmado",
        confirmedAtPrefix: "Pago em",
        waitlistDefault: "Aguardando abertura de vaga",
        waitlistPaid: "Pagamento confirmado, aguardando vaga",
        overdueDefault: "Cobrança vencida",
        overdueAtPrefix: "Vencida em",
        canceledDefault: "Inscrição cancelada",
        canceledAtPrefix: "Cancelada em",
        pendingPairPrefix: "Aguardando pagamento da dupla",
        pendingDefault: "Aguardando confirmação de pagamento",
      },
      mode: {
        individual: "Individual",
        fixedPair: "Dupla",
      },
      actions: {
        payNow: "Pagar agora",
        viewGames: "Ver jogos",
        viewDetails: "Ver detalhes",
        cancel: "Cancelar inscrição",
        remove: "Excluir inscrição",
        canceling: "Cancelando...",
        removing: "Removendo...",
      },
      filtersAriaLabel: "Filtro das inscrições",
      toasts: {
        cancelSuccess: "Inscrição cancelada.",
        cancelError: "Não foi possível cancelar a inscrição.",
        deleteSuccess: "Inscrição removida da sua lista.",
        deleteError: "Não foi possível remover a inscrição.",
      },
      teammatePrefix: "Você e",
      empty: "Nenhuma inscrição encontrada.",
      emptyByFilter: "Nenhuma inscrição para este filtro.",
    },
    admin: {
      title: "Perfil administrativo",
      subtitle: "Resumo de acesso e atalho para o painel.",
      forbiddenMessage: "Somente administradores podem acessar esta página.",
      openAdmin: "Abrir painel admin",
      labels: {
        administrator: "Administrador",
        email: "E-mail",
        totalUsers: "Usuários cadastrados",
      },
    },
  },
  about: {
    subtitle: "Conheça a história e o propósito da TNP.",
    storyAriaLabel: "História da TNP",
    featuresAriaLabel: "Pilares da TNP",
    alt: {
      team: "Stephany e Raphael no padel",
    },
    captions: {
      team: "Stephany e Raphael - TNP",
    },
    storyTitles: [
      "Paixão que conecta",
      "Comunidade ativa",
      "Experiências únicas",
      "Evolução e crescimento",
      "Padel para todos",
    ],
    featureCards: [
      { title: "Desafios recorrentes", text: "com rankings atualizados" },
      { title: "Eventos presenciais", text: "e torneios especiais" },
      { title: "Comunidade ativa", text: "para evoluir no padel" },
      { title: "Experiências selecionadas", text: "para a comunidade" },
    ],
  },
  home: {
    hero: {
      title: "Todos no Padel",
      subtitle:
        "Conectamos a comunidade, criamos desafios e valorizamos os eventos que fazem o padel crescer.",
      ctaLabel: "Ver próximos eventos",
      ctaLink: "#/desafios",
    },
    summary:
      "Somos uma equipe apaixonada por padel que organiza eventos e experiências para a comunidade.",
    heroKicker: "Comunidade • Eventos • Performance",
    heroFallbackCta: "Ver desafios",
    loadingContent: "Carregando conteúdo...",
    aboutFallbackTitle: "Sobre o TNP",
    aboutParagraphs: [
      "A TNP - Todos no Padel nasceu da paixão pelo esporte e pela vontade de levar essa energia para mais pessoas. Mais do que jogar, acreditamos no poder do padel de conectar, desafiar e transformar dentro e fora das quadras.",
      "Criamos a TNP com o propósito de formar uma comunidade ativa, acolhedora e competitiva, onde jogadores de diferentes níveis possam evoluir, se desafiar e se divertir.",
      "Promovemos experiências através dos nossos formatos de eventos, como Challenge, Super 8, Poço e Torneios, pensados para incentivar integração, espírito esportivo e evolução constante.",
      "Nosso objetivo vai além dos eventos: queremos disseminar o padel, impulsionar o crescimento do esporte e ajudar cada jogador a atingir seu próximo nível.",
      "Acreditamos que o padel é para todos. E o nosso convite é simples: venha fazer parte dessa comunidade.",
    ],
    aboutFallbackItems: [
      "Desafios recorrentes com rankings atualizados",
      "Eventos presenciais e torneios especiais",
      "Experiências selecionadas para a comunidade",
      "Comunidade ativa para evoluir no padel",
    ],
    events: {
      title: "Próximos eventos",
      subtitle: "Torneios, etapas especiais e encontros da comunidade.",
      empty: "Nenhum evento cadastrado no momento.",
      fallbackTag: "Evento",
      fallbackAddress: "Local a definir",
      navAria: "Navegação de eventos",
      moveLeft: "Mover eventos para a esquerda",
      moveRight: "Mover eventos para a direita",
    },
    clubs: {
      title: "Clubes próximos",
      subtitle:
        "Encontre clubes para jogar, reservar quadra e acompanhar a comunidade perto de você.",
      nearbyTag: "Clube",
      fallbackAddress: "Endereço a definir",
      viewMore: "Ver mais clubes",
      viewAll: "Ver todos os clubes",
    },
  },
  challenges: {
    modes: {
      super8: {
        title: "Super8",
        description: "Painel de gerenciamento do formato Super8.",
      },
      challenge: {
        title: "Challenge",
        description:
          "Painel de gerenciamento do Challenge (estrutura atual no backend: Super12).",
      },
      poco: {
        title: "Poço",
        description: "Painel de gerenciamento do formato Poço.",
      },
      tournament: {
        title: "Torneio",
      },
    },
    hub: {
      title: "Desafios",
      subtitle:
        "Escolha desafios oficiais do TNP ou desafios de organizadores.",
      officialCard: {
        title: "Desafios Oficiais TNP",
        description:
          "Visualize os desafios oficiais publicados pelo circuito TNP.",
        cta: "Ver Desafios",
        stats: {
          challenges: "Desafios",
          season: "Temporada",
          pending: "A iniciar",
        },
      },
      organizersCard: {
        title: "Desafios de Organizadores",
        description: "Explore os desafios dos organizadores parceiros.",
        cta: "Explorar Organizadores",
        stats: {
          organizers: "Organizadores",
          publishedChallenges: "Desafios publicados",
          inProgress: "A iniciar",
        },
      },
    },
    organizersDirectory: {
      title: "Selecionar Organizador",
      subtitle:
        "Escolha um organizador para abrir os desafios correspondentes.",
      loading: "Carregando organizadores...",
      loadError: "Não foi possível carregar os organizadores.",
      loadMoreError: "Não foi possível carregar mais organizadores.",
      empty: "Nenhum organizador cadastrado.",
      searchPlaceholder: "Digite o nome do organizador",
      searchAriaLabel: "Buscar organizador por nome",
      searchButtonAriaLabel: "Buscar organizador",
      loadMore: "Carregar mais",
      loadingMore: "Carregando...",
      sortLabel: "Ordenar por",
      sortOptions: {
        name: "Nome A-Z",
        athletes: "Mais atletas",
        challenges: "Mais desafios",
        updated: "Atualizados recentemente",
      },
      selectedTitle: "Selecione um Organizador",
      selectedSubtitle:
        "Escolha um organizador para visualizar os desafios disponíveis.",
      searchExpandedPlaceholder: "Buscar organizador, clube ou arena...",
      featuredTitle: "Mais acessados",
      allTitle: "Todos os organizadores",
      emptySearch: "Nenhum organizador encontrado.",
      official: "Oficial",
      athletes: "atletas",
      challenges: "desafios",
      viewChallenges: "Ver desafios",
      viewChallengesAriaPrefix: "Ver desafios de",
      openChallengesAriaPrefix: "Abrir desafios de",
      updatedToday: "Atualizado hoje",
      updatedAtPrefix: "Atualizado em",
      helpTitle: "Gostaria de organizar seu campeonato?",
      helpText: "Entre em contato conosco através do email:",
      stats: {
        finished: "finalizados",
        pending: "a iniciar",
      },
    },
    publicList: {
      title: "Desafios",
      subtitle: "Encontre e participe dos melhores desafios de padel.",
      subtitleTournament:
        "Encontre e participe dos próximos torneios de padel.",
      searchPlaceholder: "Buscar por nome do desafio ou organizador...",
      searchPlaceholderOfficial: "Buscar por nome do desafio...",
      searchPlaceholderTournament:
        "Buscar por nome do torneio...",
      searchAriaLabel: "Buscar desafios",
      filtersAriaLabel: "Filtros",
      filterGroups: {
        searchDate: "Busca e data",
        general: "Geral",
        source: "Origem",
        status: "Status",
        type: "Tipo",
      },
      titles: {
        organizers: "Desafios Organizadores",
        organizerPrefix: "Desafios",
        organizerIdPrefix: "Desafios Organizador #",
        tournaments: "Torneios",
        tnpTournaments: "Torneios TNP",
        organizerTournaments: "Torneios dos Organizadores",
      },
      filters: {
        all: "Todos",
        officialTnp: "TNP Oficial",
        organizers: "Organizadores",
        organizer: "Organizador",
        city: "Cidade",
        club: "Clube/Local",
        category: "Categoria",
        date: "Data",
        sort: "Ordenar",
        mostRecent: "Mais recentes",
        nearest: "Mais proximos",
        mostRegistered: "Mais inscritos",
        pending: "A iniciar",
        started: "Em andamento",
        finished: "Finalizado",
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Poço",
        tournament: "Torneio",
      },
      labels: {
        organizerPrefix: "",
        locationFallback: "Local a definir",
        organizerFallback: "Organização TNP",
        registeredSuffix: "inscritos",
        registrations: "Inscrições",
        details: "Ver detalhes",
        officialTnp: "TNP Oficial",
        viewAll: "Ver todos",
        priceFallback: "Valor a definir",
        moreCategories: "categorias",
        filledSlots: "vagas preenchidas",
        emptyTournaments: "Nenhum torneio encontrado.",
        partnerTournamentNoOfficialRanking:
          "Este torneio é organizado por um parceiro e não pontua no Ranking Oficial TNP.",
        organizerRankingOnly:
          "Este torneio pontua apenas no ranking do organizador.",
        empty: "Nenhum desafio nesta seção.",
        emptyTournament: "Nenhum torneio nesta seção.",
        groupPrefix: "Grupo",
        count: "Mostrando",
        countFromTo: "a",
        countOf: "de",
        countItems: "desafios",
        countTournaments: "torneios",
        rankingIncluded: "Conta no ranking",
        organizersEmpty:
          "Ainda não existem desafios de organizadores cadastrados.",
        loadErrorFallback: "Não foi possível carregar os desafios.",
        organizerByIdPrefix: "Organizador #",
      },
      summaryCards: {
        upcomingChallenges: "Próximos desafios",
        upcomingChallengesHint: "A iniciar nos próximos 7 dias",
        availableSlots: "Vagas disponíveis",
        availableSlotsHint: "Em todos os desafios abertos",
        finishedChallenges: "Desafios finalizados",
        finishedChallengesHint: "Concluídos no período",
        totalAthletes: "Total de atletas",
        totalAthletesHint: "Participando dos desafios",
        activeTournaments: "Torneios ativos",
        activeTournamentsHint: "Inscrições abertas",
        upcomingTournaments: "Próximos torneios",
        upcomingTournamentsHint: "Próximos 30 dias",
        registeredAthletes: "Atletas inscritos",
        registeredAthletesHint: "Em todos os torneios",
        openCategories: "Categorias abertas",
        openCategoriesHint: "Categorias disponíveis",
      },
      tournamentSections: {
        officialTitle: "Torneios Oficiais TNP",
        officialSubtitle: "Eventos organizados pelo circuito TNP.",
        organizersTitle: "Torneios de Organizadores",
        organizersSubtitle: "Eventos organizados por nossos parceiros.",
      },
      paging: {
        prevAria: "Página anterior",
        nextAria: "Próxima página",
      },
    },
    publicDetail: {
      shareAction: "Compartilhar",
      winnerShare: {
        athleteFallback: "Atleta TNP",
        final: "FINAL",
        female: {
          title: "CAMPEÃS",
          championBadge: "DUPLA CAMPEÃ",
          championSideTitle: "CAMPEÃS",
          runnerTitle: "VICE-CAMPEÃS",
        },
        male: {
          title: "CAMPEÕES",
          championBadge: "DUPLA CAMPEÃ",
          championSideTitle: "CAMPEÕES",
          runnerTitle: "VICE-CAMPEÕES",
        },
        mixed: {
          title: "DUPLA CAMPEÃ",
          championBadge: "CAMPEÕES DO MISTO",
          championSideTitle: "CAMPEÕES",
          runnerTitle: "DUPLA VICE-CAMPEÃ",
        },
        neutral: {
          title: "DUPLA CAMPEÃ",
          championBadge: "DUPLA CAMPEÃ",
          championSideTitle: "CAMPEÃ",
          runnerTitle: "VICE-CAMPEÃ",
        },
      },
      tournamentProgress: {
        statuses: {
          finished: "Finalizado",
          inProgress: "Em quadra",
          scheduled: "Agendado",
          pending: "Pendente",
        },
        categoryFallback: "Categoria",
        group: "Grupo",
        qualifying: "Classificatório",
        roundOf32: "16 avos de final",
        roundOf16: "Oitavas de final",
        quarterfinal: "Quartas de final",
        semifinal: "Semifinal",
        final: "Final",
        knockout: "Mata-mata",
        startedPrefix: "Iniciado há",
        startedSuffix: "",
        lessThanMinute: "menos de 1 min",
        courtFallback: "Quadra a definir",
        imageError: "Não foi possível gerar a imagem.",
        tournamentFallback: "Torneio TNP",
        dateFallback: "Data a definir",
        timeFallback: "Horário a definir",
        groupStage: "Fase de grupos",
        noMatchInBracket: "Nenhum confronto gerado para esta chave.",
        bracketsTitle: "Chaves",
        timelineTitle: "Timeline do torneio",
        bracketsDescription:
          "Acompanhe os confrontos, vencedores e próximos jogos por categoria.",
        timelineDescription:
          "Veja a ordem dos jogos, horários, quadras e status em tempo real.",
        loading: "Carregando torneio...",
        unpublishedTitle: "Chave ainda não publicada",
        unpublishedText:
          "A chave aparecerá aqui quando a organização gerar os confrontos.",
        championPair: "Dupla campeã",
        finalPrefix: "Final:",
        generatingArtwork: "Gerando arte...",
        shareResult: "Compartilhar resultado",
        category: "Categoria",
        allCategories: "Todas as categorias",
        court: "Quadra",
        allCourts: "Todas as quadras",
        previousDayAria: "Dia anterior",
        nextDayAria: "Próximo dia",
        noGames: "Nenhum jogo encontrado",
        timelineUnavailable: "Timeline ainda não gerada",
        filterHelp:
          "Ajuste os filtros de categoria, quadra ou data para ver os jogos agendados.",
        timelineHelp:
          "A agenda aparecerá aqui quando os jogos forem agendados.",
        previewDialogAria: "Prévia do resultado",
        previewDescription: "Prévia da arte em formato Story 1080x1920.",
        closePreviewAria: "Fechar prévia",
        previewAlt: "Prévia do resultado final",
        share: "Compartilhar",
        downloadPng: "Baixar PNG",
        shareTitle: "Resultado TNP",
        winnerText: "venceu",
      },
      statuses: {
        pending: "A iniciar",
        started: "Em andamento",
        finished: "Finalizado",
        canceled: "Cancelado",
        undefined: "A iniciar",
      },
      actions: {
        retry: "Tentar novamente",
        back: "Voltar",
      },
      labels: {
        organizerPrefix: "",
        locationFallback: "Local a definir",
        playerFallback: "Jogador",
        pendingPair: "Dupla pendente",
        removedPair: "Resultado pendente",
        toBeDefined: "A definir",
        challengeFallback: "Desafio",
        categoryFallback: "Categoria",
        categoryFilterAria: "Filtrar inscritos por categoria",
        format: "Formato",
        groupStage: "Fase de grupos",
        knockoutStage: "Mata-mata",
        moreInformation: "Mais informações",
      },
      tabs: {
        ariaLabel: "Seções do desafio",
        registrations: "Inscritos",
        matches: "Jogos",
        ranking: "Classificação",
        brackets: "Chaves",
        eventSchedule: "Cronograma",
        timeline: "Timeline",
      },
      eventSchedule: {
        title: "Cronograma do torneio",
        summaryTitle: "Resumo do dia",
        dayTime: "Horário do dia",
        activities: "Atividades",
        gamesActivities: "Atividades de jogos",
        courts: "Quadras e locais",
        legend: "Legenda",
        now: "Agora",
        next: "Próxima atividade",
        noLocation: "Local a definir",
        noTime: "Horário a definir",
        timeSeparator: "às",
        activityTypes: {
          games: "Jogos",
          opening: "Abertura",
          checkin: "Credenciamento",
          food: "Alimentação",
          coffee: "Café",
          cake: "Bolo",
          exercise: "Exercício",
          draw: "Sorteio",
          awards: "Premiação",
          celebration: "Confraternização",
          break: "Intervalo",
          general: "Atividade geral",
          other: "Outro",
        },
      },
      states: {
        loadErrorFallback: "Não foi possível carregar este desafio agora.",
        notFound: "Desafio não encontrado.",
        canceledAlert:
          "Este desafio foi cancelado. As inscrições e jogos foram interrompidos.",
        noRegistrations: "Ainda não há inscritos.",
        noRegistrationsText: "Seja o primeiro a garantir sua vaga.",
        noMatchesGeneratedTitle: "Jogos ainda não gerados",
        noMatchesGeneratedText:
          "As rodadas serão exibidas aqui assim que o desafio começar.",
        noMatchesTitle: "Sem jogos registrados",
        noMatchesText: "Os confrontos aparecerão aqui quando forem gerados.",
        noRankingTitle: "Classificação ainda indisponível",
        noRankingText:
          "A classificação será calculada automaticamente após o início dos jogos.",
        noRankingResultsTitle: "Aguardando resultados",
        noRankingResultsText:
          "Assim que os jogos forem concluídos, a tabela aparecerá aqui.",
      },
      cta: {
        pendingTitle: "O desafio ainda não começou",
        pendingTextSingle: "Garanta sua vaga e prepare-se!",
        pendingTextFixedPair: "Garanta a vaga da sua dupla e prepare-se!",
        registrationClosedTitle: "Inscrições encerradas",
        registrationClosedText: "",
        registrationClosedButton: "Inscrições encerradas",
        registrationClosedFooter:
          "Acompanhe as categorias, chaves e próximos jogos nesta página.",
        eventUnavailable: "Evento ainda não disponível",
        eventUnavailableFooter: "Aguardando vínculo do evento para inscrição.",
        registrationStartedTitleSingle: "Você já iniciou sua inscrição",
        registrationStartedTitleFixedPair:
          "Você já iniciou a inscrição da sua dupla",
        registrationStartedText:
          "Acesse sua área para acompanhar pagamento e status.",
        viewMyRegistration: "Ver minha inscrição",
        followRegistration: "Acompanhar inscrição",
        waitlistMe: "Você está na lista de espera.",
        mobileRegister: "Inscrever-me",
        goToEventSingle: "Ir para o evento e me inscrever",
        goToEventFixedPair: "Ir para o evento e inscrever minha dupla",
        soldOutTitle: "Torneio lotado",
        soldOutText: "No momento não há novas vagas disponíveis.",
        soldOutButton: "Vagas esgotadas",
        soldOutFooter: "Acompanhe esta página para novas atualizações.",
        waitlistTextSingle: "Você ainda pode entrar na lista de espera.",
        waitlistTextFixedPair:
          "Você ainda pode entrar na lista de espera com sua dupla.",
        waitlistButtonSingle: "Entrar na lista de espera",
        waitlistButtonFixedPair: "Entrar na lista de espera em dupla",
        waitlistFooter: "Sem vagas imediatas.",
        availableSlotsPrefix: "Vagas disponíveis:",
        registerAnotherCategory: "Inscrever em outra categoria",
        bracketsGeneratedTitle: "Chaves geradas",
        bracketsGeneratedText:
          "As inscrições foram organizadas e os confrontos já estão disponíveis.",
        bracketsGeneratedButton: "Ver chaves",
        bracketsGeneratedFooter:
          "Acompanhe os jogos e a evolução por categoria.",
        finishedTitle: "Evento encerrado",
        finishedText:
          "As inscrições foram finalizadas e este evento já terminou.",
        finishedFooter: "Confira os inscritos, jogos e classificação abaixo.",
      },
      registration: {
        title: "Inscritos",
        introSingle: "Veja a lista de jogadores já inscritos no desafio.",
        introFixedPair: "Veja a lista de duplas já inscritas no desafio.",
        showAll: "Ver todos os inscritos",
        showLess: "Mostrar menos",
        myRegistrationPrefix: "Minha inscrição",
        paymentPrefix: "Pagamento",
        openPayment: "Abrir pagamento",
        table: {
          position: "Posição",
          player: "Jogador",
          pair: "Dupla",
          registeredAt: "Inscrito em",
          status: "Status",
        },
        statuses: {
          confirmed: "Confirmado",
          pendingPayment: "Pendente",
          waitlist: "Lista de espera",
          canceled: "Cancelado",
          refunded: "Estornado",
          pending: "Pendente",
        },
      },
      matches: {
        title: "Jogos",
        round: "Rodada",
        group: "Grupo",
        final: "Final",
        matchResultAria: "Resultado da partida",
        champion: "Campeã",
        loser: "Perdedora",
        awaitingResult: "Aguardando resultado",
        pointsSuffix: "pts",
        status: {
          finished: "Finalizado",
          partial: "Parcial",
          waiting: "Aguardando",
        },
      },
      myGames: {
        title: "Meus jogos",
        description: "Veja todos os jogos que você irá disputar neste evento.",
        closeAria: "Fechar Meus jogos",
        category: "Categoria",
        yourPair: "Sua dupla",
        nextGame: "Próximo jogo",
        gamePrefix: "Jogo",
        loading: "Carregando seus jogos...",
        loadError: "Não foi possível carregar seus jogos.",
        retry: "Tente abrir novamente em instantes.",
        tournamentEmpty: "Os jogos ainda não foram definidos.",
        challengeEmpty:
          "Você está inscrito, mas os horários ainda não foram definidos.",
        emptyHelp:
          "Assim que a organização publicar os confrontos, eles aparecerão aqui.",
        roundOf32: "16 avos de final",
        roundOf16: "Oitavas de final",
        quarterfinal: "Quartas de final",
        semifinal: "Semifinal",
        final: "Final",
        roundPrefix: "Rodada",
        gameFallback: "Jogo",
        courtFallback: "Quadra a definir",
        courtPrefix: "Quadra",
        dateFallback: "Data a definir",
        timeFallback: "Horário a definir",
        waiting: "Aguardando",
        inProgress: "Em andamento",
        finished: "Finalizado",
      },
      shareModal: {
        title: "Compartilhar campeonato",
        description:
          "Mostre este campeonato para mais jogadores e aumente as inscrições.",
        closeAria: "Fechar compartilhamento",
        dialogAria: "Compartilhar campeonato",
        previewAlt: "Prévia da arte do campeonato",
        generating: "Gerando imagem...",
        unavailable: "Imagem indisponível.",
        copyLink: "Copiar link",
        copy: "Copiar",
        share: "Compartilhar",
        downloadPng: "Baixar PNG",
        linkLabel: "Link do campeonato",
        copied: "Link copiado.",
        copyError: "Não foi possível copiar o link.",
        generateError: "Não foi possível gerar a imagem.",
        instagramHint:
          "Link copiado. Para Instagram ou Stories, baixe a imagem e publique pelo app.",
        athleteFallback: "Atleta TNP",
        categoryFallback: "Categoria definida",
        participating: "Estou participando",
        titleGoal: "E vou em busca do título!",
        alongsidePrefix: "Ao lado de",
        championship: "CAMPEONATO",
        date: "Data",
        location: "Local",
        availableSuffix: "disponíveis",
        perPlayerSuffix: "por jogador",
        playToo: "Vem jogar também!",
        secureSpot: "Garanta sua vaga e faça parte desse desafio!",
        tnpChampionship: "CAMPEONATO TNP",
        dateTime: "DATA E HORÁRIO",
        organization: "Organização",
        totalSlots: "Total de vagas",
        availableSlots: "Vagas disponíveis",
        valuePerPlayer: "Valor por jogador",
        category: "Categoria",
        pairCta: "Garanta a vaga da sua dupla e prepare-se!",
      },
      canvasUnavailable: "Canvas indisponível.",
      ranking: {
        title: "Classificação",
        shareResults: "Compartilhar resultados",
        shareOk: "Link compartilhado.",
        copyOk: "Link copiado para a área de transferência.",
        shareError: "Não foi possível compartilhar agora.",
        ariaLabel: "Classificação do desafio",
        rankHeader: "Pos",
        titleHeaderPlayer: "Jogador",
        titleHeaderPair: "Dupla",
        columns: {
          total: "Total",
          roundShort: "R",
          final: "Final",
          matches: "Jogos",
          matchesShort: "Jogos",
          gamesWon: "Games ganhos",
          gamesWonShort: "G+",
          gamesLost: "Games perdidos",
          gamesLostShort: "G-",
          balance: "Saldo",
          balanceShort: "Saldo",
          wins: "Vitórias",
          winsShort: "Vit",
          losses: "Derrotas",
          lossesShort: "Der",
        },
      },
      about: {
        title: "Sobre o desafio",
        titleTournament: "Sobre o torneio",
        labels: {
          category: "Categoria",
          format: "Formato",
          slots: "Nº de vagas",
          registration: "Inscrição",
          expectedStart: "Início previsto",
          location: "Local",
          type: "Tipo",
          howItWorks: "Como funciona?",
          howItWorksText:
            "Os jogos e rodadas serão gerados automaticamente após o início do desafio.",
          availableSuffix: "disponíveis",
          registeredOf: "inscritos de",
          totalSlots: "Vagas totais",
          remainingSlots: "Vagas disponíveis",
          perPlayer: "Por jogador",
          showMore: "Ver mais",
          showLess: "Mostrar menos",
        },
      },
      type: {
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Poço",
        tournament: "Torneio",
        fallback: "Desafio",
      },
      format: {
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Poço",
        tournament: "Torneio",
      },
      mode: {
        individual: "Individual",
        fixedPair: "Dupla fixa",
        players: "jogadores",
        pairs: "duplas",
        registrationPerPlayerFixedPair: "por jogador (dupla fixa)",
      },
    },
    publicTournamentProgress: {
      scoreSeparator: " · ",
      matchResultAria: "Resultado: {score}",
      sideResultAria: "Resultado da dupla {side}",
      matchesSuffix: "jogos",
      status: {
        finished: "Finalizado",
        inProgress: "Em quadra",
        scheduled: "Agendado",
        pending: "Pendente",
      },
      round: {
        group: "Grupo",
        groupStage: "Fase de grupos",
        playIn: "Classificatório",
        roundOf32: "16 avos de final",
        roundOf16: "Oitavas de final",
        quarterfinal: "Quartas de final",
        semifinal: "Semifinal",
        final: "Final",
        knockout: "Mata-mata",
      },
      elapsed: {
        lessThanMinute: "Iniciado há menos de 1 min",
        minutes: "Iniciado há {minutes} min",
        hoursMinutes: "Iniciado há {hours}h {minutes}min",
        hours: "Iniciado há {hours}h",
        daysHours: "Iniciado há {days}d {hours}h",
        days: "Iniciado há {days}d",
      },
      fallback: {
        category: "Categoria",
        court: "Quadra a definir",
        side: "A definir",
        date: "Data a definir",
        time: "Horário a definir",
      },
      loadingTournament: "Carregando torneio...",
      headers: {
        bracketsTitle: "Chaves",
        timelineTitle: "Timeline do torneio",
        bracketsDescription:
          "Acompanhe os confrontos, vencedores e próximos jogos por categoria.",
        timelineDescription:
          "Veja a ordem dos jogos, horários, quadras e status em tempo real.",
      },
      empty: {
        noBracketMatches: "Nenhum confronto gerado para esta chave.",
        bracketTitle: "Chave ainda não publicada",
        bracketText:
          "A chave aparecerá aqui quando a organização gerar os confrontos.",
        noGamesTitle: "Nenhum jogo encontrado",
        timelineNotGeneratedTitle: "Timeline ainda não gerada",
        noGamesText:
          "Ajuste os filtros de categoria, quadra ou data para ver os jogos agendados.",
        timelineNotGeneratedText:
          "A agenda aparecerá aqui quando os jogos forem agendados.",
      },
      champion: {
        label: "Dupla campeã",
        finalPrefix: "Final:",
      },
      actions: {
        shareResult: "Compartilhar resultado",
        generatingArt: "Gerando arte...",
        share: "Compartilhar",
        downloadPng: "Baixar PNG",
      },
      filters: {
        category: "Categoria",
        allCategories: "Todas as categorias",
        court: "Quadra",
        allCourts: "Todas as quadras",
        previousDay: "Dia anterior",
        nextDay: "Próximo dia",
      },
      timeline: {
        scheduled: "Previsto",
      },
      sharePreview: {
        ariaLabel: "Prévia do resultado",
        title: "Compartilhar resultado",
        description: "Prévia da arte em formato Story 1080x1920.",
        closeAria: "Fechar prévia",
        imageAlt: "Prévia do resultado final",
        nativeTitle: "Resultado TNP",
        nativeText: "{champion} venceu {category}",
      },
      canvas: {
        imageError: "Não foi possível gerar a imagem.",
        unavailableCanvas: "Canvas indisponível.",
        championLabels: {
          female: {
            title: "CAMPEÃS",
            championBadge: "DUPLA CAMPEÃ",
            championSideTitle: "CAMPEÃS",
            runnerTitle: "VICE-CAMPEÃS",
          },
          male: {
            title: "CAMPEÕES",
            championBadge: "DUPLA CAMPEÃ",
            championSideTitle: "CAMPEÕES",
            runnerTitle: "VICE-CAMPEÕES",
          },
          mixed: {
            title: "DUPLA CAMPEÃ",
            championBadge: "CAMPEÕES DO MISTO",
            championSideTitle: "CAMPEÕES",
            runnerTitle: "DUPLA VICE-CAMPEÃ",
          },
          neutral: {
            title: "DUPLA CAMPEÃ",
            championBadge: "DUPLA CAMPEÃ",
            championSideTitle: "CAMPEÃ",
            runnerTitle: "VICE-CAMPEÃ",
          },
        },
        firstPlacePrefix: "1ª",
        shareLine1: "COMPARTILHE",
        shareLine2: "SUA VITÓRIA!",
        markInstagram: "MARQUE @TODOSNOPADEL",
        experienceLine1: "MAIS QUE UM TORNEIO,",
        experienceLine2: "UMA EXPERIÊNCIA!",
        socialLine: "◎  ♪  ▶  @TODOSNOPADEL",
        athleteFallback: "Atleta TNP",
      },
    },
    shareChampionship: {
      title: "Compartilhar campeonato",
      description:
        "Mostre este campeonato para mais jogadores e aumente as inscrições.",
      closeAria: "Fechar compartilhamento",
    },
  },
  ranking: {
    hub: {
      title: "Rankings",
      subtitle: "Acompanhe a evolução dos jogadores e organizadores do TNP.",
      officialCard: {
        title: "Ranking Oficial TNP",
        description:
          "Acompanhe o ranking geral de todos os jogadores do circuito TNP.",
        cta: "Ver Ranking",
        stats: {
          players: "Jogadores",
          season: "Temporada",
          continuousUpdateLine1: "Atualização",
          continuousUpdateLine2: "contínua",
        },
      },
      organizersCard: {
        title: "Rankings de Organizadores",
        description:
          "Explore os rankings personalizados dos organizadores parceiros.",
        cta: "Explorar Organizadores",
        stats: {
          organizers: "Organizadores",
          players: "Jogadores",
          events: "Eventos",
        },
      },
    },
    organizersDirectory: {
      title: "Selecionar Organizador",
      subtitle: "Escolha um organizador para abrir o ranking correspondente.",
      loading: "Carregando organizadores...",
      loadError: "Não foi possível carregar os organizadores.",
      loadMoreError: "Não foi possível carregar mais organizadores.",
      empty: "Nenhum organizador cadastrado.",
      searchPlaceholder: "Digite o nome do organizador",
      searchAriaLabel: "Buscar organizador por nome",
      searchButtonAriaLabel: "Buscar organizador",
      loadMore: "Carregar mais",
      loadingMore: "Carregando...",
      sortLabel: "Ordenar por",
      sortOptions: {
        name: "Nome A-Z",
        athletes: "Mais atletas",
        events: "Mais eventos",
        updated: "Atualizados recentemente",
      },
      selectedTitle: "Selecione um Ranking",
      selectedSubtitle:
        "Escolha o organizador ou clube para visualizar o ranking correspondente.",
      searchExpandedPlaceholder: "Buscar organizador, clube ou arena...",
      featuredTitle: "Mais acessados",
      allTitle: "Todos os organizadores",
      emptySearch: "Nenhum ranking encontrado.",
      rankingCountSuffix: "rankings",
      athletes: "atletas",
      events: "eventos",
      viewRanking: "Ver ranking",
      viewRankingAriaPrefix: "Ver ranking de",
      openRankingAriaPrefix: "Abrir ranking de",
      updatedAtPrefix: "Atualizado em",
    },
    page: {
      modeTabs: {
        all: "Geral",
        super8: "Super8",
        challenge: "Challenge",
        poco: "Poço",
        tournament: "Torneio",
      },
      sourceTabs: {
        official: "Oficiais",
        organizer: "Organizadores",
      },
      categoryTabs: {
        open: "Open",
        c2a: "2ª",
        c3a: "3ª",
        c4a: "4ª",
        c5a: "5ª",
        c6a: "6ª",
        c7a: "Iniciante",
      },
      labels: {
        source: "Origem",
        modality: "Modalidade",
        organizer: "Organizador",
        allOrganizers: "Todos",
        disabledOrganizerOption: "—",
        category: "Categoria",
        period: "Período",
        points: "Pontos",
        scoringStandard: "Padrão de pontuação",
        uncategorized: "Sem categoria",
        rank: "Pos",
        name: "Nome",
        filters: "Filtros",
        moreInformation: "Mais informações",
        mobileControls: "Controles de filtros e informações",
        dateFrom: "Data inicial",
        dateTo: "Data final",
        consideredStages: "Etapas consideradas",
        selectAll: "Selecionar todas",
        stageFallback: "Etapa",
      },
      periodOptions: {
        allTime: {
          label: "Sempre",
          description: "Ranking histórico completo",
        },
        last4: {
          label: "Últimas 4 etapas",
          description: "Considera apenas as últimas 4 etapas",
        },
        last8: {
          label: "Últimas 8 etapas",
          description: "Considera apenas as últimas 8 etapas",
        },
        last30: {
          label: "Últimos 30 dias",
          description: "Considera eventos dos últimos 30 dias",
        },
        last90: {
          label: "Últimos 90 dias",
          description: "Considera eventos dos últimos 90 dias",
        },
        currentYear: {
          label: "Ano atual",
          description: "Considera eventos do ano atual",
        },
        custom: {
          label: "Personalizado",
          description: "Escolha um período específico",
        },
      },
      summaryCards: {
        leader: "Líder Atual",
        noLeader: "Sem líder",
        waitingRanking: "Aguardando ranking",
        countedEvents: "Eventos Contabilizados",
        allHistory: "Em toda a história",
        periodEvents: "Eventos no período",
        rankedAthletes: "Atletas Ranqueados",
        currentSelection: "Na seleção atual",
        currentPeriod: "Período Atual",
      },
      messages: {
        noOrganizerRankings:
          "Ainda não existem rankings de organizadores para exibir.",
        hint: "O ranking soma os pontos por pessoa dentro da categoria selecionada.",
        availableCategoriesOnly:
          "Mostramos apenas categorias com ranking publicado. As demais ainda não têm dados disponíveis.",
        customScoringInfo:
          "Este ranking utiliza uma tabela de pontuação configurada pelo organizador e pode ser diferente do Ranking Oficial do TNP.",
        empty: "Sem resultados finalizados para esta categoria.",
        loadError: "Não foi possível carregar o ranking.",
        historyLoadError: "Não foi possível carregar o histórico do atleta.",
        genderTooltip:
          "Filtre o ranking por gênero: todos, feminino ou masculino.",
        invalidDateRange:
          "A data final deve ser posterior à data inicial.",
        noStagesForPeriod:
          "Nenhuma etapa encontrada para este período.",
        viewHistoryPrefix: "Ver histórico esportivo de",
        athleteFallback: "atleta",
        emptyFinishedTitle: "Sem resultados finalizados",
        emptyFinishedHint:
          "Ajuste os filtros ou aguarde a finalização de eventos para esta categoria.",
        historyAriaPrefix: "Histórico de",
        historyTitle: "Histórico esportivo",
        closeHistory: "Fechar histórico",
        emptyHistory:
          "Este atleta ainda não possui participações registradas neste ranking.",
      },
      titleFallbacks: {
        ranking: "Ranking",
        organizerRanking: "Ranking Organizadores",
        organizerById: "Ranking Organizador #",
      },
      ariaLabel: "Ranking geral",
    },
    shareModal: {
      shareAction: "Compartilhar",
      title: "Compartilhar ranking",
      closeAria: "Fechar compartilhamento",
      previewAlt: "Prévia da arte de ranking",
      generatingImage: "Gerando imagem...",
      imageUnavailable: "Imagem indisponível.",
      whatsapp: "WhatsApp",
      instagramStories: "Instagram/Stories",
      copyLink: "Copiar link",
      downloadImage: "Baixar imagem",
      copiedLink: "Link copiado.",
      copyError: "Não foi possível copiar o link.",
      generateError: "Não foi possível gerar a imagem do ranking.",
      directUnavailable:
        "Compartilhamento direto indisponível. A imagem foi baixada.",
      storiesHint: "Para Stories, baixe a imagem e publique no Instagram.",
      shareTitle: "Ranking TNP",
      shareTextPrefix: "Confira o Ranking",
      athleteFallback: "Atleta",
      canvas: {
        positionLabel: "SUA POSIÇÃO",
        currentUserTop: "Você está em {position}º lugar!",
        topCategoryMessage:
          "Parabéns por estar entre os melhores da categoria!",
        pointsSuffix: "pts",
        unavailableCanvas: "Canvas indisponível.",
        imageError: "Não foi possível gerar a imagem.",
      },
    },
  },
  shop: {
    title: "Loja",
    subtitle: "Produtos em destaque da comunidade.",
    loadingProducts: "Carregando produtos...",
    priceFallback: "Consulte",
    detailsSubtitle: "Detalhes do produto",
    backToList: "Voltar para lista",
    notFound: {
      title: "Produto não encontrado",
      message: "O produto informado não existe ou foi removido.",
      action: "Voltar para loja",
    },
  },
  eventDetails: {
    loading: "Carregando detalhes do evento...",
    notFoundTitle: "Evento não encontrado",
    notFoundMessage: "Este evento não está mais disponível.",
    date: "Data",
    address: "Endereço",
    amountPerPlayer: "Valor por jogador",
    remainingSlots: "Vagas restantes",
    details: "Detalhes",
    howRegistrationWorks: "Como funciona a inscrição?",
    paymentGuarantee:
      "Sua vaga será garantida após a confirmação do pagamento.",
    fallbackDate: "A definir",
    fallbackAddress: "A definir",
    loginToRegister: "Fazer login para se inscrever",
    registrationClosedButton: "Inscrições em breve",
    registrationClosedMessage:
      "As inscrições deste evento ainda não foram liberadas pelo organizador.",
    categories: {
      toBeDefined: "A definir",
    },
    challengeTypes: {
      super8: "Super 8",
      poco: "Poço",
      tournament: "Torneio",
      challenge: "Challenge",
    },
    registrationStatus: {
      pending: "Pendente",
      confirmed: "Confirmada",
      waitlist: "Lista de espera",
      canceled: "Cancelada",
      none: "Sem inscrição",
    },
    paymentStatus: {
      pending: "Pendente",
      confirmed: "Confirmado",
      canceled: "Cancelado",
      refunded: "Estornado",
      toBeDefined: "A definir",
      prefix: "Pagamento",
    },
    challengeStatus: {
      pending: "A iniciar",
      started: "Em andamento",
      finished: "Finalizado",
      canceled: "Cancelado",
      event: "Evento",
    },
    registrations: {
      title: "Inscritos",
      sortedByPayment:
        "Ordenado pela confirmação do pagamento; sem data de pagamento, pela última atualização da inscrição.",
      confirmedAtPrefix: "Pagamento confirmado em",
      confirmedFallbackCreatedAtPrefix:
        "Pagamento confirmado sem data registrada. Inscrição atualizada em",
      confirmedNoDate: "Pagamento confirmado sem data registrada",
    },
    loadingRegistrationStatus: "Carregando seu status de inscrição...",
    loadingEventInfo: "Carregando informações do evento...",
    missingChallengeLink:
      "Inscrição disponível após o administrador vincular este evento a um desafio.",
  },
  eventRegistration: {
    fallback: {
      toBeDefined: "A definir",
      player: "Jogador com",
    },
    buttons: {
      backToEvents: "Voltar aos eventos",
      unavailable: "Inscrição indisponível",
      confirmed: "Inscrição confirmada",
      confirmMyRegistration: "Confirmar minha inscrição",
      continueToPayment: "Continuar para pagamento",
      openPaymentAgain: "Abrir pagamento novamente",
      viewMyRegistrations: "Ver minhas inscrições",
      selectPartner: "Selecionar",
      unavailablePartner: "Indisponível",
    },
    steps: {
      registration: "Inscrição",
      data: "Dados",
      externalPayment: "Pagamento externo",
      confirmation: "Confirmação",
    },
    linkedChallengeMissing:
      "Este evento ainda não tem um desafio vinculado. Peça para o administrador configurar.",
    registrationClosed:
      "As inscrições ainda não foram liberadas pelo organizador.",
    loadingEventInfo: "Carregando informações do evento...",
    loadingMyRegistration: "Atualizando sua inscrição...",
    loadingPartners: "Carregando jogadoras...",
    emptyPartners: "Nenhuma jogadora encontrada.",
    removeSelectedPairError: "Não foi possível remover a dupla selecionada.",
    shirts: {
      deadlineClosed:
        "O prazo para escolher camiseta terminou. Voce ainda pode se inscrever sem camiseta.",
      soldOut:
        "As camisetas disponiveis acabaram. Voce ainda pode se inscrever sem camiseta.",
      availableCount: "{count} camisetas disponiveis.",
      oneAvailable:
        "Resta 1 camiseta disponivel. Escolha para um jogador ou prossiga sem camiseta.",
      onlyOneAvailable:
        "Resta apenas 1 camiseta disponivel. Escolha camisa para um jogador ou prossiga sem camisa.",
    },
    partnerCompatibility: {
      incompatiblePair:
        "Esta dupla é incompatível com a categoria selecionada.",
      available: "Disponível",
      unavailable: "Indisponível",
      undefinedCategory: "Categoria não definida",
      incompatible: "Incompatível",
    },
    form: {
      registrationCategory: "Categoria da inscrição",
      remainingSlots: "vagas restantes",
      profileIncompatible: "incompatível com seu perfil",
      fixedPair: {
        title: "Sua dupla",
        searchLabel: "Buscar por nome, e-mail ou Telefone",
        searchPlaceholder: "Buscar por nome, e-mail ou Telefone",
        noCategory: "Sem categoria",
        introFemale: "Selecione uma jogadora",
        introMale: "Selecione um jogador",
        introAny: "Selecione uma pessoa",
        introWarning:
          "Não encontrou sua dupla? Peça para ela finalizar o cadastro e verificar qual a categoria.",
        introCategoryPrefix: "da categoria",
      },
      drawPairSide: {
        noticeTitle: "Duplas por sorteio",
        notice: "As duplas deste desafio serão formadas por sorteio.",
        question: "Em qual lado você prefere jogar?",
        both: "Posso jogar nos dois lados",
        bothSummary: "Ambos",
        summaryLabel: "Preferência de lado",
      },
      super8Notice:
        "Inscrição individual: você não precisa escolher dupla para participar deste Super 8. As rodadas são sorteadas automaticamente e todos jogam com todos.",
      availabilityRestrictionTooltip:
        "Informe se há um período em que você não poderá jogar neste torneio.",
      availabilityRestrictionPeriodsLabel: "Períodos indisponíveis",
    },
    summary: {
      title: "Resumo da inscrição",
      date: "Data",
      location: "Local",
      type: "Tipo",
      format: "Formato",
      rule: "Regra",
      category: "Categoria",
      players: "Jogadores",
      valuePerPlayer: "Valor por jogador",
      subtotal: "Subtotal",
      discount: "Desconto",
      fee: "Taxa do método",
      total: "Total da inscrição",
      fixedPair: "Dupla fixa",
      individual: "Individual",
      super8Format: "Super 8",
      super8Rule: "Rodadas sorteadas • Todos contra todos",
      selectPair: "Selecione sua dupla",
    },
    paymentMethods: {
      title: "Pagamento externo",
      pixLabel: "PIX",
      creditLabel: "Crédito",
      note: "Taxas adicionais são aplicadas conforme o método selecionado.",
    },
    discountCoupon: {
      label: "Cupom de desconto",
      placeholder: "Ex.: TNP10",
      apply: "Aplicar",
      applying: "Aplicando...",
      applied: "Cupom aplicado.",
      invalid: "Cupom inválido.",
      empty: "Informe o código do cupom.",
      successPrefix: "Desconto aplicado com",
    },
    checkout: {
      redirectingTitle: "Redirecionando para o pagamento seguro...",
      redirectingText:
        "Estamos preparando sua cobrança no Asaas. Em instantes uma nova aba será aberta para você escolher PIX, cartão ou boleto.",
      confirmedTitle: "Pagamento confirmado",
      confirmedText:
        "A Asaas confirmou o pagamento e sua inscrição já está garantida no evento.",
      pendingTitle: "Pagamento pendente",
      pendingText:
        "Sua inscrição foi registrada. Estamos aguardando a confirmação do pagamento pela Asaas via webhook para concluir sua vaga.",
    },
    status: {
      canceledPrefix: "Inscrição cancelada",
      pendingPayment: "Inscrição pendente de pagamento.",
      fixedPairPrefix: "Dupla fixa:",
      waitlistLabel: "Lista de espera",
      waitlist:
        "Você está na lista de espera. Quando abrir vaga, quem confirmar pagamento primeiro é promovido.",
      waitlistConfirmation:
        "As vagas desta competição já foram preenchidas.\n\nVocê pode concluir sua inscrição e entrar na lista de espera. Sua posição na fila será garantida somente após a confirmação do pagamento.\n\nCaso uma vaga seja liberada, as inscrições pagas serão chamadas pela ordem da fila.",
      paymentLinkPrefix: "Link de pagamento:",
    },
    toasts: {
      openPaymentSuccess: "Pagamento aberto em nova aba.",
      openPopupError:
        "Não foi possível abrir nova aba. Libere pop-up e tente novamente.",
      checkoutStartError: "Não foi possível iniciar o checkout agora.",
    },
    errors: {
      teammateCpfRequired: "Informe o CPF da sua dupla fixa.",
      preferredSideRequired: "Selecione o lado em que você prefere jogar.",
      profileCategoryRequired:
        "Defina sua categoria no perfil para se inscrever neste desafio.",
      categoryMismatch: "Você não está na categoria deste desafio.",
      registrationCategoryRequired:
        "Selecione a categoria da inscrição para continuar.",
      fullNameRequired: "Informe o nome completo.",
      emailRequired: "Informe o e-mail.",
      phoneInvalid: "Informe um WhatsApp/celular válido com DDD.",
      taxIdInvalid: "Informe um CPF ou CNPJ válido.",
    },
  },
  admin: {
    accessDenied: "Acesso restrito.",
    pageTitle: "Painel do administrador",
    pageTitleOrganizer: "Painel do organizador",
    pageSubtitle:
      "Gerencie site, usuários, desafios e histórico em um único lugar.",
    pageSubtitleOrganizer:
      "Gerencie seus desafios, inscrições e usuários vinculados aos seus eventos.",
    tabs: {
      content: "Conteúdo",
      users: "Usuários",
      history: "Desafios",
      tournaments: "Torneios",
      clubs: "Clubes",
      categoryRequests: "Trocas de categoria",
      registrations: "Inscrições",
      payments: "Split",
      coupons: "Cupons",
    },
    clubs: {
      eyebrow: "Diretório público",
      title: "Clubes",
      subtitle: "Cadastre e mantenha os clubes exibidos no diretório público.",
      newClub: "Adicionar clube",
      listTitle: "Clubes cadastrados",
      searchPlaceholder: "Buscar clube",
      loading: "Carregando clubes...",
      empty: "Nenhum clube encontrado.",
      loadError: "Não foi possível carregar os clubes.",
      imageError: "Não foi possível carregar a imagem.",
      imageTooLargeError:
        "As imagens enviadas devem ser válidas e ter até 3 MB.",
      requiredFieldsError: "Preencha nome, logo, endereço, cidade e estado.",
      cepLookup: "Buscar CEP",
      cepLookupLoading: "Buscando...",
      cepLookupInvalid: "Informe um CEP com 8 dígitos.",
      cepLookupSuccess: "Endereço encontrado pelo CEP.",
      cepLookupSuccessWithCoordinates:
        "Endereço e coordenadas encontrados pelo CEP.",
      cepLookupError: "Não foi possível buscar o endereço pelo CEP.",
      selectOnMap: "Selecionar ponto no mapa",
      mapLookupLoading: "Localizando...",
      mapLookupSuccess: "Localização sugerida pelo endereço.",
      mapLookupError:
        "Não foi possível localizar este endereço automaticamente. Ajuste o ponto no mapa.",
      closeMapPicker: "Fechar seletor de mapa",
      mapPickerTitle: "Selecionar ponto do clube",
      mapPickerDescription:
        "Clique no mapa ou arraste o marcador para definir latitude e longitude.",
      mapPickerAria: "Mapa para selecionar latitude e longitude do clube",
      useMapPoint: "Usar este ponto",
      createSuccess: "Clube criado.",
      updateSuccess: "Clube atualizado.",
      saveError: "Não foi possível salvar o clube.",
      activated: "Clube ativado.",
      deactivated: "Clube desativado.",
      deleteConfirm: "Excluir este clube?",
      deleteSuccess: "Clube excluído.",
      viewPublic: "Ver público",
      activate: "Ativar",
      deactivate: "Desativar",
      delete: "Excluir",
      closeModal: "Fechar cadastro de clube",
      logo: "Logo",
      createTitle: "Cadastrar clube",
      editTitle: "Editar clube",
      active: "Ativo",
      save: "Salvar clube",
      saving: "Salvando...",
      fields: {
        name: "Nome",
        logo: "Logo",
        cover: "Foto principal",
        description: "Descrição",
        address: "Endereço",
        city: "Cidade",
        state: "Estado",
        zipCode: "CEP",
        number: "Número",
        complement: "Complemento",
        neighborhood: "Bairro",
        phone: "Telefone",
        whatsapp: "WhatsApp",
        email: "E-mail",
        site: "Site",
        instagram: "Instagram",
        bookingUrl: "Link de reserva",
        lancesUrl: "Link dos lances",
        lancesPlatformName: "Nome da plataforma de lances",
        latitude: "Latitude",
        longitude: "Longitude",
      },
    },
    misc: {
      athlete: "Atleta",
      currentCategory: "Categoria atual",
      requestedCategory: "Categoria solicitada",
      requestDate: "Data da solicitação",
      noReason: "Sem motivo informado.",
      rejectionNote: "Motivo da recusa / observação ADM (opcional)",
      rejectionNotePlaceholder:
        "Informe o motivo da recusa ou uma observação de aprovação.",
      noUsersHint: "Tente outro filtro ou termo de busca.",
      scheduledTime: "Horário previsto",
      startedPrefix: "Iniciado:",
      finishedPrefix: "Finalizado:",
      dailyStart: "Início diário",
      dailyEnd: "Fim diário",
      matchDuration: "Duração por partida",
      addSet: "Adicionar set",
      registrationsCenter: "Central de Inscrições",
      registrationsDescription:
        "Gerencie pagamentos, confirmações e lista de espera.",
      billingMethod: "Forma de cobrança",
      billingMethodHint: "Usada ao enviar cobrança",
      unavailableAutomaticBilling: "Indisponível para cobrança automática",
      emptyRegistrationsHintLine1: "Quando novas inscrições forem realizadas,",
      emptyRegistrationsHintLine2: "elas aparecerão aqui.",
      refreshList: "Atualizar lista",
    },
    sidebar: {
      selectedChallengeEdit: "Edição do desafio selecionado.",
      contentConfig: "Configuração de conteúdo do aplicativo.",
      backToPanel: "Voltar ao painel",
      closePanelMenu: "Fechar menu do painel",
      adminMenu: "Menu do painel administrativo",
      openSideMenu: "Abrir menu lateral",
      closeSideMenu: "Fechar menu lateral",
      kicker: "Painel",
      adminTitle: "Administração",
      organizerTitle: "Organização",
      description: "Navegação principal e módulos de gestão.",
      soon: "Em breve",
      dashboard: "Dashboard",
      finance: "Financeiro",
      notifications: "Notificações",
      stockAndPayments: "Estoque e pagamentos",
    },
    contentTabs: {
      hero: "Hero",
      about: "Sobre",
      highlights: "Destaques",
      events: "Eventos",
      products: "Produtos",
      instagram: "Instagram",
    },
    saveChanges: "Salvar alterações",
    saving: "Salvando...",
    toasts: {
      saveContentSuccess: "Conteúdo atualizado com sucesso.",
      saveContentError: "Erro ao salvar conteúdo.",
      userCreatedSuccess: "Usuário criado com sucesso.",
      userCreatedError: "Falha ao criar usuário.",
      userUpdatedSuccess: "Usuário atualizado com sucesso.",
      userUpdatedError: "Falha ao atualizar usuário.",
      userRemovedSuccess: "Usuário removido.",
      userRemovedError: "Falha ao remover usuário.",
      challengeLoadError: "Não foi possível carregar o desafio.",
      challengeRoundsInvalid: "JSON de rodadas inválido.",
      challengeSaveSuccess: "Desafio atualizado com sucesso.",
      challengeSaveError: "Falha ao atualizar desafio.",
      challengeStartedSuccess: "Desafio iniciado com sucesso.",
      challengeStartError: "Não foi possível iniciar o desafio.",
      challengeFinishedSuccess: "Desafio finalizado com sucesso.",
      challengeFinishError: "Não foi possível finalizar o desafio.",
      challengeDeleteSuccess: "Desafio removido.",
      challengeDeleteError: "Falha ao remover desafio.",
      challengeEventCreatedSuccess:
        "Evento criado na home e vinculado ao desafio.",
      challengeEventExistsError: "Este desafio já está vinculado a um evento.",
      imageRemovedSuccess: "Imagem removida com sucesso.",
    },
    confirms: {
      removeUser: "Remover este usuárioã",
      cancelCreateUser:
        "Ao cancelar, os dados preenchidos neste formulário serão apagados. Deseja continuar?",
      removeChallenge: "Remover este desafio e suas partidas?",
    },
    sections: {
      hero: "Hero",
      about: "Sobre",
      highlights: "Destaques",
      events: "Eventos",
      products: "Produtos",
      instagram: "Instagram",
      users: "Usuários cadastrados",
      challengeHistory: "Desafios",
    },
    actions: {
      addHighlight: "Adicionar destaque",
      addEvent: "Adicionar evento",
      addProduct: "Adicionar produto",
      addPost: "Adicionar post",
      addUser: "Adicionar usuário",
      createUser: "Criar usuário",
      saveChallenge: "Salvar desafio",
      removeChallenge: "Remover desafio",
      createChallenge: "Criar desafio",
      createEvent: "Criar evento",
      startChallenge: "Iniciar",
      finishChallenge: "Finalizar",
      next: "Próximo",
      close: "Fechar",
      generateUsersSearchPlaceholder: "Nome ou CPF",
    },
    labels: {
      title: "Título",
      subtitle: "Subtítulo",
      description: "Descrição",
      fullDetails: "Detalhes completos",
      ctaText: "Texto do CTA",
      ctaLink: "Link do CTA",
      heroImage: "Imagem do hero",
      image: "Imagem",
      date: "Data",
      time: "Hora (24h)",
      address: "Endereço",
      registrationLink: "Link de inscrição",
      registrationButtonText: "Texto do botão de inscrição",
      buttonText: "Texto do botão",
      bulletsPerLine: "Bullets (uma por linha)",
      link: "Link",
      price: "Preço",
      name: "Nome",
      email: "E-mail",
      cpf: "CPF",
      phone: "Telefone",
      sex: "Sexo",
      category: "Categoria",
      profile: "Perfil",
      password: "Senha",
      newPasswordOptional: "Nova senha (opcional)",
      searchByNameOrCpf: "Buscar por nome ou CPF",
      group: "Grupo",
      challengeName: "Nome do desafio",
      scheduledAt: "Data e horário",
      participants: "Participantes",
      filterByName: "Filtrar por nome",
      filterDateFrom: "Data inicial",
      filterDateTo: "Data final",
      filterDateRange: "Período",
      durationSeconds: "Duração (HH:MM)",
      status: "Status",
      roundsJson: "Rodadas (JSON)",
    },
    statuses: {
      loadingUsers: "Carregando usuários...",
      loadingHistory: "Carregando histórico...",
      livePanel:
        "Este painel substitui a antiga /admin para criação e andamento dos desafios.",
      pending: "A iniciar",
      started: "Em andamento",
      finished: "Finalizado",
      selected: "Selecionado",
      edit: "Editar",
      user: "Usuário",
      organizer: "Organizador",
      administrator: "Administrador",
      organizerUsersHint:
        "Como organizador, você pode adicionar novos usuários, mas não pode editar usuários existentes.",
    },
    usersTab: {
      selfPermissionHint:
        "Você não pode alterar sua própria permissão de acesso.",
      noUsersFound: "Nenhum usuário encontrado.",
    },
    tournamentCategoryEditor: {
      title: "Categorias do torneio",
      addCategory: "Adicionar categoria",
      fallbackCategory: "Categoria",
      categoryName: "Nome da categoria",
      boysCategory: "Categoria meninos",
      girlsCategory: "Categoria meninas",
      gender: "Gênero",
      registrationMode: "Modo de inscrição",
      individual: "Sorteio de duplas",
      fixedPair: "Dupla fixa",
      categoryLocation: "Local da categoria",
      categoryLocationPlaceholder: "Ex.: Clube X (opcional)",
      shirtSizesEnabled: "Camiseta",
      shirtSizesEnabledOption: "Habilitar camiseta",
      shirtSizesDisabled: "Não usar camiseta",
      shirtSizes: "Tamanhos de camiseta",
      shirtSizesPlaceholder: "Ex.: P, M, G, GG, Babylook P, Babylook M",
      slotsInCategory: "Vagas nesta categoria",
      fixedPairSlotInfo:
        "Neste modo, cada vaga representa 1 dupla (2 jogadores).",
      individualSlotInfo:
        "Neste modo, cada vaga representa 1 jogador (as duplas serão sorteadas).",
      categoryActions: "Ações da categoria",
      removeCategory: "Remover categoria",
      editCategory: "Editar",
      editSelectedCategory: "Editar categoria selecionada",
    },
    registrationsTab: {
      title: "Inscrições em eventos",
      refresh: "Atualizar",
      manualRegistrationHint:
        "Cadastro manual agora fica dentro do desafio (Histórico → abrir desafio), para respeitar modo individual ou dupla fixa.",
      paymentMethod: "Tipo de pagamento para gerar cobrança",
      debitCard: "Cartão de débito (+3%)",
      creditCard: "Cartão de crédito (+7%)",
      loading: "Carregando inscrições...",
      empty: "Nenhuma inscrição encontrada.",
      statusFilters: {
        pending: "Pendentes",
        confirmed: "Confirmadas",
        waitlist: "Lista de espera",
        canceled: "Canceladas",
        all: "Todas",
      },
      eventPrefix: "evento",
      pair: "Dupla",
      shirtSizes: "Camisetas",
      shirtSizePlayer: "Titular",
      shirtSizePartner: "Dupla",
      status: "Status",
      payment: "pagamento",
      player: "Jogador",
      notFound: "não encontrado",
      notRequired: "não obrigatório",
      paymentLink: "Link pagamento",
      open: "abrir",
      copyLink: "Copiar link",
      confirmPayment: "Confirmar pagamento",
    },
    categoryRequestsTab: {
      title: "Solicitações de troca de categoria",
      refresh: "Atualizar",
      loading: "Carregando solicitações...",
      empty: "Nenhuma solicitação encontrada.",
      playerFallback: "Jogador",
      noEmail: "sem e-mail",
      to: "para",
      reason: "Motivo",
      status: "Status",
      adminNote: "Observação ADM",
      adminNoteOptional: "Observação ADM (opcional)",
      processedBy: "Processado por",
      processedAtPrefix: "em",
      processing: "Processando...",
      approve: "Aprovar",
      reject: "Rejeitar",
      athlete: "Atleta",
      currentCategory: "Categoria atual",
      requestedCategory: "Categoria solicitada",
      requestedAt: "Data da solicitação",
      noReason: "Sem motivo informado.",
      decisionNoteLabel: "Motivo da recusa / observação ADM (opcional)",
      decisionNotePlaceholder:
        "Informe o motivo da recusa ou uma observação de aprovação.",
      decisionNotePrefix: "Motivo da recusa / observação ADM:",
      singularStatus: {
        pending: "Pendente",
        approved: "Aprovada",
        rejected: "Recusada",
      },
      filters: {
        pending: "Pendentes",
        approved: "Aprovadas",
        rejected: "Recusadas",
        all: "Todas",
      },
      toasts: {
        approved: "Solicitação aprovada e categoria atualizada.",
        rejected: "Solicitação rejeitada.",
        error: "Não foi possível processar a solicitação.",
      },
    },
    paymentsTab: {
      splitTitle: "Split ASAAS",
      save: "Salvar",
      secretsHint:
        "API key, webhook token e URLs do ASAAS são gerenciados por secrets no backend.",
      environment: "Ambiente",
      production: "Produção",
      platformWallet: "Carteira plataforma",
      platformFeeType: "Tipo taxa plataforma",
      percent: "Percentual",
      fixedFee: "Fixa (R$)",
      feeValue: "Valor taxa",
      splitEnabled: "Split ativo",
      active: "Ativo",
      inactive: "Inativo",
      organizerWallets: "Wallet dos organizadores",
      loadingSettings: "Carregando configurações...",
      walletId: "Wallet ID",
      organizerSplit: "Split do organizador",
      saveWallet: "Salvar wallet",
      noOrganizers: "Nenhum organizador encontrado.",
      myWallet: "Minha wallet ASAAS",
      toasts: {
        settingsSaved: "Configuração ASAAS salva.",
        settingsError: "Falha ao salvar configuração ASAAS.",
        organizerWalletSaved: "Wallet do organizador atualizada.",
        organizerWalletError: "Não foi possível salvar wallet do organizador.",
        myWalletSaved: "Sua wallet foi atualizada.",
        myWalletError: "Não foi possível salvar sua wallet.",
      },
    },
    discountCouponsTab: {
      title: "Cupons",
      newCoupon: "Adicionar cupom",
      create: "Criar cupom",
      saveEdit: "Salvar cupom",
      listTitle: "Cupons cadastrados",
      refresh: "Atualizar",
      loading: "Carregando cupons...",
      empty: "Nenhum cupom cadastrado.",
      edit: "Editar",
      activate: "Ativar",
      deactivate: "Inativar",
      unlimited: "Sem limite",
      noDescription: "Sem descrição",
      confirmDelete: "Remover este cupom?",
      fields: {
        code: "Código",
        description: "Descrição",
        type: "Tipo de desconto",
        value: "Valor",
        appliesTo: "Válido para",
        maxUses: "Limite de usos",
        validFrom: "Válido a partir de",
        validUntil: "Válido até",
        status: "Status",
      },
      active: "Ativo",
      inactive: "Inativo",
      types: {
        percentage: "Percentual",
        fixedAmount: "Valor fixo",
      },
      targets: {
        all: "Todos os eventos, desafios e torneios",
        currentUnavailable: "Item vinculado não encontrado",
      },
      appliesTo: {
        general: "Geral",
        event: "Evento",
        challenge: "Desafio",
        tournament: "Torneio",
      },
      toasts: {
        loadError: "Não foi possível carregar os cupons.",
        targetsLoadError:
          "Não foi possível carregar os desafios e torneios vinculados.",
        created: "Cupom criado.",
        updated: "Cupom atualizado.",
        deleted: "Cupom removido.",
        activated: "Cupom ativado.",
        deactivated: "Cupom inativado.",
        saveError: "Não foi possível salvar o cupom.",
        deleteError: "Não foi possível remover o cupom.",
      },
    },
    historyList: {
      tournamentsHistory: "Histórico de torneios",
      createTournament: "Criar torneio",
      challengesTitle: "Desafios",
      createChallenge: "+ Criar desafio",
      challengesSubtitle:
        "Gerencie e acompanhe todos os desafios da sua organização.",
      challengeSearchPlaceholder: "Buscar por nome do desafio...",
      moreOptionsAria: "Mais opções",
      paginationAria: "Paginação",
      previousPageAria: "Página anterior",
      nextPageAria: "Próxima página",
      showing: "Mostrando",
      rangeTo: "a",
      rangeOf: "de",
      challengeListKind: "desafios",
      tournamentListKind: "torneios",
      perPage: "por página",
      organization: "Organização",
      all: "Todos",
      official: "Oficial",
      tnp: "TNP",
      otherOrganizer: "Outro organizador",
      organizer: "Organizador",
      ranking: "Ranking",
      registrationsOpen: "Liberar inscrições",
      registrationsClose: "Fechar inscrições",
      registrationsStateOpen: "Inscrições abertas",
      registrationsStateClosed: "Inscrições fechadas",
      saving: "Salvando...",
      emptyTournament: "Nenhum torneio nesta seção.",
      emptyChallenge: "Nenhum desafio nesta seção.",
      loadingTournament: "Carregando torneio...",
      loadingChallenge: "Carregando desafio...",
      back: "Voltar",
      editResults: "Editar resultados",
      saveResults: "Salvar resultados",
      final: "Final",
      activeCategoryForRegistrations: "Categoria ativa para inscrições",
      playerAlreadySelected:
        "Este jogador já foi selecionado e não pode entrar em mais de uma dupla.",
      sidePreference: "Preferência de lado",
      refreshRegistrations: "Atualizar inscrições",
      loadingChallengeRegistrations: "Carregando inscrições do desafio...",
    },
    validation: {
      invalidCpf: "CPF inválido.",
      invalidPhone: "Informe o telefone completo com código do país e DDD.",
      duplicateCpf: "Este CPF já está cadastrado.",
      invalidDateTime: "Informe uma data/hora válidas.",
      invalidEndDate: "Informe uma data final válida.",
      endDateBeforeStart: "A data final não pode ser anterior à data inicial.",
      invalidDuration: "Informe duração válida no formato HH:MM.",
      organizerRequired: "Selecione um organizador para este desafio.",
      evenParticipantsRequired:
        "A lista de participantes precisa ter quantidade par.",
      super8ParticipantsRequired:
        "O Super 8 precisa de exatamente 8 participantes.",
      super8PlayersRequired: "O Super 8 precisa de exatamente 8 jogadores.",
      super8CombinedPlayersRequired:
        "O Super 8 deve possuir exatamente 8 participantes para gerar as rodadas.",
      cannotStartCurrentConfig:
        "Não foi possível iniciar com a configuração atual.",
      super8GroupSplit:
        "Este desafio utiliza a configuração antiga do Super 8 com 16 participantes e está disponível somente para consulta.",
      invalidChallengeId: "Informe um ID de desafio válido para vincular.",
      maxTrackingIds:
        "Informe até 2 IDs de rastreabilidade (separe por vírgula).",
      maxTrackingIdsError: "Informe no máximo 2 IDs de rastreabilidade.",
    },
    eventLink: {
      eventCode: "Código do evento (ID)",
      registration: "Inscrição",
      challengeLink: "Vínculo com desafio",
      selectChallenge: "Selecionar desafio…",
      challengeIdPlaceholder: "ID do desafio",
      defineEventId: "Defina um ID do evento para conseguir vincular.",
      invalidEventId:
        "ID do evento inválido. Use apenas letras, números, _ e - (máx 80).",
      noLink: "Sem vínculo configurado.",
      historyTabName: "Histórico",
      historyHintPrefix: "Abra a aba",
      historyHintSuffix: "para poder vincular.",
      registrationHint:
        "O botão de inscrição abre a tela do app para este evento.",
      link: "Vincular",
      removeLink: "Remover vínculo",
      linkedToChallengePrefix: "Vinculado ao desafio",
      noChallengeFound:
        "Nenhum desafio encontrado. Crie um desafio na aba Histórico para poder vincular aqui.",
      toasts: {
        saved: "Vínculo salvo com sucesso.",
        saveError: "Não foi possível salvar o vínculo.",
        removed: "Vínculo removido.",
        removeError: "Não foi possível remover o vínculo.",
        eventNotFound: "Não foi possível identificar o evento deste desafio.",
        registrationsOpened: "Inscrições liberadas.",
        registrationsClosed: "Inscrições fechadas.",
        registrationsUpdateError: "Não foi possível atualizar as inscrições.",
        rejected: "Inscrição recusada.",
        rejectError: "Não foi possível recusar a inscrição.",
        paid: "Pagamento marcado como pago.",
        paidError: "Não foi possível marcar como pago.",
        paymentLinkCopied: "Link de pagamento copiado.",
        paymentAlreadyConfirmed: "Pagamento já confirmado.",
        noPaymentLink: "Não há link de pagamento disponível para copiar.",
        copyError: "Não foi possível copiar o link.",
        registrationRemoved: "Inscrição removida.",
        registrationRemoveError: "Não foi possível remover inscrição.",
      },
    },
    modal: {
      addUserAriaLabel: "Adicionar usuário",
      addUserTitle: "Adicionar usuário",
      createChallengeTitle: "Criar desafio",
      challengeDetailsTitle: "Detalhes do desafio",
    },
    createChallengePage: {
      createTournamentTitle: "Criar torneio",
      createChallengeTitle: "Criar desafio",
      editTournamentTitle: "Editar torneio",
      editChallengeTitle: "Editar desafio",
      pageSubtitleTournament:
        "Configure as informações principais do torneio.",
      pageSubtitleChallenge:
        "Configure as informações principais do desafio.",
      editSubtitleTournament:
        "Atualize as informações principais do torneio.",
      editSubtitleChallenge:
        "Atualize as informações principais do desafio.",
      back: "Voltar",
      gender: "Gênero",
      maleCategory: "Categoria masculina",
      femaleCategory: "Categoria feminina",
      category: "Categoria",
      organization: "Organização",
      official: "Oficial",
      organizer: "Organizador",
      select: "Selecione",
      currentAdmin: "Meu perfil ADM",
      emptyOption: "—",
      includeRanking: "Contabilizar no ranking oficial",
      includeOrganizerRanking: "Contabilizar no ranking do organizador",
      includeOfficialRanking: "Pontua no Ranking Oficial TNP?",
      yes: "Sim",
      no: "Não",
      eventIdentity: {
        title: "Identidade do evento",
        info:
          "Escolha qual imagem representa este evento nos compartilhamentos, cards e telas vinculadas ao organizador.",
        description:
          "Essa escolha vale apenas para este evento e não altera a identidade global do TNP.",
        mode: "Modo da identidade",
        photo: "Foto do organizador",
        logo: "Logo do organizador",
        tnp: "Padrão TNP",
        photoHelp: "Usa a foto do perfil do organizador em formato circular.",
        logoHelp: "Usa a logo cadastrada no perfil do organizador.",
        tnpHelp: "Usa a marca oficial do TNP.",
        logoMissing:
          "Para usar Logo do organizador, configure uma logo no perfil do organizador em Identidade visual.",
        uploadLogo: "Enviar logo",
        replaceLogo: "Trocar logo",
        savingLogo: "Salvando logo...",
        logoSaved: "Logo salva no seu perfil.",
        logoUploadHelp:
          "A logo enviada aqui fica vinculada ao seu perfil de organizador.",
        logoInvalid: "Use PNG, JPG, JPEG ou WEBP até 2MB.",
        preview: "Preview da identidade do evento",
        logoPreviewAlt: "Logo do organizador",
        organizerFallback: "Organizador",
      },
      tournamentCategoriesTitle: "Categorias e inscrições",
      tournamentCategoriesEditDescription:
        "Gerencie categorias, inscrições, duplas e jogadores.",
      tournamentCategoriesDescription:
        "Configure as categorias do torneio, o modo de inscrição por categoria e o total de vagas.",
      challengeCategoriesTitle: "Categorias do desafio",
      challengeCategoriesDescription:
        "Configure as categorias do desafio, o modo de inscricao e o horario de cada categoria.",
      challengeCategory: "Categoria do desafio",
      selectCategory: "Selecione uma categoria",
      categoryTime: "Horario da categoria",
      totalSlots: "Vagas totais configuradas",
      totalSlotsDescription: "Soma das vagas definidas em todas as categorias.",
      generalInfoTitle: "Informações gerais",
      generalInfoDescription:
        "Defina o nome e a descrição que serão exibidos no torneio.",
      tournamentName: "Nome do torneio",
      city: "Cidade",
      state: "Estado",
      clubVenue: "Clube/Local",
      selectCity: "Selecione uma cidade",
      selectClubVenue: "Selecione um clube/local",
      manualVenueOption: "Preencher manualmente",
      loadingClubs: "Carregando clubes...",
      noRegisteredClubs: "Nenhum clube cadastrado",
      eventCityPlaceholder: "Informe a cidade do evento",
      eventClubVenuePlaceholder: "Informe o clube/local do evento",
      locationPeriodTitle: "Local e período",
      locationScheduleTitle: "Local e horários",
      locationPeriodDescription:
        "Configure o local padrão do torneio e o intervalo de datas.",
      locationScheduleDescription:
        "Local, período e horário de início e fim por dia.",
      courtsTitle: "Quadra e nome das quadras",
      courtsDescription:
        "Cadastre as quadras disponíveis para a programação.",
      organizationRankingTitle: "Organização e ranking",
      organizationRankingDescription:
        "Escolha o organizador e a participação no ranking.",
      tournamentAddressPlaceholder: "Local padrão do torneio (cidade/clube)",
      tournamentStart: "Início do torneio",
      tournamentEnd: "Fim do torneio",
      registrationTypeInfoPrefix: "Tipo de inscrição do evento:",
      registrationIndividualSuper8: "individual (Super 8 sempre individual)",
      registrationFixedPairByCategory:
        "dupla fixa (definido pela categoria selecionada)",
      registrationIndividualByCategory:
        "individual (definido pela categoria selecionada)",
      registrationFixedPairPoco: "dupla fixa (Poço sempre dupla fixa)",
      registrationFixedPairByMode: "dupla fixa (definido pelo modo de duplas)",
      registrationIndividualByMode: "individual (definido pelo modo de duplas)",
      pricePerPlayer: "Valor por jogador (R$)",
      fixedPairPriceHint:
        "Para inscrição em dupla fixa, a cobrança final será este valor x 2.",
      eventSettingsTitle: "Imagem, valor e inscrições",
      eventSettingsDescription:
        "Configure a imagem pública, o valor, camiseta e abertura das inscrições.",
      visualIdentityTitle: "Identidade visual",
      visualIdentityDescription:
        "Personalização do organizador e foto do torneio.",
      advancedSettingsTitle: "Configurações avançadas do torneio",
      advancedSettingsDescription:
        "Agrupe regras opcionais de logística, operação e disponibilidade.",
      tournamentOperationsTitle: "Chaves e timeline",
      tournamentOperationsDescription:
        "Configure chaves, programação, timeline e resultados.",
      tournamentEventScheduleTitle: "Cronograma do torneio",
      tournamentEventScheduleDescription:
        "Configure a programação pública por dia, horário e atividade.",
      generalRequiredDescription: "Nome, descrição e valor obrigatório.",
      summary: {
        format: "Formato",
        date: "Data",
        categories: "Categorias",
        city: "Cidade",
        tournament: "Torneio",
        challenge: "Desafio",
        toBeDefined: "A definir",
        slotsSuffix: "vagas",
        definedByFormat: "Definido pelo formato",
        tnpStandard: "Padrão TNP",
        organizerLogo: "Logo do organizador",
        organizerPhoto: "Foto do organizador",
        countsRanking: "Conta para ranking",
        countsMyRanking: "Conta para meu ranking",
        notRanking: "Não conta para ranking",
        tournamentSummary: "Resumo do torneio",
        challengeSummary: "Resumo do desafio",
        locationFallback: "Local a definir",
        participantsSuffix: "participante(s)",
        changes: "Alterações:",
        pending: "Pendências:",
        saveChanges: "Salvar alterações",
        pendingSchedule: "programação",
        pendingGeneralInfo: "informações gerais",
        pendingShirts: "camisetas",
        pendingParticipants: "categorias e participantes",
        pendingRounds: "rodadas e resultados",
      },
      operations: {
        registrations: "Inscrições",
        registrationsOpen: "Abertas",
        registrationsClosed: "Fechadas",
        openRegistrations: "Abrir inscrições",
        closeRegistrations: "Fechar inscrições",
        closeRegistrationsMessage: 'Fechar inscrições de "{name}"?',
        closingRegistrations: "Fechando...",
        redrawPairs: "Sortear duplas novamente",
        regenerateRounds: "Gerar rodadas novamente",
        closeBeforeStart: "Feche as inscrições antes de iniciar.",
        generateBeforeStart: "Gere as rodadas antes de iniciar.",
      },
      sectionStatus: {
        complete: "Completo",
        attention: "Atenção",
        pending: "Pendente",
      },
      downloadShirtSizes: "Baixar planilha de camisetas",
      shirts: {
        eventShirts: "Camisas do evento",
        availabilityType: "Disponibilidade das camisas",
        availabilityNone: "Sem limite",
        availabilityPeriod: "Por prazo",
        availabilityQuantity: "Por quantidade",
        deadline: "Prazo para escolher camisa",
        quantityLimit: "Quantidade maxima de camisas",
        quantitySummary:
          "Total: {total} | Confirmadas: {confirmed} | Disponiveis: {available}",
      },
      customSettings: {
        challengeModel: "Modelo do desafio",
        tnpStandard: "Padrao TNP",
        custom: "Personalizado",
        gameType: "Tipo de jogo",
        byGames: "Por games",
        byTime: "Por tempo",
        gameCount: "Quantidade de games",
        gameDurationMinutes: "Tempo por jogo",
        courtsCount: "Quantidade de quadras",
        defaultCourtsCount: "Quadras padrão para novas categorias",
        categoryCourtsCount: "Quadras nesta categoria",
        playersCount: "Quantidade de jogadores",
        challengeWaitingPlayersHelp:
          "No Challenge, é permitido até 2 jogadores em espera por quadra.",
        pocoExactPlayersHelp:
          "No Poço, cada quadra precisa ter exatamente 4 jogadores.",
        timeOver: "Tempo encerrado.",
        startTimer: "Iniciar tempo",
        pauseTimer: "Pausar tempo",
        resetTimer: "Reiniciar tempo",
      },
      submitTournament: "Criar torneio",
      submitChallenge: "Criar desafio",
      saving: "Salvando...",
      defaultCategoryPrefix: "Categoria",
      toasts: {
        organizersLoadError: "Falha ao carregar organizadores.",
        organizerRequiredTournament:
          "Selecione um organizador para este torneio.",
        organizerRequiredChallenge:
          "Selecione um organizador para este desafio.",
        invalidSlots: "Informe um número válido de vagas (mínimo 2).",
        cityRequired: "Informe a cidade do evento.",
        clubVenueRequired: "Informe o clube/local do evento.",
        imageRequired: "Adicione uma imagem antes de salvar.",
        priceRequired:
          "Informe um valor por jogador maior que zero antes de salvar.",
        priceMinimum: "O valor mínimo permitido é R$ 5,00.",
        scheduleRequired:
          "Informe ao menos uma quadra e horários válidos para o torneio.",
        shirtSettingsRequired: "Informe se haverá camisetas no evento.",
        shirtSizesRequired:
          "Informe ao menos um tamanho de camiseta antes de salvar.",
        shirtDeadlineRequired:
          "Informe o prazo limite para escolha da camiseta.",
        shirtDeadlinePast:
          "O prazo para escolher camiseta não pode estar no passado.",
        shirtQuantityRequired: "Informe a quantidade maxima de camisas.",
        gameCountRequired: "Informe a quantidade de games.",
        gameDurationRequired: "Informe o tempo por jogo.",
        courtsCountRequired: "Informe ao menos 2 quadras.",
        playersCountRequired: "Informe ao menos 12 jogadores.",
        challengeMaxPlayersExceeded:
          "Quantidade máxima excedida. No Challenge personalizado, é permitido até 2 jogadores em espera por quadra.",
        pocoExactPlayersRequired:
          "No Poço personalizado, a quantidade de jogadores deve ser exatamente 4 jogadores por quadra.",
        pocoMinPlayersRequired: "O Poço precisa ter no mínimo 12 jogadores.",
        noShirtSizesToExport:
          "Nenhuma inscrição disponível para exportar camisetas.",
        categoriesRequired:
          "Crie ao menos uma categoria personalizada do torneio com vagas.",
        challengeCategoriesRequired:
          "O desafio precisa ter pelo menos uma categoria.",
        challengeCategoryRequired: "Selecione uma categoria.",
        categoryTimeRequired: "Informe o horario da categoria.",
        eachCategoryNeedsTime: "Cada categoria precisa ter um horario.",
        duplicateChallengeCategory: "Esta categoria ja foi adicionada.",
        challengeCategoryApplied:
          "Categoria aplicada. Use Salvar tudo do desafio para persistir.",
        categorySaved: "Categoria salva com sucesso.",
        categorySaveError: "Falha ao salvar categoria.",
        categoryRegistrationTypeSaved: "Modo de inscrição salvo.",
        invalidEndDate: "A data final não pode ser anterior à data inicial.",
        tournamentSaved: "Torneio salvo com sucesso.",
        challengeSaved: "Desafio salvo com sucesso.",
        tournamentSaveError: "Falha ao salvar torneio.",
        challengeSaveError: "Falha ao salvar desafio.",
      },
    },
    historyTable: {
      id: "ID",
      group: "Desafio",
      status: "Status",
      createdAt: "Criado em",
      scheduledAt: "Data/Hora",
      matches: "Partidas",
      participants: "Participantes",
      action: "Ação",
      editTitle: "Editar desafio #",
    },
  },
  imageUpload: {
    change: "Trocar",
    edit: "Editar",
    remove: "Remover",
    noImageSelected: "Nenhuma imagem selecionada.",
    helpText:
      "PNG/JPG recomendado. No modal, use scroll ou controle de zoom e arraste para reposicionar.",
    cropTitle: "Ajuste da foto",
    zoom: "Zoom",
    horizontalAdjust: "Ajuste horizontal",
    verticalAdjust: "Ajuste vertical",
    applyCrop: "Aplicar recorte",
    cropError:
      "Não foi possível recortar esta imagem. Tente trocar por um arquivo JPG/PNG local.",
    selectImageFor: "Selecionar imagem para",
    cropImageOf: "Ajuste da foto de",
    previewSuffix: "prévia",
  },
  challengeEngine: {
    apiError: "Erro na API",
    savePlayerError: "Falha ao salvar jogador no banco:",
    saveSideError: "Falha ao salvar preferência de lado no banco:",
    savePairError: "Falha ao salvar dupla no banco:",
    createTournamentError: "Falha ao criar torneio no banco:",
    finalizeTournamentError: "Falha ao finalizar torneio no banco:",
    loadDataError: "Falha ao carregar dados do banco:",
    requiresEvenPlayers: "É necessário um número par de jogadores.",
    unableToBuildPairs: "Não foi possível montar todas as duplas.",
    addEvenNumberAlert: "Adicione um número par de jogadores para sortear.",
    unresolvedSideAlert:
      "Não foi possível respeitar todos os lados. Algumas duplas ficaram do mesmo lado.",
    selectAtLeastOneSide: "Selecione pelo menos um lado (direita ou esquerda).",
    csv: {
      fileNamePrefix: "resultados",
      group: "Grupo",
      date: "Data",
      duration: "Duração",
      pos: "Pos",
      pair: "Dupla",
      matches: "Jogos",
      gamesWon: "Games ganhos",
      gamesLost: "Games perdidos",
      balance: "Saldo",
      wins: "Vitórias",
      losses: "Derrotas",
    },
    labels: {
      right: "Direita",
      left: "Esquerda",
      rightAndLeft: "Direita + Esquerda",
      sidePreferenceMissing: "Preferência não informada (ambos)",
      undefined: "Indefinido",
      challengeTitle: "DESAFIO TNP",
      challengeMode: "CHALLENGE",
      ranking: "Classificação",
      pos: "Pos",
      pair: "Dupla",
      matches: "Jogos",
      gamesWon: "Games ganhos",
      gamesLost: "Games perdidos",
      balance: "Saldo",
      wins: "Vitórias",
      losses: "Derrotas",
      registeredPairs: "Duplas cadastradas",
      registeredPlayers: "Jogadores cadastrados",
      registerPlayers: "Cadastro de Jogadores",
      buildPairs: "Montar Duplas",
      pairDrawMode: "Sorteio de duplas",
      documentPlaceholder: "Documento (CPF/DNI/CUIT)",
      fullNamePlaceholder: "Nome completo",
      save: "Salvar",
      player1Placeholder: "Documento ou Nome Jogador 1",
      player2Placeholder: "Documento ou Nome Jogador 2",
      add: "Adicionar",
      player1: "Jogador 1",
      player2: "Jogador 2",
      playerPlaceholder: "Documento ou Nome do Jogador",
      player: "Jogador",
      nonePairRegistered: "Nenhuma dupla cadastrada.",
      nonePlayerAdded: "Nenhum jogador adicionado.",
      nonePairDrawn: "Nenhuma dupla sorteada.",
      saveDrawPairs: "Salvar sorteio",
      savingDrawPairs: "Salvando sorteio...",
      drawPairsSaved: "Sorteio de duplas salvo com sucesso.",
      drawPairsSaveError: "Não foi possível salvar o sorteio de duplas.",
      pairNumber: "Dupla",
      sidePrefix: "Lado",
      openRegistrationsBeforeParticipants:
        "Abra as inscrições antes de adicionar participantes.",
      closeRegistrationsBeforeStructure:
        "Encerre as inscrições antes de gerar as chaves ou rodadas.",
      competitionAlreadyStarted:
        "A competição já foi iniciada ou encerrada.",
      generateStructureBeforeStart:
        "Gere as chaves ou rodadas antes de iniciar a competição.",
      remove: "Remover",
      drawPairs: "Sortear duplas",
      drawedPairs: "Duplas sorteadas",
      drawedPairsHint:
        "Confira as duplas sorteadas. Em seguida, gere as rodadas do grupo.",
      generateRounds: "Gerar rodadas do grupo",
      start: "Iniciar",
      finish: "Finalizar",
      round: "Rodada",
      pendingPair: "Dupla pendente",
      removedPair: "Resultado pendente",
      startMessage: "Cadastre duplas e gere as rodadas para começar.",
      startDrawMessage:
        "Cadastre jogadores, sorteie as duplas e gere as rodadas para começar.",
      startSuper8Message:
        "Cadastre 8 jogadores e gere as rodadas para começar.",
      adminLoginToPersist:
        "Para gravar no banco, faça login como admin (token tnp-token). Sem isso, fica salvo apenas neste navegador.",
      playerAlreadySelected:
        "Este jogador já foi selecionado e não pode entrar em mais de uma dupla.",
      sidePreferenceAria: "Preferência de lado",
      finishBeforeGeneratingRounds:
        "Finalize a partida antes de gerar novas rodadas.",
    },
    checkIn: {
      confirm: "Confirmar chegada",
      undo: "Desfazer chegada",
      present: "Presente",
      waitingArrival: "Aguardando chegada",
      waitingParticipants: "Aguardando participantes",
      waitingOpponents: "Aguardando adversários",
      readyToCall: "Pronto para chamada",
      confirmError: "Não foi possível confirmar a chegada.",
      undoError: "Não foi possível desfazer a chegada.",
    },
    courtStatus: {
      putOnCourt: "Colocar em Quadra",
      removeFromCourt: "Retirar da Quadra",
      onCourt: "Em Quadra",
      onCourtGames: "Jogos em Quadra",
      waiting: "Aguardando",
      finished: "Encerrado",
      addResult: "Adicionar Resultado",
      resultRequiresCourt: "Esta partida ainda não está em quadra.",
      resultRequiresCourtLong:
        "Não é possível adicionar o resultado porque esta partida ainda não está em quadra.",
      updateError: "Não foi possível atualizar o status da partida.",
      uncheckedParticipants: "Existem participantes sem check-in confirmado.",
      confirmStartWithUnchecked:
        "Existem participantes sem check-in confirmado.\n\nDeseja colocar esta partida em quadra mesmo assim?",
      undefinedParticipants:
        "Defina os participantes para colocar a partida em quadra.",
      courtCapacityWarning:
        "Há mais partidas em quadra do que quadras cadastradas.",
      registeredCourts: "quadras cadastradas",
      court: "Quadra",
    },
  },
  legal: {
    privacyPolicy: {
      title: "Política de Privacidade",
      commitmentTitle: "Compromisso do Usuário",
      moreInfoTitle: "Mais informações",
      effectiveDate: "Esta política é efetiva a partir de 11 April 2026 19:32.",
      lastUpdatedLabel: "Última atualização",
      lastUpdatedDate: "11 April 2026 19:32",
      introTitle: "Sua privacidade é importante",
      introDescription:
        "Nós respeitamos sua privacidade e explicamos abaixo como coletamos, usamos e protegemos seus dados.",
      collectionTitle: "Coleta de informações",
      usageTitle: "Uso das informações",
      storageSecurityTitle: "Armazenamento e segurança",
      dataSharingTitle: "Compartilhamento de dados",
      externalLinksTitle: "Links externos",
      userRightsTitle: "Direitos do usuário",
      questionsTitle: "Dúvidas sobre privacidade?",
      questionsText:
        "Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco.",
      contactCta: "Fale conosco",
      expandLabel: "Expandir seção",
      collapseLabel: "Recolher seção",
      paragraphs: [
        "A sua privacidade é importante para nós. É política do Todos no Padel respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site Todos no Padel, e outros sites que possuímos e operamos.",
        "Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.",
        "Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.",
        "Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.",
        "O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por suas respectivas __PRIVACY_LINK__.",
        "Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.",
        "O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contacto connosco.",
      ],
      commitmentIntro:
        "O usuário se compromete a fazer uso adequado dos conteúdos e da informação que o Todos no Padel oferece no site e com caráter enunciativo, mas não limitativo:",
      commitmentItems: [
        "A) Não se envolver em atividades que sejam ilegais ou contrárias à boa fé e à ordem pública.",
        "B) Não difundir propaganda ou conteúdo de natureza racista, xenofóbica, jogos de sorte ou azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os direitos humanos.",
        "C) Não causar danos aos sistemas físicos (hardwares) e lógicos (softwares) do Todos no Padel, de seus fornecedores ou terceiros, para introduzir ou disseminar vírus informáticos ou quaisquer outros sistemas de hardware ou software que sejam capazes de causar danos anteriormente mencionados.",
      ],
      moreInfoParagraph:
        "Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados, caso interaja com um dos recursos que você usa em nosso site.",
      privacyLinkLabel: "políticas de privacidade",
    },
    termsOfUse: {
      title: "Termos de Uso",
      lastUpdatedLabel: "Última atualização",
      lastUpdatedDate: "22 de junho de 2026",
      introTitle: "Bem-vindo ao Todos no Padel",
      introDescription:
        "Ao acessar nosso site e utilizar nossos serviços, você concorda com os termos e condições descritos abaixo.",
      introReadCarefully: "Leia com atenção antes de continuar.",
      questionsTitle: "Dúvidas?",
      questionsText:
        "Se você tiver alguma dúvida sobre estes Termos de Uso, entre em contato conosco através dos nossos canais oficiais.",
      contactCta: "Fale conosco",
      expandLabel: "Expandir seção",
      collapseLabel: "Recolher seção",
      sections: [
        {
          title: "1. Termos",
          paragraphs: [
            "Ao acessar ao site Todos no Padel, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis. Se você não concordar com algum desses termos, está proibido de usar ou acessar este site. Os materiais contidos neste site são protegidos pelas leis de direitos autorais e marcas comerciais aplicáveis.",
          ],
        },
        {
          title: "2. Uso de Licença",
          paragraphs: [
            "É concedida permissão para baixar temporariamente uma cópia dos materiais (informações ou software) no site Todos no Padel, apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, você não pode:",
            "Esta licença será automaticamente rescindida se você violar alguma dessas restrições e poderá ser rescindida por Todos no Padel a qualquer momento. Ao encerrar a visualização desses materiais ou após o término desta licença, você deve apagar todos os materiais baixados em sua posse, seja em formato eletrónico ou impresso.",
          ],
          items: [
            "Modificar ou copiar os materiais.",
            "Usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial).",
            "Tentar descompilar ou fazer engenharia reversa de qualquer software contido no site Todos no Padel.",
            "Remover quaisquer direitos autorais ou outras notações de propriedade dos materiais.",
            "Transferir os materiais para outra pessoa ou “espelhar” os materiais em qualquer outro servidor.",
          ],
        },
        {
          title: "3. Isenção de responsabilidade",
          paragraphs: [
            "Os materiais no site da Todos no Padel são fornecidos “como estão”. Todos no Padel não oferece garantias, expressas ou implícitas, e, por este meio, isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual ou outra violação de direitos.",
            "Além disso, o Todos no Padel não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ou à confiabilidade do uso dos materiais em seu site ou de outra forma relacionado a esses materiais ou em sites vinculados a este site.",
          ],
        },
        {
          title: "4. Limitações",
          paragraphs: [
            "Em nenhum caso o Todos no Padel ou seus fornecedores serão responsáveis por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro ou devido a interrupção dos negócios) decorrentes do uso ou da incapacidade de usar os materiais em Todos no Padel, mesmo que Todos no Padel ou um representante autorizado da Todos no Padel tenha sido notificado oralmente ou por escrito da possibilidade de tais danos. Como algumas jurisdições não permitem limitações em garantias implícitas, ou limitações de responsabilidade por danos consequentes ou incidentais, essas limitações podem não se aplicar a você.",
          ],
        },
        {
          title: "5. Precisão dos materiais",
          paragraphs: [
            "Os materiais exibidos no site da Todos no Padel podem incluir erros técnicos, tipográficos ou fotográficos. Todos no Padel não garante que qualquer material em seu site seja preciso, completo ou atual. Todos no Padel pode fazer alterações nos materiais contidos em seu site a qualquer momento, sem aviso prévio. No entanto, Todos no Padel não se compromete a atualizar os materiais.",
          ],
        },
        {
          title: "6. Links",
          paragraphs: [
            "O Todos no Padel não analisou todos os sites vinculados ao seu site e não é responsável pelo conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica endosso por Todos no Padel do site. O uso de qualquer site vinculado é por conta e risco do usuário.",
          ],
        },
        {
          title: "Modificações",
          paragraphs: [
            "O Todos no Padel pode revisar estes termos de serviço do site a qualquer momento, sem aviso prévio. Ao usar este site, você concorda em ficar vinculado à versão atual desses termos de serviço.",
          ],
        },
        {
          title: "Lei aplicável",
          paragraphs: [
            "Estes termos e condições são regidos e interpretados de acordo com as leis do Todos no Padel e você se submete irrevogavelmente à jurisdição exclusiva dos tribunais naquele estado ou localidade.",
          ],
        },
      ],
    },
  },
} as const;

export type SiteTexts = typeof siteTextsPt;

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T[K] extends object
      ? DeepPartial<T[K]>
      : T[K] extends string
        ? string
        : T[K] extends number
          ? number
          : T[K] extends boolean
            ? boolean
            : T[K];
};

const enOverrides: DeepPartial<SiteTexts> = {
  common: {
    loading: "Loading...",
    save: "Save",
    apply: "Apply",
    clear: "Clear",
    cancel: "Cancel",
    remove: "Remove",
    edit: "Edit",
    close: "Close",
    confirm: "Confirm",
    removing: "Removing...",
    backToProfile: "Back to profile",
    apiError: "API error",
    passwordVisibility: {
      show: "Show password",
      hide: "Hide password",
    },
    timePicker: {
      open: "Open time picker",
    },
    locationActions: {
      openMap: "Open location in maps",
      copyAddress: "Copy address",
      copied: "Address copied.",
      copyError: "Could not copy the address.",
    },
    infoTooltip: {
      ariaLabel: "View information",
    },
    info: {
      challengeModel:
        "TNP standard uses the platform's official rules. Custom lets you adjust players, courts and match format within limits.",
      tnpStandard: "TNP standard uses the official rules defined by the platform.",
      customChallenge:
        "Custom lets you adjust number of players, courts and match format while respecting minimum limits.",
      gameType: "Defines whether the match is controlled by games or by time.",
      byGames: "By games ends the match when the configured score is reached.",
      byTime: "By time shows a countdown timer on the match screen.",
      gameCount: "Number of games used to guide when the match ends.",
      gameDuration: "Duration of each game. The countdown timer uses this value.",
      courtsCount: "Number of courts available for simultaneous matches.",
      playersCount:
        "Total number of challenge players, respecting the selected model limits.",
      category:
        "The category is used to validate technical eligibility and organize registrations.",
      openCategory:
        "Open categories have no gender restriction, but still follow the category's technical rule.",
      ranking:
        "When enabled, the event counts points in the ranking according to TNP rules.",
      organizerRanking:
        "When enabled, the event counts points only in this organizer's own ranking.",
      eventShirts:
        "Enable shirts to let players choose sizes during registration.",
      shirtsByPeriod:
        "Shirts by period remain available only until the configured deadline.",
      shirtsByQuantity:
        "Shirts by quantity remain available until the configured limit runs out.",
      tournamentCategories:
        "Categories separate registrations, schedules and slots within the tournament.",
      tournamentFormat:
        "The format defines how tournament matchups will be organized.",
      groupStage:
        "Group stage organizes participants into groups before the elimination phase.",
      knockout:
        "Knockout eliminates participants as matchups advance.",
      americanSystem:
        "American system creates rotating matches to accumulate participant performance.",
      valuePerPlayer:
        "Amount charged per player. In fixed pair mode, the total considers both players.",
      slotLimit: "Maximum number of registrations available for this category.",
      categoryTime: "Expected time for the category within the event.",
      registrationCategory:
        "The category is validated according to your profile and the event rules.",
      fixedPair:
        "Fixed pair requires selecting or entering your partner before completing registration.",
      externalPayment:
        "External payment opens the payment provider outside the TNP platform.",
      pix: "PIX usually confirms faster, depending on the payment provider response.",
      credit:
        "Credit may include a method fee and depends on provider confirmation.",
      discountCoupon:
        "The coupon is applied to the registration total when valid.",
      shirt:
        "Registration remains available even when shirts are no longer available.",
      shirtUnavailable:
        "Shirt unavailable means the deadline passed or the configured limit ran out.",
      referral: "Indicate who invited you to join the event.",
      incompatibleCategory:
        "Incompatible category means the pair or athlete does not meet this category's rules.",
      modality: "Filters the ranking by the type of event considered.",
      period: "Defines the event window used in the ranking calculation.",
      allTime: "Always considers the full ranking history.",
      last4:
        "Last 4 stages considers only the four most recent events for the selected modality and category.",
      consideredStages:
        "Considered stages are the events used in the current point total.",
      countedEvents:
        "Counted events shows how many events entered the current calculation.",
      rankedAthletes:
        "Ranked athletes shows how many people appear in the current selection.",
      points:
        "Points are summed per person within the selected category.",
      tiebreakers:
        "In case of a tie, the system applies the tiebreaker criteria defined in the rules.",
      currentCategory:
        "Your current category defines which events you can register for.",
      rankingPosition:
        "Ranking position considers your current category in the overall ranking.",
      titles: "Titles count finished events won as champion.",
      runnerUps: "Runner-up finishes count finished events in second place.",
      categoryChange:
        "Category changes must be approved by the TNP team.",
      openRegistrations:
        "Opening registrations makes the event available for public registration.",
      closeRegistrations:
        "Closing registrations prevents new registrations without deleting existing records.",
      remove: "Remove deletes the selected item. Use only when you are sure.",
      eventStatus: "Status shows whether the event is pending, in progress or finished.",
      eventDateTime:
        "Date and time show when the event is scheduled to happen.",
      participants: "Participants are the players selected or registered for the event.",
      registrations: "Registrations are records received through the public form.",
      split:
        "Split defines how received amounts are divided between platform and organizer.",
      users: "Users are registered accounts with permissions and sports data.",
      userCategory: "User category is used to validate event registrations.",
      userRole: "User role defines access permissions in the system.",
      shareRanking: "Share ranking creates an image or link for the current selection.",
      shareResult: "Share result creates an image or link for the displayed result.",
      shareChampionship:
        "Share tournament uses the current tournament's public data.",
      downloadPng: "Download PNG saves the generated image to your device.",
      copyLink: "Copy link sends the current page URL to the clipboard.",
      methodFee: "Method fee varies according to the selected payment method.",
      subtotal: "Subtotal before discount and payment method fees.",
      registrationTotal:
        "Registration total after discount and method fee, when applicable.",
    },
    dateRange: {
      placeholder: "Select range",
      until: "to",
      openEnded: "...",
    },
    userAvatar: {
      sex: {
        female: "female",
        male: "male",
        other: "other",
        notInformed: "not informed",
      },
      customAltPrefix: "Profile photo of",
      defaultAltPrefix: "Default avatar",
      defaultAltConnector: "of",
      fallbackUser: "user",
    },
    searchInput: {
      clear: "Clear search",
    },
    pageSize: {
      ariaLabel: "Items per page",
      perPage: "{count} per page",
      all: "All",
    },
    filters: {
      allCategories: "All categories",
      allSexes: "Mixed",
    },
    sex: {
      notInformed: "Prefer not to say",
      male: "Male",
      female: "Female",
      other: "Other",
    },
    challengeGender: {
      male: "Men",
      female: "Women",
      mixed: "Mixed",
      open: "Open",
      maleShort: "Men",
      femaleShort: "Women",
    },
    category: {
      notInformed: "Not informed",
      c7a: "Beginner (7th)",
      c6a: "6th",
      c5a: "5th",
      c4a: "4th",
      c3a: "3rd",
      c2a: "2nd",
      open: "Open",
      free: "Free",
    },
    serverUnavailable: {
      title: "We couldn't connect to our server",
      description:
        "We are having trouble accessing the system right now. This may be temporary, please try again shortly.",
      actions: {
        retry: "Try again",
      },
      supportHint: "If the issue persists, please contact support.",
    },
    language: {
      label: "Language",
      modalTitle: "Choose your language",
      modalDescription:
        "Select how you want to browse the site. You can change it later in the header.",
      options: {
        pt: "Portuguese",
        en: "English",
        es: "Spanish",
      },
    },
  },
  header: {
    openMenu: "Open menu",
    closeMenu: "Close menu",
    nav: {
      about: "About",
      challenges: "Challenges",
      tournaments: "Tournaments",
      ranking: "Ranking",
      athletes: "Athletes",
      matches: "Matches",
      clubs: "Clubs",
      admin: "Admin",
      profile: "Profile",
      createAccount: "Create account",
      login: "Login",
      logout: "Log out",
    },
    hello: "Hello",
    fallbackPlayerName: "Player",
    notifications: {
      ariaLabel: "Open notifications",
      title: "Notifications",
      loading: "Loading notifications...",
      empty: "No notifications.",
      error: "Could not load notifications.",
      markAllRead: "Mark all as read",
      markRead: "Mark as read",
      removeAll: "Delete all",
      remove: "Delete",
      actions: {
        paymentPending: "Payment pending",
        payNow: "Pay now",
        registrationConfirmed: "Registration confirmed",
        viewRegistration: "View registration",
        viewGames: "View games",
        acceptInvite: "Accept invite",
        declineInvite: "Decline invite",
      },
    },
  },
  footer: {
    description: "Challenges, events, and a connected community.",
    instagramAriaLabel: "Todos no Padel Instagram",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
  },
  legal: {
    privacyPolicy: {
      title: "Privacy Policy",
      commitmentTitle: "User Commitment",
      moreInfoTitle: "More information",
      effectiveDate: "This policy is effective as of April 11, 2026 19:32.",
      lastUpdatedLabel: "Last updated",
      lastUpdatedDate: "April 11, 2026 19:32",
      introTitle: "Your privacy is important",
      introDescription:
        "We respect your privacy and explain below how we collect, use, and protect your data.",
      collectionTitle: "Information collection",
      usageTitle: "Use of information",
      storageSecurityTitle: "Storage and security",
      dataSharingTitle: "Data sharing",
      externalLinksTitle: "External links",
      userRightsTitle: "User rights",
      questionsTitle: "Privacy questions?",
      questionsText:
        "If you have any questions about this Privacy Policy, contact us.",
      contactCta: "Contact us",
      expandLabel: "Expand section",
      collapseLabel: "Collapse section",
      paragraphs: [
        "Your privacy is important to us. Todos no Padel respects your privacy regarding any information we may collect on this website and other websites we own and operate.",
        "We request personal information only when it is necessary to provide a service, using fair and lawful means, with your knowledge and consent.",
        "We retain collected information only for as long as necessary and protect stored data with commercially acceptable safeguards.",
        "We do not share personally identifiable information publicly or with third parties, except when required by law.",
        "Our website may contain links to external websites that are not operated by us. We have no control over those websites and cannot accept responsibility for their respective __PRIVACY_LINK__.",
        "You may refuse to provide personal information, understanding that some services may not be available.",
        "Continued use of our website will be considered acceptance of our privacy and personal information practices.",
      ],
      commitmentIntro:
        "The user agrees to make appropriate use of the content and information offered by Todos no Padel, including but not limited to:",
      commitmentItems: [
        "A) Not engage in illegal activities or activities contrary to good faith and public order.",
        "B) Not distribute racist, xenophobic, illegal pornographic, terrorism-related or human-rights-violating content.",
        "C) Not damage or attempt to damage the systems of Todos no Padel, its suppliers or third parties.",
      ],
      moreInfoParagraph:
        "If you are unsure whether a feature depends on cookies or related technologies, it is generally safer to keep them enabled while using the site.",
      privacyLinkLabel: "privacy policies",
    },
    termsOfUse: {
      title: "Terms of Use",
      lastUpdatedLabel: "Last updated",
      lastUpdatedDate: "June 22, 2026",
      introTitle: "Welcome to Todos no Padel",
      introDescription:
        "By accessing our website and using our services, you agree to the terms and conditions described below.",
      introReadCarefully: "Please read carefully before continuing.",
      questionsTitle: "Questions?",
      questionsText:
        "If you have any questions about these Terms of Use, contact us through our official channels.",
      contactCta: "Contact us",
      expandLabel: "Expand section",
      collapseLabel: "Collapse section",
      sections: [
        {
          title: "1. Terms",
          paragraphs: [
            "By accessing Todos no Padel, you agree to comply with these terms of service, applicable laws and regulations. If you disagree with any term, you may not use or access this website.",
          ],
        },
        {
          title: "2. License Use",
          paragraphs: [
            "Permission is granted to temporarily download one copy of the materials for personal, non-commercial viewing only.",
            "This license automatically terminates if you violate any restriction and may be terminated by Todos no Padel at any time.",
          ],
          items: [
            "Modify or copy the materials.",
            "Use the materials for commercial purposes or public display.",
            "Attempt to reverse engineer any software contained on the website.",
            "Remove copyright or ownership notices.",
            "Transfer or mirror the materials on another server.",
          ],
        },
        {
          title: "3. Disclaimer",
          paragraphs: [
            "The materials on Todos no Padel are provided as is. Todos no Padel makes no warranties, expressed or implied.",
          ],
        },
        {
          title: "4. Limitations",
          paragraphs: [
            "Todos no Padel and its suppliers are not liable for damages arising from the use or inability to use the website materials.",
          ],
        },
        {
          title: "5. Accuracy of materials",
          paragraphs: [
            "The materials may contain technical, typographical or photographic errors and may be changed without prior notice.",
          ],
        },
        {
          title: "6. Links",
          paragraphs: [
            "Todos no Padel is not responsible for the content of linked websites. Use of any linked website is at the user's own risk.",
          ],
        },
        {
          title: "Modifications",
          paragraphs: [
            "Todos no Padel may revise these terms at any time without prior notice. By using this website, you agree to the current version.",
          ],
        },
        {
          title: "Applicable law",
          paragraphs: [
            "These terms are governed by and interpreted according to applicable law.",
          ],
        },
      ],
    },
  },
  about: {
    subtitle: "Discover TNP's story and purpose.",
    storyAriaLabel: "TNP story",
    featuresAriaLabel: "TNP pillars",
    captions: { team: "Stephany and Raphael - Co-fundadores" },
    storyTitles: [
      "Passion that connects",
      "Active community",
      "Unique experiences",
      "Evolution and growth",
      "Padel for everyone",
    ],
    featureCards: [
      { title: "Recurring challenges", text: "with updated rankings" },
      { title: "In-person events", text: "and special tournaments" },
      { title: "Active community", text: "to improve at padel" },
      { title: "Curated experiences", text: "for the community" },
    ],
  },
  auth: {
    login: {
      title: "Login",
      subtitle: "Sign in to join challenges.",
      submit: "Sign in",
      error: "Login failed. Check your email/CPF and password.",
      footerCta: "Don’t have an account yet?",
      footerLink: "Create account",
      identifierLabel: "Email or CPF",
      passwordLabel: "Password",
    },
    register: {
      title: "Create account",
      subtitle: "Initial registration with name, email and password.",
      submit: "Create account",
      error: "Failed to create account. Check the data and try again.",
      invalidCpf: "Invalid CPF.",
      invalidPhone: "Enter the complete phone number with country and area codes.",
      footerCta: "Already have an account?",
      footerLink: "Sign in",
      nameLabel: "Name",
      emailLabel: "Email",
      cpfLabel: "CPF",
      phoneLabel: "Phone",
      passwordLabel: "Password",
      sexLabel: "Gender",
      categoryLabel: "Category",
    },
    forgotPassword: {
      title: "Recover password",
      link: "Forgot password",
      subtitle: "Enter your email or CPF to receive the instructions.",
      submit: "Send reset link",
      backToLogin: "Back to login",
      genericMessage:
        "If the information is registered, we will send an email with password reset instructions.",
      resetSuccess:
        "Password reset successfully. Sign in with your new password.",
    },
    resetPassword: {
      title: "Reset password",
      subtitle: "Create a new password to access your account.",
      submit: "Reset password",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      invalidToken: "Invalid or expired token.",
      minLength: "The new password must be at least {count} characters.",
      mismatch: "The passwords do not match.",
      success: "Password reset successfully. Sign in with your new password.",
      error: "Could not reset your password. Request a new link.",
    },
    confirmEmail: {
      title: "Confirm email",
      missingToken: "Confirmation token is missing.",
      success: "Email confirmed successfully.",
      error: "Could not confirm the email.",
      loading: "Confirming email...",
      goToProfile: "Go to profile",
    },
    context: {
      invalidSession: "Invalid session",
      hookOutOfScope: "useAuth must be used inside AuthProvider",
    },
  },
  paymentSuccess: {
    title: "Payment started",
    description:
      "We received your return. The official registration confirmation will be updated automatically through the Asaas webhook.",
    viewRegistrations: "View my registrations",
    backToChallenges: "Back to challenges",
  },
  publicPlayerProfile: {
    title: "Sports profile",
    subtitle: "Player public history on TNP.",
    categoryPrefix: "Category",
    categoryFallback: "Category not informed",
    notFound: "Profile not found.",
    loadError: "Could not load this profile.",
    openPhoto: "Enlarge player photo",
    photoDialogTitle: "Player photo",
    photoAlt: "Profile photo of {name}",
    shareProfile: "Share profile",
    shareTitle: "{name}'s sports profile",
    shareText: "Check {name}'s sports profile on Todos no Padel.",
    ranking: {
      title: "Current ranking",
      subtitle: "Best active position found.",
      empty: "This player does not have ranking points yet.",
      positionSuffix: "th place",
      pointsSuffix: "points",
      noPosition: "No position",
      myCategoryRanking: "My category",
      byTypeTitle: "Placement by type",
      openRanking: "Open ranking",
    },
    stats: {
      title: "Stats",
      subtitle: "Consolidated numbers from the sports history.",
      participations: "Participations",
      points: "Points",
      wins: "Wins",
      losses: "Losses",
      titles: "Titles",
      runnerUps: "Runner-ups",
      gamesBalance: "Balance",
    },
    achievements: {
      title: "Achievements",
      subtitle: "Badges unlocked by the player.",
      empty: "No public achievements unlocked.",
    },
    participations: {
      title: "Sports history",
      subtitle: "Events with registered results.",
      empty: "No public participation registered.",
    },
  },
  athletesPage: {
    title: "Athletes",
    subtitle: "Find registered TNP athletes.",
    searchPlaceholder: "Search by name",
    categoryFilter: "Category",
    allCategories: "All categories",
    sexFilter: "Sex",
    allSexes: "Mixed",
    empty: "No athletes found.",
    loadError: "Could not load athletes.",
  },
  clubs: {
    title: "Clubs",
    subtitle: "Find padel clubs to play, book courts and follow your highlights.",
    filtersLabel: "Club filters",
    searchPlaceholder: "Search club",
    cityFilter: "City",
    cityPlaceholder: "Enter city",
    stateFilter: "State",
    allStates: "All",
    listView: "List",
    mapView: "Map",
    useLocation: "Use my location",
    locationUnavailable: "Location could not be used on this device.",
    locationApplied: "Nearby clubs loaded.",
    locationDenied: "Location permission denied. Manual search remains available.",
    loadError: "Could not load clubs.",
    empty: "No clubs found.",
    noMapCoordinates: "No clubs in this search have coordinates registered.",
    requestClub: {
      action: "Add club",
      title: "Request club registration",
      subtitle:
        "Send the main details so we can review the club for the directory.",
      close: "Close club request",
      success: "Request sent. Our team will review the club.",
      error: "Could not send the club request.",
      saving: "Sending...",
      submit: "Send request",
      requiredHint: "Name, city and state are required.",
      contactHint:
        "Add a contact, website, Instagram, address or note to help us locate the club.",
      fields: {
        requesterName: "Your name",
        requesterEmail: "Your email",
        requesterPhone: "Your phone",
        clubName: "Club name",
        city: "City",
        state: "State",
        address: "Address",
        websiteUrl: "Website",
        instagramUrl: "Instagram",
        notes: "Notes",
      },
      placeholders: {
        requesterName: "How we can identify you",
        requesterEmail: "you@email.com",
        requesterPhone: "(00) 00000-0000",
        clubName: "Public club name",
        city: "Club city",
        state: "FL",
        address: "Street, number and district",
        websiteUrl: "https://...",
        instagramUrl: "@padelclub",
        notes: "Links, club contact or useful details",
      },
    },
    actions: {
      viewClub: "View club",
      instagram: "Instagram",
      booking: "Book court",
      lances: "View my highlights",
      directions: "Directions",
      site: "Website",
    },
    detail: {
      notFound: "Club not found.",
      back: "Back to clubs",
      tabs: {
        navigation: "Club sections",
        about: "About",
        location: "Address and map",
        contact: "Contact",
        matches: "Matches",
        events: "Events",
      },
      about: "About the club",
      noDescription: "This club does not have a description yet.",
      matchesTitle: "Upcoming matches at this club",
      noMatches: "There are no open matches published for this club yet.",
      viewAllMatches: "View all matches",
      createMatch: "Create match at this club",
      address: "Address",
      street: "Street",
      neighborhood: "Neighborhood",
      cityState: "City/state",
      zipCode: "ZIP code",
      contact: "Contact",
      phone: "Phone",
      whatsapp: "WhatsApp",
      email: "Email",
      noContact: "No public contact registered.",
      upcomingEventsTitle: "Upcoming events at the club",
      upcomingEventsSubtitle: "Challenges and tournaments scheduled at this venue.",
      loadingEvents: "Loading events...",
      noUpcomingEvents: "No upcoming events registered at this club.",
      dateFallback: "Date to be defined",
    },
  },
  openMatches: {
    title: "Matches",
    subtitle:
      "Find open spots, publish your booked court, and organize matches that fit each player profile.",
    loadError: "Could not load open matches.",
    emptyTitle: "No open matches found.",
    emptyDescription:
      "Adjust the filters or publish the first match in this area.",
    hero: {
      openCount: "Open",
      upcomingCount: "Next 7 days",
      clubCount: "Clubs with matches",
    },
    actions: {
      create: "Create match",
      createLogin: "Log in to create",
      viewDetails: "View details",
      edit: "Edit",
      openMap: "Open in maps",
      share: "Share",
      retry: "Try again",
      clearFilters: "Clear filters",
      showFilters: "Show filters",
      hideFilters: "Hide filters",
      closeModal: "Close",
    },
    filters: {
      searchPlaceholder: "Search by club, city, or organizer",
      date: "Date",
      club: "Club",
      city: "City",
      category: "Category",
      gender: "Gender",
      side: "Side",
      time: "Time",
      timeFromShort: "From",
      timeToShort: "To",
      timeFrom: "Start time from",
      timeTo: "Start time until",
      anyTime: "Any time",
      allClubs: "All clubs",
      allCities: "All cities",
      allCategories: "All categories",
      allGenders: "All genders",
      allSides: "All sides",
      availableOnly: "Open spots only",
    },
    card: {
      organizer: "Organizer",
      availableSlots: "spots available",
      filledSlots: "filled spots",
      estimatedPerPlayer: "per player",
      priceInfo:
        "The per-player amount depends on the number of confirmed players. With reserves, the split may change until the match is confirmed.",
      priceInfoAriaLabel: "Understand per-player amount",
      priceRangeSeparator: "to",
      approvalRequired: "Approval required",
      instantEntry: "Direct entry",
      organizerPlays: "Organizer plays",
      organizerOnly: "Organizer only",
      categories: "Categories",
      side: "Side",
      gender: "Preference",
      playersLabel: "players",
      slotsPreview: "Spots preview",
      emptySlot: "Open spot",
      pendingSlot: "To confirm",
      waitingList: "Reserves",
      waitingListOpen: "Reserves available",
      waitingListClosed: "No spots available",
      statusOpen: "Open",
      statusFull: "Full",
      statusApproval: "Approval required",
      statusCanceled: "Canceled",
      statusConfirmed: "Confirmed",
      statusFinished: "Finished",
    },
    results: {
      title: "Matches found",
      countSingular: "result",
      countPlural: "results",
      sortLabel: "Sort",
      sortRecent: "Most recent",
      sortUpcoming: "Upcoming dates",
      sortLowestPrice: "Lowest price",
      sortMostSpots: "Most spots",
    },
    detail: {
      notFound: "Match not found.",
      back: "Back to matches",
      club: "Club",
      viewClub: "View club details",
      map: "Map",
      sideRequirementAny: "Any side",
      leftSidePlayersNeeded: "left-side player(s)",
      rightSidePlayersNeeded: "right-side player(s)",
      responsibilityTitle: "Organizer responsibility",
      responsibilityNotice:
        "This match is organized by a player. Court booking and participant collection are not handled by TNP.",
      payment: "Payment",
      details: "Match details",
      notes: "Notes",
      description: "Description",
      schedule: "Date and time",
      location: "Location",
      slots: "Spots",
      categories: "Accepted categories",
      duration: "Duration",
      join: "I want to play",
      joinCourtAction: "I want to play",
      joinReserveAction: "Join as reserve",
      matchSoldOut: "Match full",
      joinLogin: "Log in to play",
      joinLoading: "Requesting...",
      joinPending: "Request sent to the organizer.",
      joinConfirmed: "Participation confirmed.",
      joinWaitlist: "Request sent.",
      canceledAlertTitle: "Match canceled",
      canceledAlertDescription:
        "This match was canceled by the organizer. Confirmed players were notified.",
      joinWaitlistAction: "I want to play",
      joinError: "Could not request participation.",
      joinCategoryBlocked: "Category not allowed.",
      fullNoWaitlist: "Match is full.",
      acceptInvite: "Accept invite",
      declineInvite: "Decline invite",
      declineInviteSuccess: "Invite declined.",
      confirmMatch: "Confirm match",
      confirmMatchLoading: "Confirming...",
      confirmMatchSuccess: "Match confirmed.",
      confirmMatchError: "Could not confirm the match.",
      confirmedMatchNotice: "Match confirmed by the organizer.",
      finishedMatchNotice: "This match time has ended.",
      confirmMatchBlocked: "This match cannot be confirmed right now.",
      participantsTitle: "Participants and requests",
      confirmedPlayersTitle: "Confirmed players",
      noConfirmedPlayers: "No confirmed players yet.",
      courtPlayersTitle: "Players on court",
      reservePlayersTitle: "Reserves",
      reservePlayersDescription:
        "Players who join the rotation during the match.",
      emptyCourtSlot: "Court spot",
      reserveSlot: "Reserve spot",
      noReserveSlots: "No reserves configured.",
      summaryTitle: "Summary",
      participantsSummary: "{filled} of {total} participants",
      onCourtSummary: "{count} on court",
      reserveSummary: "{count} reserves",
      courtVacancies: "{count} court spots",
      reserveVacancies: "{count} reserve spots",
      organizerNotice:
        "The organizer handles the court booking and payment collection.",
      organizerPlayer: "Organizer plays",
      manageParticipantsTitle: "Manage participants",
      noParticipants: "There are no participants in this match yet.",
      participantFallback: "Participant",
      participantNotRegistered: "Not registered",
      addParticipant: "Add participant",
      addParticipantLoading: "Adding...",
      addParticipantSuccess: "Participant added.",
      addParticipantError: "Could not add participant.",
      addParticipantType: "Participant type",
      addParticipantRegistered: "Registered athlete",
      addParticipantExternal: "External participant",
      addParticipantPlaceholder: "Filled spot",
      addParticipantName: "Participant name",
      addParticipantNamePlaceholder: "Name of who will play",
      addParticipantCpf: "CPF",
      addParticipantCpfPlaceholder: "Optional CPF",
      inviteSearch: "Search athlete",
      inviteSearchPlaceholder: "Type name or category",
      inviteAthlete: "Athlete",
      inviteSelect: "Select an athlete",
      inviteNoResults: "No athletes available.",
      invite: "Invite",
      inviting: "Inviting...",
      inviteSuccess: "Invite sent.",
      inviteError: "Could not send invite.",
      approveParticipant: "Confirm",
      waitlistParticipant: "Reserve",
      declineParticipant: "Decline",
      cancelParticipant: "Remove",
      cancelParticipantSelf: "Cancel participation",
      cancelParticipantLoading: "Canceling...",
      cancelParticipantSelfBlocked:
        "Cancellation is available until 4 hours before the match.",
      cancelParticipantSuccess: "Participation canceled.",
      cancelParticipantError: "Could not cancel the participation.",
      reviewSuccess: "Participant updated.",
      reviewError: "Could not update participant.",
      messageBoardTitle: "Conversation",
      noMessages: "No messages in this conversation yet.",
      messageLabel: "Message",
      messagePlaceholder: "Write to confirmed participants.",
      messageSend: "Send message",
      messageSending: "Sending...",
      messageError: "Could not send message.",
      messageReadOnly:
        "This conversation is closed. Messages will be available until {date}.",
      messageNoAccess:
        "The conversation is only visible to the organizer and confirmed players.",
      messageCharacters: "{count}/{limit}",
      messageRemoved: "Message removed",
      messageRemove: "Remove message",
      messageLoading: "Loading conversation...",
      messageSystemAuthor: "System",
      organizerBadge: "Organizer",
      participantStatuses: {
        invited: "Invited",
        pending: "To confirm",
        confirmed: "Participation confirmed",
        waitlist: "Reserve",
        declined: "Declined",
        canceled: "Canceled",
      },
    },
    form: {
      title: "Create match",
      subtitle:
        "Publish a new open match using a club that is already registered on TNP.",
      editTitle: "Edit match",
      editSubtitle:
        "Update your match details directly from the public list.",
      club: "Club",
      matchTitle: "Match name",
      matchTitlePlaceholder: "Ex.: Stephany's match",
      date: "Date",
      startTime: "Start",
      endTime: "End",
      duration: "Calculated duration",
      durationPending: "Enter start and end time",
      durationInvalid: "Invalid time range",
      totalPlayers: "Total players",
      initialParticipants: "Already filled spots",
      initialParticipantsHint:
        "Add confirmed registered athletes, external players, or simply block a spot.",
      editParticipants: "Add players",
      editParticipantsHint:
        "Add newly confirmed people to this match without changing existing players.",
      addInitialParticipant: "Add spot",
      noInitialParticipants: "No spot filled initially.",
      participantType: "Spot type",
      participantRegistered: "Registered athlete",
      participantExternal: "External participant",
      participantPlaceholder: "Filled spot without identification",
      participantSearch: "Search athlete",
      participantSearchPlaceholder: "Type name or category",
      participantSelect: "Select athlete",
      participantNoResults: "No athletes available.",
      participantNotRegistered: "Not registered",
      participantAlreadySelected: "This athlete has already been added.",
      participantName: "Name",
      participantCpf: "CPF",
      removeInitialParticipant: "Remove spot",
      categories: "Accepted categories",
      genderPreference: "Gender preference",
      sidePreference: "Side preference",
      leftPlayersCount: "Left-side players",
      rightPlayersCount: "Right-side players",
      sidePlayersTotalError:
        "Left and right-side players cannot exceed the configured total athletes.",
      totalPrice: "Total court cost",
      totalPricePlaceholder: "Optional",
      totalPriceHint: "Fill in only if you want to show an estimated split.",
      playerPrice: "Price per player",
      playerPricePlaceholder: "Optional",
      playerPriceHint: "Fill in only if each player pays a fixed amount.",
      priceMode: "Price type",
      pricePending: "To be defined",
      paymentMode: "Payment method",
      details: "Match details",
      detailsPlaceholder:
        "Add notes here about payment, level, meeting point, or any useful context for players.",
      paymentInstructions: "Payment instructions",
      description: "Description",
      notes: "Notes",
      organizerPlays: "I am also playing",
      approvalRequired: "Require approval to join",
      waitlistEnabled: "Allow reserves",
      responsibility:
        "I confirm that I am responsible for booking the court, organizing the match, and collecting payment from participants.",
      selectClub: "Select a club",
      clubSearchPlaceholder: "Type the club name, city, or address",
      clubNoResults: "No clubs found.",
      dateRequired: "Select a date for the match.",
      categoriesHint: "Choose one or more categories.",
      submit: "Publish match",
      submitting: "Publishing...",
      editSubmit: "Save changes",
      editSubmitting: "Saving...",
      cancelMatch: "Cancel match",
      cancelMatchSubmitting: "Canceling...",
      cancelMatchConfirm:
        "Are you sure you want to cancel this match? It will no longer appear in the public list.",
      cancelMatchSuccess: "Match canceled.",
      cancelMatchError: "Could not cancel the match.",
      success: "Match published successfully.",
      editSuccess: "Match updated successfully.",
      saveError: "Could not publish the match.",
      editError: "Could not update the match.",
    },
    options: {
      genderAny: "Any gender",
      genderFemale: "Female",
      genderMale: "Male",
      genderMixed: "Mixed",
      genderPreferFemale: "Preferably female",
      genderPreferMale: "Preferably male",
      sideAny: "Any side",
      sideLeft: "Looking for left side",
      sideRight: "Looking for right side",
      sideBoth: "Looking for both sides",
      sidePreferLeft: "Preferably left side",
      sidePreferRight: "Preferably right side",
      paymentOrganizer: "Pay organizer",
      paymentClub: "Pay club",
      paymentOnsite: "Pay on site",
      paymentPix: "Pay with Pix",
      paymentCustom: "To be arranged",
      paymentFree: "Free match",
      paymentUndefined: "Price TBD",
      priceModeCourt: "Per court",
      priceModePlayer: "Per player",
    },
  },
  home: {
    hero: {
      title: "Todos no Padel",
      subtitle:
        "We connect the community, create challenges and highlight the events that help padel grow.",
      ctaLabel: "View upcoming events",
      ctaLink: "#/desafios",
    },
    summary:
      "We are a padel-driven team organizing events and building community experiences.",
    heroKicker: "Community • Events • Performance",
    heroFallbackCta: "View challenges",
    loadingContent: "Loading content...",
    aboutFallbackTitle: "About TNP",
    aboutParagraphs: [
      "TNP - Todos no Padel was born from a passion for the sport and the desire to bring that energy to more people. More than playing, we believe padel can connect, challenge and transform people on and off court.",
      "We created TNP to build an active, welcoming and competitive community where players at different levels can evolve, challenge themselves and have fun.",
      "We promote experiences through formats such as Challenge, Super 8, Poço and Tournaments, designed to encourage integration, sportsmanship and constant evolution.",
      "Our goal goes beyond events: we want to spread padel, support the growth of the sport and help each player reach their next level.",
      "We believe padel is for everyone. Our invitation is simple: join this community.",
    ],
    aboutFallbackItems: [
      "Recurring challenges with updated rankings",
      "In-person events and special tournaments",
      "Selected experiences for the community",
      "An active community to evolve in padel",
    ],
    events: {
      title: "Upcoming events",
      subtitle: "Tournaments, special stages and community meetups.",
      empty: "No events registered at the moment.",
      fallbackTag: "Event",
      fallbackAddress: "Location to be defined",
      navAria: "Event navigation",
      moveLeft: "Move events left",
      moveRight: "Move events right",
    },
    clubs: {
      title: "Nearby clubs",
      subtitle:
        "Find clubs to play, book courts and follow the community around you.",
      nearbyTag: "Club",
      fallbackAddress: "Address to be defined",
      viewMore: "View more clubs",
      viewAll: "View all clubs",
    },
  },
  eventDetails: {
    loading: "Loading event details...",
    notFoundTitle: "Event not found",
    notFoundMessage: "This event is no longer available.",
    date: "Date",
    address: "Address",
    amountPerPlayer: "Amount per player",
    remainingSlots: "Remaining spots",
    details: "Details",
    howRegistrationWorks: "How does registration work?",
    paymentGuarantee: "Your spot is guaranteed after payment confirmation.",
    fallbackDate: "To be defined",
    fallbackAddress: "To be defined",
    loginToRegister: "Log in to register",
    registrationClosedButton: "Registrations opening soon",
    registrationClosedMessage:
      "Registrations for this event have not been released by the organizer yet.",
    categories: {
      toBeDefined: "To be defined",
    },
    challengeTypes: {
      super8: "Super 8",
      poco: "Poço",
      tournament: "Tournament",
      challenge: "Challenge",
    },
    registrationStatus: {
      pending: "Pending",
      confirmed: "Confirmed",
      waitlist: "Waitlist",
      canceled: "Canceled",
      none: "No registration",
    },
    paymentStatus: {
      pending: "Pending",
      confirmed: "Confirmed",
      canceled: "Canceled",
      refunded: "Refunded",
      toBeDefined: "To be defined",
      prefix: "Payment",
    },
    challengeStatus: {
      pending: "Starting soon",
      started: "In progress",
      finished: "Finished",
      canceled: "Canceled",
      event: "Event",
    },
    registrations: {
      title: "Registrations",
      sortedByPayment:
        "Sorted by payment confirmation; when missing, by registration update.",
      confirmedAtPrefix: "Payment confirmed on",
      confirmedFallbackCreatedAtPrefix:
        "Payment confirmed with no registered date. Registration updated on",
      confirmedNoDate: "Payment confirmed with no registered date",
    },
    loadingRegistrationStatus: "Loading your registration status...",
    loadingEventInfo: "Loading event information...",
    missingChallengeLink:
      "Registration will be available after the admin links this event to a challenge.",
  },
  eventRegistration: {
    fallback: {
      toBeDefined: "To be defined",
      player: "Player",
    },
    buttons: {
      backToEvents: "Back to events",
      unavailable: "Registration unavailable",
      confirmed: "Registration confirmed",
      confirmMyRegistration: "Confirm my registration",
      continueToPayment: "Continue to payment",
      openPaymentAgain: "Open payment again",
      viewMyRegistrations: "View my registrations",
      selectPartner: "Select",
      unavailablePartner: "Unavailable",
    },
    steps: {
      registration: "Registration",
      data: "Data",
      externalPayment: "External payment",
      confirmation: "Confirmation",
    },
    linkedChallengeMissing:
      "This event does not have a linked challenge yet. Ask the administrator to configure it.",
    registrationClosed:
      "Registrations have not been released by the organizer yet.",
    loadingEventInfo: "Loading event information...",
    loadingMyRegistration: "Updating your registration...",
    loadingPartners: "Loading players...",
    emptyPartners: "No players found.",
    removeSelectedPairError: "Could not remove the selected pair.",
    shirts: {
      deadlineClosed:
        "The shirt selection deadline has passed. You can still register without a shirt.",
      soldOut:
        "Available shirts are sold out. You can still register without a shirt.",
      availableCount: "{count} shirts available.",
      oneAvailable:
        "1 shirt is available. Choose it for one player or continue without a shirt.",
      onlyOneAvailable:
        "Only 1 shirt is available. Choose a shirt for one player or continue without a shirt.",
    },
    partnerCompatibility: {
      incompatiblePair: "This pair is incompatible with the selected category.",
      available: "Available",
      unavailable: "Unavailable",
      undefinedCategory: "Category not defined",
      incompatible: "Incompatible",
    },
    form: {
      registrationCategory: "Registration category",
      remainingSlots: "spots remaining",
      profileIncompatible: "incompatible with your profile",
      fixedPair: {
        title: "Your pair",
        searchLabel: "Search by name, email or phone",
        searchPlaceholder: "Search by name, email or phone",
        noCategory: "No category",
        introFemale: "Select a female player",
        introMale: "Select a male player",
        introAny: "Select a player",
        introWarning:
          "Could not find your partner? Ask them to finish their registration.",
        introCategoryPrefix: "from category",
      },
      drawPairSide: {
        noticeTitle: "Random pairs",
        notice: "Pairs for this challenge will be formed by draw.",
        question: "Which side do you prefer to play?",
        both: "I can play both sides",
        bothSummary: "Both",
        summaryLabel: "Side preference",
      },
      super8Notice:
        "Individual registration: you do not need to choose a partner to join this Super 8. Rounds are randomly drawn and everyone plays with everyone.",
      availabilityRestrictionTooltip:
        "Tell us if there is a period when you will not be able to play in this tournament.",
      availabilityRestrictionPeriodsLabel: "Unavailable periods",
    },
    summary: {
      title: "Registration summary",
      date: "Date",
      location: "Location",
      type: "Type",
      format: "Format",
      rule: "Rule",
      category: "Category",
      players: "Players",
      valuePerPlayer: "Amount per player",
      subtotal: "Subtotal",
      discount: "Discount",
      fee: "Payment method fee",
      total: "Registration total",
      fixedPair: "Fixed pair",
      individual: "Individual",
      super8Format: "Super 8",
      super8Rule: "Randomly drawn rounds • Everyone plays everyone",
      selectPair: "Select your pair",
    },
    paymentMethods: {
      title: "External payment",
      pixLabel: "PIX",
      creditLabel: "Card",
      note: "Additional fees are applied according to the selected method.",
    },
    discountCoupon: {
      label: "Discount coupon",
      placeholder: "Example: TNP10",
      apply: "Apply",
      applying: "Applying...",
      applied: "Coupon applied.",
      invalid: "Invalid coupon.",
      empty: "Enter the coupon code.",
      successPrefix: "Discount applied with",
    },
    checkout: {
      redirectingTitle: "Redirecting to secure payment...",
      redirectingText:
        "We are preparing your Asaas charge. A new tab will open shortly so you can choose PIX, card or boleto.",
      confirmedTitle: "Payment confirmed",
      confirmedText:
        "Asaas confirmed the payment and your registration is guaranteed.",
      pendingTitle: "Payment pending",
      pendingText:
        "Your registration was recorded. We are waiting for Asaas payment confirmation via webhook to secure your spot.",
    },
    status: {
      canceledPrefix: "Registration canceled",
      pendingPayment: "Registration pending payment.",
      fixedPairPrefix: "Fixed pair:",
      waitlistLabel: "Waitlist",
      waitlist:
        "You are on the waitlist. When a spot opens, the first confirmed payment is promoted.",
      waitlistConfirmation:
        "This competition is already full.\n\nYou can finish your registration and join the waitlist. Your queue position is guaranteed only after payment confirmation.\n\nIf a spot opens, paid registrations will be called by queue order.",
      paymentLinkPrefix: "Payment link:",
    },
    toasts: {
      openPaymentSuccess: "Payment opened in a new tab.",
      openPopupError: "Could not open a new tab. Allow pop-ups and try again.",
      checkoutStartError: "Could not start checkout right now.",
    },
    errors: {
      teammateCpfRequired: "Enter your fixed-pair partner CPF.",
      preferredSideRequired: "Select the side you prefer to play.",
      profileCategoryRequired:
        "Set your category in your profile to register for this challenge.",
      categoryMismatch: "You are not in this challenge category.",
      registrationCategoryRequired:
        "Select the registration category to continue.",
      fullNameRequired: "Enter the full name.",
      emailRequired: "Enter the email.",
      phoneInvalid: "Enter a valid WhatsApp/mobile number with area code.",
      taxIdInvalid: "Enter a valid CPF or CNPJ.",
    },
  },
  challenges: {
    hub: {
      title: "Challenges",
      subtitle: "Choose official TNP challenges or organizer challenges.",
      officialCard: {
        title: "Official TNP Challenges",
        description: "View official challenges published by the TNP circuit.",
        cta: "Explore Official",
        stats: {
          challenges: "Challenges",
          season: "Season",
          pending: "Upcoming",
        },
      },
      organizersCard: {
        title: "Organizer Challenges",
        description: "Explore challenges from partner organizers.",
        cta: "Explore Organizers",
        stats: {
          organizers: "Organizers",
          publishedChallenges: "Published challenges",
          inProgress: "Upcoming",
        },
      },
    },
    organizersDirectory: {
      title: "Select Organizer",
      subtitle: "Choose an organizer to open the corresponding challenges.",
      loading: "Loading organizers...",
      loadError: "Could not load organizers.",
      loadMoreError: "Could not load more organizers.",
      empty: "No organizers registered.",
      searchPlaceholder: "Enter organizer name",
      searchAriaLabel: "Search organizer by name",
      searchButtonAriaLabel: "Search organizer",
      loadMore: "Load more",
      loadingMore: "Loading...",
      sortLabel: "Sort by",
      sortOptions: {
        name: "Name A-Z",
        athletes: "Most players",
        challenges: "Most challenges",
        updated: "Recently updated",
      },
      selectedTitle: "Select an Organizer",
      selectedSubtitle: "Choose an organizer to view available challenges.",
      searchExpandedPlaceholder: "Search organizer, club or arena...",
      featuredTitle: "Most viewed",
      allTitle: "All organizers",
      emptySearch: "No organizers found.",
      official: "Official",
      athletes: "players",
      challenges: "challenges",
      viewChallenges: "View challenges",
      viewChallengesAriaPrefix: "View challenges from",
      openChallengesAriaPrefix: "Open challenges from",
      updatedToday: "Updated today",
      updatedAtPrefix: "Updated on",
      helpTitle: "Would you like to organize a tournament?",
      helpText: "Contact us by email:",
      stats: { finished: "finished", pending: "upcoming" },
    },
    publicList: {
      title: "Challenges",
      subtitle: "Find and follow upcoming challenges.",
      subtitleTournament: "Find and join upcoming padel tournaments.",
      searchPlaceholder: "Search by challenge or organizer name...",
      searchPlaceholderOfficial: "Search by challenge name...",
      searchPlaceholderTournament: "Search by tournament name...",
      searchAriaLabel: "Search challenges",
      filterGroups: {
        searchDate: "Search and date",
        general: "General",
        source: "Source",
        status: "Status",
        type: "Type",
      },
      titles: {
        organizers: "Organizer Challenges",
        organizerPrefix: "Challenges",
        organizerIdPrefix: "Organizer Challenges #",
        tournaments: "Tournaments",
        tnpTournaments: "TNP tournaments",
        organizerTournaments: "Organizer tournaments",
      },
      labels: {
        details: "View details",
        officialTnp: "Official TNP",
        viewAll: "View all",
        priceFallback: "Price to be defined",
        moreCategories: "categories",
        filledSlots: "filled spots",
        emptyTournaments: "No tournaments found.",
        partnerTournamentNoOfficialRanking:
          "This tournament is organized by a partner and does not count toward the Official TNP Ranking.",
        organizerRankingOnly:
          "This tournament counts only toward the organizer ranking.",
        empty: "No challenges found.",
        emptyTournament: "No tournaments in this section.",
        groupPrefix: "Group",
        organizerPrefix: "Organizer:",
        locationFallback: "Location to be defined",
        organizerFallback: "To be defined",
        countTournaments: "tournaments",
      },
      summaryCards: {
        upcomingChallenges: "Upcoming challenges",
        upcomingChallengesHint: "Starting in the next 7 days",
        availableSlots: "Available spots",
        availableSlotsHint: "Across all open challenges",
        finishedChallenges: "Finished challenges",
        finishedChallengesHint: "Completed in the period",
        totalAthletes: "Total players",
        totalAthletesHint: "Participating in challenges",
        activeTournaments: "Active tournaments",
        activeTournamentsHint: "Registrations open",
        upcomingTournaments: "Upcoming tournaments",
        upcomingTournamentsHint: "Next 30 days",
        registeredAthletes: "Registered players",
        registeredAthletesHint: "Across all tournaments",
        openCategories: "Open categories",
        openCategoriesHint: "Available categories",
      },
      filters: {
        all: "All",
        officialTnp: "Official TNP",
        organizers: "Organizers",
        organizer: "Organizer",
        city: "City",
        club: "Club/Venue",
        category: "Category",
        date: "Date",
        sort: "Sort",
        mostRecent: "Most recent",
        nearest: "Nearest",
        mostRegistered: "Most registered",
        pending: "Upcoming",
        started: "In progress",
        finished: "Finished",
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Poço",
        tournament: "Tournament",
      },
      tournamentSections: {
        officialTitle: "Official TNP Tournaments",
        officialSubtitle: "Events organized by the TNP circuit.",
        organizersTitle: "Organizer Tournaments",
        organizersSubtitle: "Events organized by our partners.",
      },
    },
    publicDetail: {
      statuses: {
        pending: "Upcoming",
        started: "In progress",
        finished: "Finished",
        canceled: "Canceled",
        undefined: "Upcoming",
      },
      shareAction: "Share",
      winnerShare: {
        athleteFallback: "TNP player",
        final: "FINAL",
        female: {
          title: "CHAMPIONS",
          championBadge: "CHAMPION PAIR",
          championSideTitle: "CHAMPIONS",
          runnerTitle: "RUNNERS-UP",
        },
        male: {
          title: "CHAMPIONS",
          championBadge: "CHAMPION PAIR",
          championSideTitle: "CHAMPIONS",
          runnerTitle: "RUNNERS-UP",
        },
        mixed: {
          title: "CHAMPION PAIR",
          championBadge: "MIXED CHAMPIONS",
          championSideTitle: "CHAMPIONS",
          runnerTitle: "RUNNER-UP PAIR",
        },
        neutral: {
          title: "CHAMPION PAIR",
          championBadge: "CHAMPION PAIR",
          championSideTitle: "CHAMPIONS",
          runnerTitle: "RUNNERS-UP",
        },
      },
      tournamentProgress: {
        statuses: {
          finished: "Finished",
          inProgress: "On court",
          scheduled: "Scheduled",
          pending: "Pending",
        },
        categoryFallback: "Category",
        group: "Group",
        qualifying: "Qualifying",
        roundOf32: "Round of 32",
        roundOf16: "Round of 16",
        quarterfinal: "Quarterfinal",
        semifinal: "Semifinal",
        final: "Final",
        knockout: "Knockout stage",
        startedPrefix: "Started",
        startedSuffix: " ago",
        lessThanMinute: "less than 1 min",
        courtFallback: "Court to be defined",
        imageError: "Could not generate the image.",
        tournamentFallback: "TNP Tournament",
        dateFallback: "Date to be defined",
        timeFallback: "Time to be defined",
        groupStage: "Group stage",
        noMatchInBracket: "No matchups generated for this bracket.",
        bracketsTitle: "Brackets",
        timelineTitle: "Tournament timeline",
        bracketsDescription:
          "Follow matchups, winners and upcoming matches by category.",
        timelineDescription: "View match order, times, courts and live status.",
        loading: "Loading tournament...",
        unpublishedTitle: "Bracket not published yet",
        unpublishedText: "The bracket will appear here once it is generated.",
        championPair: "Champion pair",
        finalPrefix: "Final:",
        generatingArtwork: "Generating artwork...",
        shareResult: "Share result",
        category: "Category",
        allCategories: "All categories",
        court: "Court",
        allCourts: "All courts",
        previousDayAria: "Previous day",
        nextDayAria: "Next day",
        noGames: "No matches found",
        timelineUnavailable: "Timeline has not been generated yet",
        filterHelp: "Adjust category, court or date filters to view matches.",
        timelineHelp: "The schedule will appear here once matches are set.",
        previewDialogAria: "Result preview",
        previewDescription: "1080x1920 Story artwork preview.",
        closePreviewAria: "Close preview",
        previewAlt: "Final result preview",
        share: "Share",
        downloadPng: "Download PNG",
        shareTitle: "TNP Result",
        winnerText: "won",
      },
      actions: {
        retry: "Try again",
        back: "Back",
      },
      labels: {
        locationFallback: "Location to be defined",
        playerFallback: "Player",
        pendingPair: "Pending pair",
        removedPair: "Result pending",
        toBeDefined: "To be defined",
        challengeFallback: "Challenge",
        categoryFallback: "Category",
        categoryFilterAria: "Filter registrations by category",
        format: "Format",
        groupStage: "Group stage",
        knockoutStage: "Knockout stage",
        moreInformation: "More information",
      },
      tabs: {
        ariaLabel: "Challenge sections",
        registrations: "Registrations",
        matches: "Matches",
        ranking: "Standings",
        brackets: "Brackets",
        eventSchedule: "Schedule",
        timeline: "Timeline",
      },
      eventSchedule: {
        title: "Tournament schedule",
        summaryTitle: "Day summary",
        dayTime: "Day time",
        activities: "Activities",
        gamesActivities: "Game activities",
        courts: "Courts and places",
        legend: "Legend",
        now: "Now",
        next: "Next activity",
        noLocation: "Location to be defined",
        noTime: "Time to be defined",
        timeSeparator: "to",
        activityTypes: {
          games: "Games",
          opening: "Opening",
          checkin: "Check-in",
          food: "Food",
          coffee: "Coffee",
          cake: "Cake",
          exercise: "Exercise",
          draw: "Draw",
          awards: "Awards",
          celebration: "Celebration",
          break: "Break",
          general: "General activity",
          other: "Other",
        },
      },
      states: {
        loadErrorFallback: "Could not load this challenge right now.",
        notFound: "Challenge not found.",
        canceledAlert:
          "This challenge was canceled. Registrations and matches were interrupted.",
        noRegistrations: "There are no registrations yet.",
        noRegistrationsText: "Be the first to secure your spot.",
        noMatchesGeneratedTitle: "Matches have not been generated yet",
        noMatchesGeneratedText:
          "Rounds will appear here as soon as the challenge starts.",
        noMatchesTitle: "No matches registered",
        noMatchesText: "Matchups will appear here when they are generated.",
        noRankingTitle: "Standings are not available yet",
        noRankingText:
          "Standings will be calculated automatically after matches start.",
        noRankingResultsTitle: "Waiting for results",
        noRankingResultsText:
          "Once matches are completed, the table will appear here.",
      },
      cta: {
        pendingTitle: "The challenge has not started yet",
        pendingTextSingle: "Secure your spot and get ready!",
        pendingTextFixedPair: "Secure your pair's spot and get ready!",
        registrationClosedTitle: "Registrations closed",
        registrationClosedButton: "Registrations closed",
        registrationClosedFooter:
          "Follow categories, brackets and upcoming matches on this page.",
        eventUnavailable: "Event not available yet",
        eventUnavailableFooter: "Waiting for the event link to register.",
        registrationStartedTitleSingle: "You already started your registration",
        registrationStartedTitleFixedPair:
          "You already started your pair registration",
        registrationStartedText: "Open your area to follow payment and status.",
        viewMyRegistration: "View my registration",
        followRegistration: "Follow registration",
        waitlistMe: "You are on the waitlist.",
        mobileRegister: "Register",
        goToEventSingle: "Go to event and register",
        goToEventFixedPair: "Go to event and register my pair",
        soldOutTitle: "Tournament sold out",
        soldOutText: "There are no new spots available right now.",
        soldOutButton: "Sold out",
        soldOutFooter: "Follow this page for updates.",
        waitlistTextSingle: "You can still join the waitlist.",
        waitlistTextFixedPair:
          "You can still join the waitlist with your pair.",
        waitlistButtonSingle: "Join waitlist",
        waitlistButtonFixedPair: "Join pair waitlist",
        waitlistFooter: "No immediate spots available.",
        availableSlotsPrefix: "Available spots:",
        registerAnotherCategory: "Register in another category",
        bracketsGeneratedTitle: "Brackets generated",
        bracketsGeneratedText:
          "Registrations have been organized and matchups are available.",
        bracketsGeneratedButton: "View brackets",
        bracketsGeneratedFooter: "Follow matches and progress by category.",
        finishedTitle: "Event finished",
        finishedText:
          "Registrations are closed and this event has already ended.",
        finishedFooter: "Check registrations, matches and standings below.",
      },
      registration: {
        title: "Registrations",
        introSingle: "See the players already registered for this challenge.",
        introFixedPair: "See the pairs already registered for this challenge.",
        showAll: "View all registrations",
        showLess: "Show less",
        myRegistrationPrefix: "My registration",
        paymentPrefix: "Payment",
        openPayment: "Open payment",
        table: {
          position: "Position",
          player: "Player",
          pair: "Pair",
          registeredAt: "Registered at",
          status: "Status",
        },
        statuses: {
          confirmed: "Confirmed",
          pendingPayment: "Pending",
          waitlist: "Waitlist",
          canceled: "Canceled",
          refunded: "Refunded",
          pending: "Pending",
        },
      },
      matches: {
        title: "Matches",
        round: "Round",
        group: "Group",
        final: "Final",
        matchResultAria: "Match result",
        champion: "Champion",
        loser: "Runner-up",
        awaitingResult: "Waiting for result",
        pointsSuffix: "pts",
        status: {
          finished: "Finished",
          partial: "Partial",
          waiting: "Waiting",
        },
      },
      myGames: {
        title: "My matches",
        description: "View every match you will play in this event.",
        closeAria: "Close My matches",
        category: "Category",
        yourPair: "Your pair",
        nextGame: "Next match",
        gamePrefix: "Match",
        loading: "Loading your matches...",
        loadError: "Could not load your matches.",
        retry: "Please try opening this again shortly.",
        tournamentEmpty: "Matches have not been defined yet.",
        challengeEmpty:
          "You are registered, but match times have not been defined yet.",
        emptyHelp: "They will appear here once the organizer publishes them.",
        roundOf32: "Round of 32",
        roundOf16: "Round of 16",
        quarterfinal: "Quarterfinal",
        semifinal: "Semifinal",
        final: "Final",
        roundPrefix: "Round",
        gameFallback: "Match",
        courtFallback: "Court to be defined",
        courtPrefix: "Court",
        dateFallback: "Date to be defined",
        timeFallback: "Time to be defined",
        waiting: "Waiting",
        inProgress: "In progress",
        finished: "Finished",
      },
      shareModal: {
        title: "Share tournament",
        description:
          "Show this tournament to more players and increase registrations.",
        closeAria: "Close sharing",
        dialogAria: "Share tournament",
        previewAlt: "Tournament artwork preview",
        generating: "Generating image...",
        unavailable: "Image unavailable.",
        copyLink: "Copy link",
        copy: "Copy",
        share: "Share",
        downloadPng: "Download PNG",
        linkLabel: "Tournament link",
        copied: "Link copied.",
        copyError: "Could not copy the link.",
        generateError: "Could not generate the image.",
        instagramHint:
          "Link copied. For Instagram or Stories, download the image and publish it in the app.",
        athleteFallback: "TNP player",
        categoryFallback: "Category defined",
        participating: "I'm participating",
        titleGoal: "And I'm going for the title!",
        alongsidePrefix: "Alongside",
        championship: "TOURNAMENT",
        date: "Date",
        location: "Location",
        availableSuffix: "available",
        perPlayerSuffix: "per player",
        playToo: "Come play too!",
        secureSpot: "Secure your spot and join this challenge!",
        tnpChampionship: "TNP TOURNAMENT",
        dateTime: "DATE AND TIME",
        organization: "Organizer",
        totalSlots: "Total spots",
        availableSlots: "Available spots",
        valuePerPlayer: "Amount per player",
        category: "Category",
        pairCta: "Secure your pair's spot and get ready!",
      },
      canvasUnavailable: "Canvas unavailable.",
      ranking: {
        title: "Standings",
        shareResults: "Share results",
        shareOk: "Link shared.",
        copyOk: "Link copied to clipboard.",
        shareError: "Could not share right now.",
        ariaLabel: "Challenge standings",
        rankHeader: "Pos",
        titleHeaderPlayer: "Player",
        titleHeaderPair: "Pair",
        columns: {
          total: "Total",
          roundShort: "R",
          final: "Final",
          matches: "Matches",
          matchesShort: "Matches",
          gamesWon: "Games won",
          gamesWonShort: "G+",
          gamesLost: "Games lost",
          gamesLostShort: "G-",
          balance: "Balance",
          balanceShort: "Balance",
          wins: "Wins",
          winsShort: "W",
          losses: "Losses",
          lossesShort: "L",
        },
      },
      about: {
        title: "About the challenge",
        titleTournament: "About the tournament",
        labels: {
          category: "Category",
          format: "Format",
          slots: "Available spots",
          registration: "Registration",
          expectedStart: "Expected start",
          location: "Location",
          type: "Type",
          howItWorks: "How does it work?",
          howItWorksText:
            "Matches and rounds will be generated automatically after the challenge starts.",
          availableSuffix: "available",
          registeredOf: "registered of",
          totalSlots: "Total spots",
          remainingSlots: "Spots available",
          perPlayer: "Per player",
          showMore: "View more",
          showLess: "Show less",
        },
      },
      format: {
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Poço",
        tournament: "Tournament",
      },
      mode: {
        individual: "Individual",
        fixedPair: "Fixed pair",
        players: "players",
        pairs: "pairs",
        registrationPerPlayerFixedPair: "per player (fixed pair)",
      },
    },
    publicTournamentProgress: {
      matchResultAria: "Result: {score}",
      sideResultAria: "Pair {side} result",
      matchesSuffix: "matches",
      status: {
        finished: "Finished",
        inProgress: "On court",
        scheduled: "Scheduled",
        pending: "Pending",
      },
      round: {
        group: "Group",
        groupStage: "Group stage",
        playIn: "Qualifier",
        roundOf32: "Round of 32",
        roundOf16: "Round of 16",
        quarterfinal: "Quarterfinals",
        semifinal: "Semifinal",
        final: "Final",
        knockout: "Knockout",
      },
      elapsed: {
        lessThanMinute: "Started less than 1 min ago",
        minutes: "Started {minutes} min ago",
        hoursMinutes: "Started {hours}h {minutes}min ago",
        hours: "Started {hours}h ago",
        daysHours: "Started {days}d {hours}h ago",
        days: "Started {days}d ago",
      },
      fallback: {
        category: "Category",
        court: "Court to be defined",
        side: "To be defined",
        date: "Date to be defined",
        time: "Time to be defined",
      },
      loadingTournament: "Loading tournament...",
      headers: {
        bracketsTitle: "Brackets",
        timelineTitle: "Tournament timeline",
        bracketsDescription:
          "Follow matchups, winners and next matches by category.",
        timelineDescription:
          "See match order, times, courts and status in real time.",
      },
      empty: {
        noBracketMatches: "No matchup generated for this bracket.",
        bracketTitle: "Bracket not published yet",
        bracketText:
          "The bracket will appear here when the organization generates the matchups.",
        noGamesTitle: "No matches found",
        timelineNotGeneratedTitle: "Timeline not generated yet",
        noGamesText:
          "Adjust the category, court or date filters to see scheduled matches.",
        timelineNotGeneratedText:
          "The schedule will appear here when matches are scheduled.",
      },
      champion: {
        label: "Champion pair",
        finalPrefix: "Final:",
      },
      actions: {
        shareResult: "Share result",
        generatingArt: "Generating artwork...",
        share: "Share",
        downloadPng: "Download PNG",
      },
      filters: {
        category: "Category",
        allCategories: "All categories",
        court: "Court",
        allCourts: "All courts",
        previousDay: "Previous day",
        nextDay: "Next day",
      },
      timeline: {
        scheduled: "Scheduled",
      },
      sharePreview: {
        ariaLabel: "Result preview",
        title: "Share result",
        description: "Story 1080x1920 artwork preview.",
        closeAria: "Close preview",
        imageAlt: "Final result preview",
        nativeTitle: "TNP Result",
        nativeText: "{champion} won {category}",
      },
      canvas: {
        imageError: "Could not generate the image.",
        unavailableCanvas: "Canvas unavailable.",
        championLabels: {
          female: {
            title: "CHAMPIONS",
            championBadge: "CHAMPION PAIR",
            championSideTitle: "CHAMPIONS",
            runnerTitle: "RUNNERS-UP",
          },
          male: {
            title: "CHAMPIONS",
            championBadge: "CHAMPION PAIR",
            championSideTitle: "CHAMPIONS",
            runnerTitle: "RUNNERS-UP",
          },
          mixed: {
            title: "CHAMPION PAIR",
            championBadge: "MIXED CHAMPIONS",
            championSideTitle: "CHAMPIONS",
            runnerTitle: "RUNNER-UP PAIR",
          },
          neutral: {
            title: "CHAMPION PAIR",
            championBadge: "CHAMPION PAIR",
            championSideTitle: "CHAMPION",
            runnerTitle: "RUNNER-UP",
          },
        },
        firstPlacePrefix: "1st",
        shareLine1: "SHARE",
        shareLine2: "YOUR WIN!",
        markInstagram: "TAG @TODOSNOPADEL",
        experienceLine1: "MORE THAN A TOURNAMENT,",
        experienceLine2: "AN EXPERIENCE!",
        socialLine: "◎  ♪  ▶  @TODOSNOPADEL",
        athleteFallback: "TNP Athlete",
      },
    },
    shareChampionship: {
      title: "Share championship",
      description:
        "Show this championship to more players and increase registrations.",
      closeAria: "Close sharing",
    },
  },
  profile: {
    user: {
      title: "User profile",
      subtitle: "Your account details.",
      emptyMessage: "You need to log in to access your profile.",
      goToLogin: "Go to login",
      saveError: "Failed to save profile data.",
      completeProfile: "Complete profile",
      roleLabels: { admin: "Admin", organizer: "Organizer", user: "Player" },
      unconfirmedEmail: "Email not confirmed",
      avatarAriaLabel: "Profile photo",
      editAvatarPhoto: "Edit photo",
      saveAvatarCrop: "Save crop",
      avatarSaveSuccess: "Profile photo updated successfully.",
      shareProfile: "Share profile",
      stats: {
        runnerUps: "Runner-up finishes",
        currentCategory: "Current category",
        rankingPosition: "Ranking position",
        memberSince: "Member since",
      },
      tabs: {
        profile: "My profile",
        security: "Security",
        challenges: "My events",
        registrations: "My registrations",
      },
      labels: {
        avatar: "Profile photo",
        personalInfo: "Personal information",
        name: "Name",
        email: "Email",
        cpf: "CPF",
        phone: "Phone",
        sex: "Gender",
        category: "Category",
        club: "Linked club",
        noClub: "No linked club",
        sidePreference: "Preferred side",
      },
      sidePreference: {
        both: "I play both sides",
        left: "I prefer left",
        right: "I prefer right",
      },
      cpfInfoAriaLabel: "Why can't I edit my CPF?",
      cpfInfo:
        "CPF cannot be edited by the user because it is sensitive data. Only administrators can change it.",
      categoryLocked:
        "Category already defined. To change it, send a request to the admin team.",
      loadingCategoryRequests: "Loading requests...",
      pendingCategoryRequestPrefix: "Pending request:",
      pendingCategoryRequestTo: "to",
      requestCategoryChange: "Request category change",
      noChanges: "No changes to save.",
      saveSuccess: "Data updated successfully.",
      outdatedServer:
        "Server is outdated. Restart the backend (`npm run server`) and try again.",
      cancel: "Cancel",
      saveChanges: "Save changes",
      saving: "Saving...",
      notProvided: "Not provided",
      dashboard: {
        stats: {
          matches: "Matches played",
          playedMatches: "Matches played",
          titles: "Titles won",
          runnersUp: "Runner-up finishes",
          category: "Current category",
          rankingPosition: "Ranking position",
          events: "Events played",
        },
        shareProfile: "Share profile",
        eventsTitle: "My events",
        eventsSubtitle: "Follow your journey at TNP.",
        overviewTitle: "User profile",
        overviewSubtitle: "Your account details.",
        personalInfo: "Personal information",
        memberSince: "Member since",
        requestReviewHint: "Your request will be reviewed by the TNP team.",
        requestApprovalHint: "The change will only apply after approval.",
        requestReason: "Request reason",
        selectRequestReason: "Select the request reason",
        observationOptional: "Notes (optional)",
        observationPlaceholder: "Add more details about your request...",
        searchEvent: "Search event",
        filtersAria: "Filters",
        eventStatusAria: "Event status",
        eventTypeAria: "Event type",
        eventEmpty: "No events found.",
        eventFilters: {
          all: "All",
          pending: "Upcoming",
          started: "In progress",
          finished: "Finished",
          tournaments: "Tournaments",
          challenge: "Challenge",
          super8: "Super8",
          poco: "Poço",
        },
        categoryReasons: [
          "Technical progress",
          "Performance reclassification",
          "Registration correction",
          "Organizer guidance",
          "Other reason",
        ],
        requestReasonRequired: "Select the request reason.",
        pendingRequest:
          "You already have a category change request under review.",
        share: {
          dialogAria: "Share profile",
          title: "Share profile",
          description: "1080x1920 Story artwork with your TNP journey.",
          closeAria: "Close sharing",
          previewAlt: "Profile artwork preview",
          generating: "Generating artwork...",
          unavailable: "Artwork unavailable.",
          share: "Share",
          downloadPng: "Download PNG",
          copyLink: "Copy link",
          generateError: "Could not generate the profile artwork.",
          copied: "Link copied.",
          copyError: "Could not copy the link.",
          shareTitle: "My TNP profile",
          directUnavailable:
            "Direct sharing is unavailable. The artwork was downloaded.",
          journey: "My TNP journey",
          sportsProfile: "SPORTS PROFILE",
          athleteFallback: "TNP player",
          categoryFallback: "Category not provided",
          rankingSuffix: "in the ranking",
          rankingProgress: "Ranking in progress",
          noRankingPosition: "No position",
          noRankingHint: "No points yet",
          rankingPositionLabel: "position",
          rankingStatusLabel: "status",
        },
      },
      achievements: {
        title: "Achievements",
        description: "Badges unlocked through your TNP journey.",
        loading: "Loading achievements...",
        loadError: "Could not load achievements.",
        unlockedCountPrefix: "Unlocked",
        unlockedAt: "Unlocked on",
        locked: "Locked",
        types: {
          athlete: "Athlete",
          organizer: "Organizer",
          event: "Event",
          ranking: "Ranking",
          participation: "Participation",
        },
      },
      notificationPreferences: {
        title: "Notification preferences",
        description: "Choose which alerts you want to receive inside TNP.",
        loading: "Loading preferences...",
        loadError: "Could not load preferences.",
        saveError: "Could not save preferences.",
        saveSuccess: "Preferences saved.",
        save: "Save preferences",
        saving: "Saving...",
        options: {
          inApp: "In-app notifications",
          email: "Email notifications",
          events: "Event notifications",
          ranking: "Ranking notifications",
          payments: "Payment notifications",
          achievements: "Achievement notifications",
        },
      },
      organizerStatistics: {
        title: "Organizer Statistics",
        description: "Track the performance of your events on TNP.",
        adminScope: "All organizers",
        loading: "Loading statistics...",
        loadError: "Could not load statistics.",
        emptyValue: "No data",
        emptyChart: "No data for this period.",
        dateFrom: "Start date",
        dateTo: "End date",
        invalidDateRange: "The end date must be after the start date.",
        periods: {
          all: "All time",
          current_year: "Current year",
          last_30: "Last 30 days",
          last_90: "Last 90 days",
          custom: "Custom period",
        },
        chartPeriods: {
          lastMonth: "Last month",
          lastSixMonths: "Last 6 months",
          lastYear: "Last year",
          allTime: "All time",
          allPeriods: "All periods",
        },
        cards: {
          completedEvents: "Completed events",
          futureEvents: "Future events",
          uniqueAthletes: "Unique athletes",
          totalRegistrations: "Total registrations",
          soldOutEvents: "Sold-out events",
          estimatedRevenue: "Estimated revenue",
          averageAthletes: "Average athletes per event",
          popularCategory: "Most popular category",
        },
        byTypeTitle: "Statistics by event type",
        internalRankingTitle: "Organizer internal ranking",
        eventTypes: {
          challenge: "Challenge",
          super8: "Super8",
          poco: "Poço",
          tournament: "Tournaments",
        },
        metrics: {
          completed: "Completed",
          registrations: "Registrations",
          average: "Average",
        },
        ranking: {
          mostParticipations: "Athlete with most participations",
          mostTitles: "Athlete with most titles",
          mostRecurring: "Most recurring athlete",
          topCategory: "Category with most registrations",
          topEvent: "Event with most registrations",
        },
        charts: {
          registrationsByMonth: "Registrations by month",
          revenueByMonth: "Estimated revenue by month",
          eventsByMonth: "Events by month",
          categories: "Most popular categories",
        },
        chartDescriptions: {
          registrationsByMonth: "Confirmed registrations grouped by month.",
          revenueByMonth:
            "Estimated revenue from confirmed registrations.",
          eventsByMonth: "Number of completed events in each month.",
          categories: "Categories with the highest registration volume.",
        },
        chartMetricLabels: {
          registrationsByMonth: "registrations per month",
          revenueByMonth: "estimated revenue per month",
          eventsByMonth: "events per month",
          categories: "registrations per category",
        },
        chartEmptyMessages: {
          insufficientData: "Not enough data to display this chart.",
          noData: "No data found for this period.",
          noRevenue: "No confirmed revenue for this period.",
        },
        chartNote:
          "Data is updated in real time as new events and registrations are recorded.",
      },
      organizerRanking: {
        title: "Organizer Ranking",
        description:
          "Define the scoring table used only in rankings for your events.",
        info:
          "The official TNP Ranking always uses the platform's official scoring. This setting changes only this organizer's own ranking.",
        scoringMode: "Scoring mode",
        modes: {
          tnp_standard: "TNP standard",
          duplicate: "Duplicate TNP standard",
          custom: "Custom",
        },
        modeDescriptions: {
          tnp_standard: "Uses the official scoring without edits.",
          custom: "Allows editing the scoring for your events.",
        },
        modalities: {
          super8: "Super 8",
          challenge: "Challenge",
          poco: "Poço",
          tournament: "Tournaments",
        },
        fields: {
          first: "1st place",
          second: "2nd place",
          third: "3rd place",
          fourth: "4th place",
          fifth: "5th place",
          sixth: "6th place",
          seventh: "7th place",
          eighth: "8th place",
          participation: "Participation",
          champion: "Champion",
          runnerUp: "Runner-up",
          semifinal: "Semifinal",
          quarterfinal: "Quarterfinal",
        },
        loading: "Loading scoring...",
        save: "Save scoring",
        saving: "Saving...",
        restoreDefault: "Restore TNP standard",
        restoreConfirm:
          "Do you want to restore TNP standard mode? Your custom scoring will no longer be used.",
        duplicateOfficial: "Duplicate official TNP scoring",
        duplicateAgain: "Duplicate from TNP again",
        duplicatedNotice:
          "This table was created from the official TNP scoring. It can now be changed without affecting the official ranking.",
        replaceConfirm:
          "Do you want to replace your current scoring with the official TNP scoring?",
        validationError: "Enter valid scoring.",
        loadError: "Could not load organizer scoring.",
        saveError: "Could not save organizer scoring.",
        saveSuccess: "Organizer scoring saved.",
        resetSuccess: "Scoring restored to TNP standard.",
      },
      visualIdentity: {
        title: "Visual Identity",
        description: "Customize the colors used in your event materials.",
        info:
          "The settings in this section are used only for events organized by you. The rest of the platform keeps using the official TNP identity.",
        logoTitle: "Organizer logo",
        publicName: "Public organizer name",
        publicNamePlaceholder: "Name displayed in the showcase",
        logoDescription:
          "Use a PNG, JPG, JPEG, or WEBP image up to 2MB.",
        logoHelp:
          "The logo is saved to your profile and can be reused in events organized by you.",
        logoPreviewAlt: "Organizer logo preview",
        uploadLogo: "Upload logo",
        replaceLogo: "Replace logo",
        removeLogo: "Remove logo",
        invalidLogo: "Upload a valid PNG, JPG, JPEG, or WEBP image.",
        logoTooLarge: "The logo must be 2MB or less.",
        logoInvalidDimensions:
          "The logo width and height must be between 64 and 4096 pixels.",
        mode: "Identity mode",
        backgroundNotice:
          "Choose the background used on your events' public screens.",
        backgroundTitle: "Screen background",
        backgrounds: {
          blue: "Blue (default)",
          black: "Black",
          white: "White",
        },
        modes: {
          tnp_standard: "TNP standard",
          custom: "Custom",
        },
        modeDescriptions: {
          tnp_standard:
            "Uses TNP official colors in materials for your events.",
          custom:
            "Allows choosing your own colors for materials and screens linked to your events.",
        },
        fields: {
          primaryColor: "Primary color",
          secondaryColor: "Secondary color",
          accentColor: "Accent color",
        },
        usage: {
          primaryColor:
            "Used for buttons, links, titles, main icons, and progress bars.",
          secondaryColor:
            "Used for gradients, cards, secondary buttons, and badges.",
          accentColor:
            "Used for champion highlights, timer, alerts, last spots, visual emphasis, and glow.",
        },
        previewTitle: "Visual identity preview",
        previewRanking: "Organizer Ranking",
        previewShare: "Share Ranking",
        previewPlayers: ["John Silva", "Maria Souza", "Pedro Lima"],
        hexPlaceholder: "#2B9CDF",
        loading: "Loading visual identity...",
        save: "Save identity",
        saving: "Saving...",
        restoreDefault: "Restore TNP standard",
        validationError: "Use valid HEX colors in the #2B9CDF format.",
        contrastWarning:
          "This combination may make text harder to read. We recommend using colors with stronger contrast.",
        loadError: "Could not load the visual identity.",
        saveError: "Could not save the visual identity.",
        saveSuccess: "Visual identity saved.",
        resetSuccess: "Visual identity restored to TNP standard.",
      },
      categoryRequest: {
        title: "Request category change",
        newCategory: "New desired category",
        selectCategory: "Select a category",
        reason: "Reason (optional)",
        reasonLabel: "Request reason",
        reasonSelectPlaceholder: "Select the request reason",
        reasonSelectShortPlaceholder: "Select the reason",
        observation: "Note (optional)",
        observationPlaceholder: "Add more details about your request...",
        modalObservationPlaceholder: "Type a note to help with the review.",
        reviewHint: "Your request will be reviewed by the TNP team.",
        approvalHint: "The change is applied only after approval.",
        currentUserCategory: "User current category",
        reasonPlaceholder: "Briefly explain the reason for the change.",
        observationPrefix: "Note:",
        sending: "Sending...",
        submit: "Send request",
        categoryRequired: "Select the desired category.",
        differentCategory:
          "The requested category must be different from the current one.",
        success: "Request sent for administrator review.",
        error: "Could not send the request.",
        historyEyebrow: "History",
        historyTitle: "Request history",
        historyEmpty: "No category change requests registered.",
        historyTo: "to",
        requestedAt: "Requested on",
        resolvedAt: "Answered on",
        adminResponse: "Administrator response",
        noAdminResponse: "The request was rejected without an additional message.",
        statuses: {
          pending: "Pending",
          approved: "Accepted",
          rejected: "Rejected",
        },
      },
      security: {
        description: "Password change and access settings.",
        emailTitle: "Access email",
        pendingEmailPrefix: "Email pending confirmation:",
        generatingLink: "Resending...",
        confirmEmail: "Resend confirmation email",
        updateEmail: "Update email",
        emailSaving: "Saving...",
        emailUpdated: "Email updated.",
        emailUpdateError: "Could not update the email.",
        emailRequestRegisteredPrefix:
          "Request registered. We sent a confirmation email to:",
        confirmationLinkSuccess: "Confirmation email resent.",
        confirmationLinkError: "Could not resend the confirmation email.",
        passwordTitle: "Change password",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmNewPassword: "Confirm new password",
        passwordUpdating: "Updating password...",
        updatePassword: "Update password",
        passwordRequired: "Enter the current password and the new password.",
        passwordMinLength: "The new password must have at least 4 characters.",
        passwordMismatch: "The new password confirmation does not match.",
        passwordUpdated: "Password changed successfully.",
        passwordUpdateError: "Could not change the password.",
      },
      challenges: {
        matchesSuffix: "matches",
        viewDetails: "View details",
        openMap: "Open location in maps",
        copyLocation: "Copy address",
        locationCopied: "Address copied.",
        copyLocationError: "Could not copy the address.",
        empty: "No challenges in this section.",
        paginationAria: "Events pagination",
        previousPage: "Previous page",
      },
    },
    myGames: {
      title: "Tournament and challenge games",
      subtitle:
        "Track your tournament and challenge games, times, courts, and results.",
      empty: "No games found.",
      loadError: "Could not load your games.",
      modalSubtitle: "Games released for this registration.",
      closeModal: "Close games",
      upcomingTitle: "Upcoming games",
      confirmedOpenMatchesTitle: "Confirmed open matches",
      historyTitle: "History and results",
      noUpcoming: "You do not have upcoming scheduled games.",
      noConfirmedOpenMatches: "No open match confirmed by the organizer.",
      openMatchConfirmed: "Participation confirmed by the organizer",
      noHistory: "No published results yet.",
      categoryFallback: "Category",
      courtFallback: "Court to be confirmed",
      viewTournament: "View tournament",
      scorePending: "Result pending",
      unscheduled: "Time to be confirmed",
      result: {
        win: "Win",
        loss: "Loss",
        finished: "Finished",
        pending: "Pending",
      },
    },
    openMatches: {
      title: "Open matches",
      subtitle:
        "Manage matches you created and track your invites and requests.",
      empty: "No open matches found.",
      emptyHint:
        "When you create or join an open match, it will appear here.",
      loadError: "Could not load your open matches.",
      groupEmpty: "No matches in this section.",
      view: "View match",
      edit: "Edit",
      updateSuccess: "Match updated.",
      clubFallback: "Club to be confirmed",
      slotsSuffix: "available spots",
      requestsTitle: "Requests and invites",
      groups: {
        created: "Created by me",
        confirmed: "Confirmed",
        invites: "Invites",
        pending: "Pending requests",
        waitlist: "Reserves",
        history: "History",
        canceled: "Canceled",
      },
    },
    registrations: {
      title: "My registrations",
      subtitle: "Track the status of your event registrations.",
      filters: {
        all: "All",
        confirmed: "Confirmed",
        pending: "Pending",
        waitlist: "Waitlist",
        canceled: "Canceled",
        overdue: "Overdue",
      },
      statuses: {
        confirmed: "Confirmed",
        pending: "Pending",
        waitlist: "Waitlist",
        canceled: "Canceled",
        overdue: "Overdue",
      },
      hints: {
        confirmedDefault: "Payment confirmed",
        confirmedAtPrefix: "Paid on",
        waitlistDefault: "Waiting for an available spot",
        waitlistPaid: "Payment confirmed, waiting for a spot",
        overdueDefault: "Charge overdue",
        overdueAtPrefix: "Overdue on",
        canceledDefault: "Registration canceled",
        canceledAtPrefix: "Canceled on",
        pendingPairPrefix: "Waiting for pair payment",
        pendingDefault: "Waiting for payment confirmation",
      },
      mode: {
        individual: "Individual",
        fixedPair: "Pair",
      },
      actions: {
        payNow: "Pay now",
        viewGames: "View games",
        viewDetails: "View details",
        cancel: "Cancel registration",
        remove: "Delete registration",
        canceling: "Canceling...",
        removing: "Removing...",
      },
      filtersAriaLabel: "Registration filters",
      toasts: {
        cancelSuccess: "Registration canceled.",
        cancelError: "Could not cancel the registration.",
        deleteSuccess: "Registration removed from your list.",
        deleteError: "Could not remove the registration.",
      },
      teammatePrefix: "You and",
      empty: "No registrations found.",
      emptyByFilter: "No registrations for this filter.",
    },
  },
  ranking: {
    hub: {
      title: "Rankings",
      subtitle: "Track player and organizer progress in TNP.",
      officialCard: {
        title: "Official TNP Ranking",
        description: "Follow the overall ranking of all TNP circuit players.",
        cta: "View Ranking",
        stats: {
          players: "Players",
          season: "Season",
          continuousUpdateLine1: "Continuous",
          continuousUpdateLine2: "update",
        },
      },
      organizersCard: {
        title: "Organizer Rankings",
        description: "Explore custom rankings from partner organizers.",
        cta: "Explore Organizers",
        stats: {
          organizers: "Organizers",
          players: "Players",
          events: "Events",
        },
      },
    },
    organizersDirectory: {
      title: "Select Organizer",
      subtitle: "Choose an organizer to open the corresponding ranking.",
      loading: "Loading organizers...",
      loadError: "Could not load organizers.",
      loadMoreError: "Could not load more organizers.",
      empty: "No organizers registered.",
      searchPlaceholder: "Enter organizer name",
      searchAriaLabel: "Search organizer by name",
      searchButtonAriaLabel: "Search organizer",
      loadMore: "Load more",
      loadingMore: "Loading...",
      sortLabel: "Sort by",
      sortOptions: {
        name: "Name A-Z",
        athletes: "Most players",
        events: "Most events",
        updated: "Recently updated",
      },
      selectedTitle: "Select a Ranking",
      selectedSubtitle:
        "Choose an organizer or club to view the corresponding ranking.",
      searchExpandedPlaceholder: "Search organizer, club or arena...",
      featuredTitle: "Most viewed",
      allTitle: "All organizers",
      emptySearch: "No rankings found.",
      rankingCountSuffix: "rankings",
      athletes: "players",
      events: "events",
      viewRanking: "View ranking",
      viewRankingAriaPrefix: "View ranking for",
      openRankingAriaPrefix: "Open ranking for",
      updatedAtPrefix: "Updated on",
    },
    page: {
      modeTabs: {
        all: "Overall",
        super8: "Super8",
        challenge: "Challenge",
        poco: "Poço",
        tournament: "Tournament",
      },
      sourceTabs: { official: "Official", organizer: "Organizers" },
      categoryTabs: {
        open: "Open",
        c2a: "2nd",
        c3a: "3rd",
        c4a: "4th",
        c5a: "5th",
        c6a: "6th",
        c7a: "Beginner",
      },
      labels: {
        source: "Source",
        modality: "Modality",
        organizer: "Organizer",
        allOrganizers: "All",
        disabledOrganizerOption: "—",
        category: "Category",
        period: "Period",
        points: "Points",
        scoringStandard: "Scoring standard",
        uncategorized: "Uncategorized",
        rank: "Pos",
        name: "Name",
        filters: "Filters",
        moreInformation: "More information",
        mobileControls: "Filter and information controls",
        dateFrom: "Start date",
        dateTo: "End date",
        consideredStages: "Included stages",
        selectAll: "Select all",
        stageFallback: "Stage",
      },
      periodOptions: {
        allTime: {
          label: "Always",
          description: "Complete historical ranking",
        },
        last4: {
          label: "Last 4 stages",
          description: "Considers only the last 4 stages",
        },
        last8: {
          label: "Last 8 stages",
          description: "Considers only the last 8 stages",
        },
        last30: {
          label: "Last 30 days",
          description: "Considers events from the last 30 days",
        },
        last90: {
          label: "Last 90 days",
          description: "Considers events from the last 90 days",
        },
        currentYear: {
          label: "Current year",
          description: "Considers events from the current year",
        },
        custom: {
          label: "Custom",
          description: "Choose a specific period",
        },
      },
      summaryCards: {
        leader: "Current Leader",
        noLeader: "No leader",
        waitingRanking: "Waiting for ranking",
        countedEvents: "Counted Events",
        allHistory: "All history",
        periodEvents: "Events in period",
        rankedAthletes: "Ranked Players",
        currentSelection: "In the current selection",
        currentPeriod: "Current Period",
      },
      messages: {
        noOrganizerRankings: "There are no organizer rankings to display yet.",
        hint: "The ranking sums points per person within the selected category.",
        availableCategoriesOnly:
          "Only categories with published ranking data are shown. The others do not have available data yet.",
        customScoringInfo:
          "This ranking uses a scoring table configured by the organizer and may differ from the official TNP Ranking.",
        empty: "No completed results for this category.",
        loadError: "Could not load the ranking.",
        historyLoadError: "Could not load the player's history.",
        genderTooltip:
          "Filter the ranking by gender: all, female or male.",
        invalidDateRange: "The end date must be after the start date.",
        noStagesForPeriod: "No stages found for this period.",
        viewHistoryPrefix: "View sports history for",
        athleteFallback: "player",
        emptyFinishedTitle: "No completed results",
        emptyFinishedHint:
          "Adjust the filters or wait for events in this category to finish.",
        historyAriaPrefix: "History for",
        historyTitle: "Sports history",
        closeHistory: "Close history",
        emptyHistory:
          "This player does not have any registered participations in this ranking yet.",
      },
      titleFallbacks: {
        ranking: "Ranking",
        organizerRanking: "Organizer Ranking",
        organizerById: "Organizer Ranking #",
      },
      ariaLabel: "Overall ranking",
    },
    shareModal: {
      shareAction: "Share",
      title: "Share ranking",
      closeAria: "Close sharing",
      previewAlt: "Ranking artwork preview",
      generatingImage: "Generating image...",
      imageUnavailable: "Image unavailable.",
      whatsapp: "WhatsApp",
      instagramStories: "Instagram/Stories",
      copyLink: "Copy link",
      downloadImage: "Download image",
      copiedLink: "Link copied.",
      copyError: "Could not copy the link.",
      generateError: "Could not generate the ranking image.",
      directUnavailable: "Direct sharing is unavailable. The image was downloaded.",
      storiesHint:
        "For Stories, download the image and publish it on Instagram.",
      shareTitle: "TNP Ranking",
      shareTextPrefix: "Check out the Ranking",
      athleteFallback: "Athlete",
      canvas: {
        positionLabel: "YOUR POSITION",
        currentUserTop: "You are in {position}º place!",
        topCategoryMessage: "Congrats on being among the best in the category!",
        pointsSuffix: "pts",
        unavailableCanvas: "Canvas unavailable.",
        imageError: "Could not generate the image.",
      },
    },
  },
  imageUpload: {
    change: "Change",
    edit: "Edit",
    remove: "Remove",
    noImageSelected: "No image selected.",
    helpText:
      "PNG/JPG recommended. In the modal, use scroll or the zoom control and drag to reposition.",
    cropTitle: "Photo adjustment",
    horizontalAdjust: "Horizontal adjustment",
    verticalAdjust: "Vertical adjustment",
    applyCrop: "Apply crop",
    cropError:
      "Could not crop this image. Try changing it to a local JPG/PNG file.",
    selectImageFor: "Select image for",
    cropImageOf: "Photo adjustment for",
    previewSuffix: "preview",
  },
  challengeEngine: {
    labels: {
      right: "Right",
      left: "Left",
      rightAndLeft: "Right + Left",
      sidePreferenceMissing: "Side preference not informed (both)",
      registeredPlayers: "Registered players",
      playerPlaceholder: "Document or Player Name",
      player: "Player",
      nonePairDrawn: "No pairs drawn.",
      saveDrawPairs: "Save draw",
      savingDrawPairs: "Saving draw...",
      drawPairsSaved: "Pair draw saved successfully.",
      drawPairsSaveError: "Could not save the pair draw.",
      pairNumber: "Pair",
      sidePrefix: "Side",
      openRegistrationsBeforeParticipants:
        "Open registrations before adding participants.",
      closeRegistrationsBeforeStructure:
        "Close registrations before generating brackets or rounds.",
      competitionAlreadyStarted:
        "The competition has already started or finished.",
      generateStructureBeforeStart:
        "Generate brackets or rounds before starting the competition.",
      remove: "Remove",
      drawPairs: "Draw pairs",
      drawedPairs: "Drawn pairs",
      drawedPairsHint:
        "Review the drawn pairs. Then generate the group rounds.",
      generateRounds: "Generate group rounds",
      startSuper8Message:
        "Add 8 players and generate the rounds to start.",
      adminLoginToPersist:
        "To save to the database, sign in as admin (token tnp-token). Otherwise, it is saved only in this browser.",
      playerAlreadySelected:
        "This player has already been selected and cannot be added to more than one pair.",
      sidePreferenceAria: "Side preference",
      round: "Round",
    },
    checkIn: {
      confirm: "Confirm arrival",
      undo: "Undo arrival",
      present: "Present",
      waitingArrival: "Waiting for arrival",
      waitingParticipants: "Waiting for participants",
      waitingOpponents: "Waiting for opponents",
      readyToCall: "Ready to call",
      confirmError: "Could not confirm arrival.",
      undoError: "Could not undo arrival.",
    },
    courtStatus: {
      putOnCourt: "Put on Court",
      removeFromCourt: "Remove from Court",
      onCourt: "On Court",
      onCourtGames: "Games on Court",
      waiting: "Waiting",
      finished: "Finished",
      addResult: "Add Result",
      resultRequiresCourt: "This match is not on court yet.",
      resultRequiresCourtLong:
        "The result cannot be added because this match is not on court yet.",
      updateError: "Could not update match status.",
      uncheckedParticipants: "There are participants without confirmed check-in.",
      confirmStartWithUnchecked:
        "There are participants without confirmed check-in.\n\nDo you want to put this match on court anyway?",
      undefinedParticipants:
        "Define the participants before putting this match on court.",
      courtCapacityWarning:
        "There are more matches on court than registered courts.",
      registeredCourts: "registered courts",
      court: "Court",
    },
  },
  admin: {
    pageTitle: "Administrator panel",
    pageTitleOrganizer: "Organizer panel",
    pageSubtitle: "Manage site, users, challenges and history in one place.",
    pageSubtitleOrganizer:
      "Manage your challenges, registrations and users linked to your events.",
    tabs: {
      content: "Content",
      users: "Users",
      history: "Challenges",
      tournaments: "Tournaments",
      clubs: "Clubs",
      categoryRequests: "Category changes",
      registrations: "Registrations",
      payments: "Split",
      coupons: "Coupons",
    },
    clubs: {
      eyebrow: "Public directory",
      title: "Clubs",
      subtitle: "Create and maintain the clubs shown in the public directory.",
      newClub: "Add club",
      listTitle: "Registered clubs",
      searchPlaceholder: "Search club",
      loading: "Loading clubs...",
      empty: "No clubs found.",
      loadError: "Could not load clubs.",
      imageError: "Could not load the image.",
      imageTooLargeError:
        "Uploaded images must be valid and up to 3 MB.",
      requiredFieldsError: "Fill in name, logo, address, city, and state.",
      cepLookup: "Find ZIP",
      cepLookupLoading: "Searching...",
      cepLookupInvalid: "Enter an 8-digit ZIP code.",
      cepLookupSuccess: "Address found from ZIP code.",
      cepLookupSuccessWithCoordinates:
        "Address and coordinates found from ZIP code.",
      cepLookupError: "Could not find the address from ZIP code.",
      selectOnMap: "Select point on map",
      mapLookupLoading: "Locating...",
      mapLookupSuccess: "Location suggested from address.",
      mapLookupError:
        "Could not locate this address automatically. Adjust the point on the map.",
      closeMapPicker: "Close map picker",
      mapPickerTitle: "Select club point",
      mapPickerDescription:
        "Click the map or drag the marker to set latitude and longitude.",
      mapPickerAria: "Map to select club latitude and longitude",
      useMapPoint: "Use this point",
      createSuccess: "Club created.",
      updateSuccess: "Club updated.",
      saveError: "Could not save club.",
      activated: "Club activated.",
      deactivated: "Club deactivated.",
      deleteConfirm: "Delete this club?",
      deleteSuccess: "Club deleted.",
      viewPublic: "View public",
      activate: "Activate",
      deactivate: "Deactivate",
      delete: "Delete",
      closeModal: "Close club form",
      logo: "Logo",
      createTitle: "Create club",
      editTitle: "Edit club",
      active: "Active",
      save: "Save club",
      saving: "Saving...",
      fields: {
        name: "Name",
        logo: "Logo",
        cover: "Main photo",
        description: "Description",
        address: "Address",
        city: "City",
        state: "State",
        zipCode: "ZIP code",
        number: "Number",
        complement: "Complement",
        neighborhood: "Neighborhood",
        phone: "Phone",
        whatsapp: "WhatsApp",
        email: "Email",
        site: "Website",
        instagram: "Instagram",
        bookingUrl: "Booking link",
        lancesUrl: "Highlights link",
        lancesPlatformName: "Highlights platform name",
        latitude: "Latitude",
        longitude: "Longitude",
      },
    },
    misc: {
      athlete: "Athlete",
      currentCategory: "Current category",
      requestedCategory: "Requested category",
      requestDate: "Request date",
      noReason: "No reason provided.",
      rejectionNote: "Rejection reason / admin note (optional)",
      rejectionNotePlaceholder:
        "Enter the rejection reason or an approval note.",
      noUsersHint: "Try another filter or search term.",
      scheduledTime: "Scheduled time",
      startedPrefix: "Started:",
      finishedPrefix: "Finished:",
      dailyStart: "Daily start",
      dailyEnd: "Daily end",
      matchDuration: "Match duration",
      addSet: "Add set",
      registrationsCenter: "Registrations Center",
      registrationsDescription: "Manage payments, confirmations and waitlist.",
      billingMethod: "Billing method",
      billingMethodHint: "Used when sending a charge",
      unavailableAutomaticBilling: "Unavailable for automatic billing",
      emptyRegistrationsHintLine1: "When new registrations are submitted,",
      emptyRegistrationsHintLine2: "they will appear here.",
      refreshList: "Refresh list",
    },
    actions: {
      createChallenge: "Create challenge",
      startChallenge: "Start",
      finishChallenge: "Finish",
      generateUsersSearchPlaceholder: "Name or CPF",
    },
    labels: {
      title: "Title",
      description: "Description",
      image: "Image",
      date: "Date",
      time: "Time (24h)",
      address: "Address",
      challengeName: "Challenge name",
      scheduledAt: "Date and time",
      participants: "Participants",
      durationSeconds: "Duration (HH:MM)",
      status: "Status",
    },
    statuses: {
      loadingHistory: "Loading history...",
      pending: "Upcoming",
      started: "In progress",
      finished: "Finished",
      selected: "Selected",
      edit: "Edit",
      user: "User",
      organizer: "Organizer",
      administrator: "Administrator",
    },
    historyTable: {
      id: "ID",
      group: "Challenge",
      status: "Status",
      scheduledAt: "Date/Time",
      participants: "Participants",
      action: "Action",
    },
    sidebar: {
      selectedChallengeEdit: "Selected challenge editing.",
      contentConfig: "Application content configuration.",
      backToPanel: "Back to panel",
      closePanelMenu: "Close panel menu",
      adminMenu: "Administrative panel menu",
      openSideMenu: "Open side menu",
      closeSideMenu: "Close side menu",
      kicker: "Panel",
      adminTitle: "Administration",
      organizerTitle: "Organization",
      description: "Main navigation and management modules.",
      soon: "Coming soon",
      dashboard: "Dashboard",
      finance: "Finance",
      notifications: "Notifications",
      stockAndPayments: "Stock and payments",
    },
    usersTab: {
      selfPermissionHint: "You cannot change your own access permission.",
      noUsersFound: "No users found.",
    },
    tournamentCategoryEditor: {
      title: "Tournament categories",
      addCategory: "Add category",
      fallbackCategory: "Category",
      categoryName: "Category name",
      boysCategory: "Boys category",
      girlsCategory: "Girls category",
      gender: "Gender",
      registrationMode: "Registration mode",
      individual: "Pair draw",
      fixedPair: "Fixed pair",
      categoryLocation: "Category location",
      categoryLocationPlaceholder: "Ex.: Club X (optional)",
      shirtSizesEnabled: "Shirt",
      shirtSizesEnabledOption: "Enable shirt",
      shirtSizesDisabled: "Do not use shirt",
      shirtSizes: "Shirt sizes",
      shirtSizesPlaceholder: "Ex.: S, M, L, XL, Babylook S, Babylook M",
      slotsInCategory: "Slots in this category",
      fixedPairSlotInfo:
        "In this mode, each slot represents 1 pair (2 players).",
      individualSlotInfo:
        "In this mode, each slot represents 1 player (pairs will be drawn).",
      categoryActions: "Category actions",
      removeCategory: "Remove category",
      editCategory: "Edit",
      editSelectedCategory: "Edit selected category",
    },
    registrationsTab: {
      title: "Event registrations",
      refresh: "Refresh",
      manualRegistrationHint:
        "Manual registration is now inside the challenge (History -> open challenge), respecting individual or fixed-pair mode.",
      paymentMethod: "Payment type to generate charge",
      debitCard: "Debit card (+3%)",
      creditCard: "Credit card (+7%)",
      loading: "Loading registrations...",
      empty: "No registrations found.",
      statusFilters: {
        pending: "Pending",
        confirmed: "Confirmed",
        waitlist: "Waitlist",
        canceled: "Canceled",
        all: "All",
      },
      eventPrefix: "event",
      pair: "Pair",
      shirtSizes: "Shirts",
      shirtSizePlayer: "Player",
      shirtSizePartner: "Partner",
      status: "Status",
      payment: "payment",
      player: "Player with",
      notFound: "not found",
      notRequired: "not required",
      paymentLink: "Payment link",
      open: "open",
      copyLink: "Copy link",
      confirmPayment: "Confirm payment",
    },
    categoryRequestsTab: {
      title: "Category change requests",
      refresh: "Refresh",
      loading: "Loading requests...",
      empty: "No requests found.",
      playerFallback: "Player",
      noEmail: "no email",
      to: "to",
      reason: "Reason",
      status: "Status",
      adminNote: "Admin note",
      adminNoteOptional: "Admin note (optional)",
      processedBy: "Processed by",
      processedAtPrefix: "at",
      processing: "Processing...",
      approve: "Approve",
      reject: "Reject",
      athlete: "Player",
      currentCategory: "Current category",
      requestedCategory: "Requested category",
      requestedAt: "Request date",
      noReason: "No reason provided.",
      decisionNoteLabel: "Rejection reason / admin note (optional)",
      decisionNotePlaceholder:
        "Enter the rejection reason or an approval note.",
      decisionNotePrefix: "Rejection reason / admin note:",
      singularStatus: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
      },
      filters: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        all: "All",
      },
      toasts: {
        approved: "Request approved and category updated.",
        rejected: "Request rejected.",
        error: "Could not process the request.",
      },
    },
    paymentsTab: {
      splitTitle: "ASAAS split",
      save: "Save",
      secretsHint:
        "ASAAS API key, webhook token, and URLs are managed by backend secrets.",
      environment: "Environment",
      production: "Production",
      platformWallet: "Platform wallet",
      platformFeeType: "Platform fee type",
      percent: "Percent",
      fixedFee: "Fixed (R$)",
      feeValue: "Fee value",
      splitEnabled: "Split enabled",
      active: "Active",
      inactive: "Inactive",
      organizerWallets: "Organizer wallets",
      loadingSettings: "Loading settings...",
      walletId: "Wallet ID",
      organizerSplit: "Organizer split",
      saveWallet: "Save wallet",
      noOrganizers: "No organizers found.",
      myWallet: "My ASAAS wallet",
      toasts: {
        settingsSaved: "ASAAS settings saved.",
        settingsError: "Failed to save ASAAS settings.",
        organizerWalletSaved: "Organizer wallet updated.",
        organizerWalletError: "Could not save organizer wallet.",
        myWalletSaved: "Your wallet was updated.",
        myWalletError: "Could not save your wallet.",
      },
    },
    historyList: {
      tournamentsHistory: "Tournament history",
      createTournament: "Create tournament",
      challengesTitle: "Challenges",
      createChallenge: "+ Create challenge",
      challengesSubtitle:
        "Manage and track all challenges from your organization.",
      challengeSearchPlaceholder: "Search by challenge name...",
      moreOptionsAria: "More options",
      paginationAria: "Pagination",
      previousPageAria: "Previous page",
      nextPageAria: "Next page",
      showing: "Showing",
      rangeTo: "to",
      rangeOf: "of",
      challengeListKind: "challenges",
      tournamentListKind: "tournaments",
      perPage: "per page",
      organization: "Organization",
      all: "All",
      official: "Official",
      tnp: "TNP",
      otherOrganizer: "Another organizer",
      organizer: "Organizer",
      ranking: "Ranking",
      registrationsOpen: "Open registrations",
      registrationsClose: "Close registrations",
      registrationsStateOpen: "Registrations open",
      registrationsStateClosed: "Registrations closed",
      saving: "Saving...",
      emptyTournament: "No tournaments in this section.",
      emptyChallenge: "No challenges in this section.",
      loadingTournament: "Loading tournament...",
      loadingChallenge: "Loading challenge...",
      back: "Back",
      editResults: "Edit results",
      saveResults: "Save results",
      final: "Final",
      activeCategoryForRegistrations: "Active category for registrations",
      playerAlreadySelected:
        "This player has already been selected and cannot join more than one pair.",
      sidePreference: "Side preference",
      refreshRegistrations: "Refresh registrations",
      loadingChallengeRegistrations: "Loading challenge registrations...",
    },
    validation: {
      invalidCpf: "Invalid CPF.",
      invalidPhone: "Enter the complete phone number with country and area codes.",
      duplicateCpf: "This CPF is already registered.",
      invalidDateTime: "Enter a valid date/time.",
      invalidEndDate: "Enter a valid end date.",
      endDateBeforeStart: "The end date cannot be earlier than the start date.",
      invalidDuration: "Enter a valid duration in HH:MM format.",
      organizerRequired: "Select an organizer for this challenge.",
      evenParticipantsRequired:
        "The participant list must have an even quantity.",
      super8ParticipantsRequired:
        "Super 8 needs exactly 8 participants.",
      super8PlayersRequired: "Super 8 needs exactly 8 players.",
      super8CombinedPlayersRequired:
        "Super 8 must have exactly 8 participants to generate rounds.",
      cannotStartCurrentConfig:
        "Could not start with the current configuration.",
      super8GroupSplit:
        "This challenge uses the old Super 8 configuration with 16 participants and is available for viewing only.",
      invalidChallengeId: "Enter a valid challenge ID to link.",
      maxTrackingIds: "Enter up to 2 tracking IDs (separate by comma).",
      maxTrackingIdsError: "Enter at most 2 tracking IDs.",
    },
    eventLink: {
      eventCode: "Event code (ID)",
      registration: "Registration",
      challengeLink: "Challenge link",
      selectChallenge: "Select challenge…",
      challengeIdPlaceholder: "Challenge ID",
      defineEventId: "Set an event ID to link it.",
      invalidEventId:
        "Invalid event ID. Use only letters, numbers, _ and - (max 80).",
      noLink: "No link configured.",
      historyTabName: "History",
      historyHintPrefix: "Open the",
      historyHintSuffix: "tab to link it.",
      registrationHint:
        "The registration button opens the app screen for this event.",
      link: "Link",
      removeLink: "Remove link",
      linkedToChallengePrefix: "Linked to challenge",
      noChallengeFound:
        "No challenge found. Create a challenge in the History tab to link it here.",
      toasts: {
        saved: "Link saved successfully.",
        saveError: "Could not save the link.",
        removed: "Link removed.",
        removeError: "Could not remove the link.",
        eventNotFound: "Could not identify this challenge event.",
        registrationsOpened: "Registrations opened.",
        registrationsClosed: "Registrations closed.",
        registrationsUpdateError: "Could not update registrations.",
        rejected: "Registration rejected.",
        rejectError: "Could not reject the registration.",
        paid: "Payment marked as paid.",
        paidError: "Could not mark as paid.",
        paymentLinkCopied: "Payment link copied.",
        paymentAlreadyConfirmed: "Payment already confirmed.",
        noPaymentLink: "No payment link available to copy.",
        copyError: "Could not copy the link.",
        registrationRemoved: "Registration removed.",
        registrationRemoveError: "Could not remove registration.",
      },
    },
    createChallengePage: {
      createTournamentTitle: "Create tournament",
      createChallengeTitle: "Create challenge",
      editTournamentTitle: "Edit tournament",
      editChallengeTitle: "Edit challenge",
      pageSubtitleTournament: "Configure the main tournament information.",
      pageSubtitleChallenge: "Configure the main challenge information.",
      editSubtitleTournament: "Update the main tournament information.",
      editSubtitleChallenge: "Update the main challenge information.",
      back: "Back",
      gender: "Gender",
      maleCategory: "Men's category",
      femaleCategory: "Women's category",
      category: "Category",
      organization: "Organization",
      official: "Official",
      organizer: "Organizer",
      select: "Select",
      currentAdmin: "My admin profile",
      emptyOption: "—",
      includeRanking: "Count in official ranking",
      includeOrganizerRanking: "Count in my ranking",
      includeOfficialRanking: "Counts toward the Official TNP Ranking?",
      yes: "Yes",
      no: "No",
      eventIdentity: {
        title: "Event identity",
        info:
          "Choose which image represents this event in shares, cards, and organizer-linked screens.",
        description:
          "This choice applies only to this event and does not change the global TNP identity.",
        mode: "Identity mode",
        photo: "Organizer photo",
        logo: "Organizer logo",
        tnp: "TNP standard",
        photoHelp: "Uses the organizer profile photo in a circular format.",
        logoHelp: "Uses the logo saved in the organizer profile.",
        tnpHelp: "Uses the official TNP brand.",
        logoMissing:
          "To use Organizer logo, add a logo to the organizer profile under Visual identity.",
        uploadLogo: "Upload logo",
        replaceLogo: "Replace logo",
        savingLogo: "Saving logo...",
        logoSaved: "Logo saved to your profile.",
        logoUploadHelp:
          "The logo uploaded here is linked to your organizer profile.",
        logoInvalid: "Use PNG, JPG, JPEG, or WEBP up to 2MB.",
        preview: "Event identity preview",
        logoPreviewAlt: "Organizer logo",
        organizerFallback: "Organizer",
      },
      tournamentCategoriesTitle: "Categories and registrations",
      tournamentCategoriesEditDescription:
        "Manage categories, registrations, pairs, and players.",
      tournamentCategoriesDescription:
        "Configure tournament categories, registration mode per category, and the total number of slots.",
      challengeCategoriesTitle: "Challenge categories",
      challengeCategoriesDescription:
        "Configure challenge categories, registration mode, and the time for each category.",
      challengeCategory: "Challenge category",
      selectCategory: "Select a category",
      categoryTime: "Category time",
      totalSlots: "Total configured slots",
      totalSlotsDescription: "Sum of the slots defined across all categories.",
      generalInfoTitle: "General information",
      generalInfoDescription:
        "Set the name and description displayed for the tournament.",
      tournamentName: "Tournament name",
      city: "City",
      state: "State",
      clubVenue: "Club/Venue",
      selectCity: "Select a city",
      selectClubVenue: "Select a club/venue",
      manualVenueOption: "Fill manually",
      loadingClubs: "Loading clubs...",
      noRegisteredClubs: "No registered clubs",
      eventCityPlaceholder: "Enter the event city",
      eventClubVenuePlaceholder: "Enter the event club/venue",
      locationPeriodTitle: "Location and period",
      locationScheduleTitle: "Location and times",
      locationPeriodDescription:
        "Configure the default tournament location and date range.",
      locationScheduleDescription:
        "Location, period, and start/end time for each day.",
      courtsTitle: "Courts and court names",
      courtsDescription: "Add the courts available for scheduling.",
      organizationRankingTitle: "Organization and ranking",
      organizationRankingDescription:
        "Choose the organizer and ranking participation.",
      tournamentAddressPlaceholder: "Default tournament location (city/club)",
      tournamentStart: "Tournament start",
      tournamentEnd: "Tournament end",
      registrationTypeInfoPrefix: "Event registration type:",
      registrationIndividualSuper8: "individual (Super 8 is always individual)",
      registrationFixedPairByCategory:
        "fixed pair (defined by the selected category)",
      registrationIndividualByCategory:
        "individual (defined by the selected category)",
      registrationFixedPairPoco: "fixed pair (Poço is always fixed pair)",
      registrationFixedPairByMode: "fixed pair (defined by pair mode)",
      registrationIndividualByMode: "individual (defined by pair mode)",
      pricePerPlayer: "Price per player (R$)",
      fixedPairPriceHint:
        "For fixed-pair registration, the final charge will be this amount x 2.",
      eventSettingsTitle: "Image, price, and registrations",
      eventSettingsDescription:
        "Configure the public image, price, shirt, and registration opening.",
      visualIdentityTitle: "Visual identity",
      visualIdentityDescription:
        "Organizer customization and tournament photo.",
      advancedSettingsTitle: "Advanced tournament settings",
      advancedSettingsDescription:
        "Group optional logistics, operations, and availability rules.",
      tournamentOperationsTitle: "Brackets and timeline",
      tournamentOperationsDescription:
        "Configure brackets, scheduling, timeline, and results.",
      tournamentEventScheduleTitle: "Tournament schedule",
      tournamentEventScheduleDescription:
        "Configure the public program by day, time, and activity.",
      generalRequiredDescription: "Name, description, and required amount.",
      summary: {
        format: "Format",
        date: "Date",
        categories: "Categories",
        city: "City",
        tournament: "Tournament",
        challenge: "Challenge",
        toBeDefined: "To be defined",
        slotsSuffix: "spots",
        definedByFormat: "Defined by format",
        tnpStandard: "TNP standard",
        organizerLogo: "Organizer logo",
        organizerPhoto: "Organizer photo",
        countsRanking: "Counts toward ranking",
        countsMyRanking: "Counts toward my ranking",
        notRanking: "Does not count toward ranking",
        tournamentSummary: "Tournament summary",
        challengeSummary: "Challenge summary",
        locationFallback: "Location to be defined",
        participantsSuffix: "participant(s)",
        changes: "Changes:",
        pending: "Pending:",
        saveChanges: "Save changes",
        pendingSchedule: "schedule",
        pendingGeneralInfo: "general information",
        pendingShirts: "shirts",
        pendingParticipants: "categories and participants",
        pendingRounds: "rounds and results",
      },
      operations: {
        registrations: "Registrations",
        registrationsOpen: "Open",
        registrationsClosed: "Closed",
        openRegistrations: "Open registrations",
        closeRegistrations: "Close registrations",
        closeRegistrationsMessage: 'Close registrations for "{name}"?',
        closingRegistrations: "Closing...",
        redrawPairs: "Draw pairs again",
        regenerateRounds: "Generate rounds again",
        closeBeforeStart: "Close registrations before starting.",
        generateBeforeStart: "Generate the rounds before starting.",
      },
      sectionStatus: {
        complete: "Complete",
        attention: "Attention",
        pending: "Pending",
      },
      downloadShirtSizes: "Download shirt spreadsheet",
      shirts: {
        eventShirts: "Event shirts",
        availabilityType: "Shirt availability",
        availabilityNone: "No limit",
        availabilityPeriod: "By period",
        availabilityQuantity: "By quantity",
        deadline: "Shirt selection deadline",
        quantityLimit: "Maximum shirts available",
        quantitySummary:
          "Total: {total} | Confirmed: {confirmed} | Available: {available}",
      },
      customSettings: {
        challengeModel: "Challenge model",
        tnpStandard: "TNP standard",
        custom: "Custom",
        gameType: "Game type",
        byGames: "By games",
        byTime: "By time",
        gameCount: "Number of games",
        gameDurationMinutes: "Time per game",
        courtsCount: "Number of courts",
        defaultCourtsCount: "Default courts for new categories",
        categoryCourtsCount: "Courts in this category",
        playersCount: "Number of players",
        challengeWaitingPlayersHelp:
          "In Challenge, up to 2 waiting players are allowed per court.",
        pocoExactPlayersHelp:
          "In Poço, each court must have exactly 4 players.",
        timeOver: "Time is over.",
        startTimer: "Start timer",
        pauseTimer: "Pause timer",
        resetTimer: "Reset timer",
      },
      submitTournament: "Create tournament",
      submitChallenge: "Create challenge",
      saving: "Saving...",
      defaultCategoryPrefix: "Category",
      toasts: {
        organizersLoadError: "Failed to load organizers.",
        organizerRequiredTournament: "Select an organizer for this tournament.",
        organizerRequiredChallenge: "Select an organizer for this challenge.",
        invalidSlots: "Enter a valid number of slots (minimum 2).",
        cityRequired: "Enter the event city.",
        clubVenueRequired: "Enter the event club/venue.",
        imageRequired: "Add an image before saving.",
        priceRequired:
          "Enter a price per player greater than zero before saving.",
        priceMinimum: "The minimum allowed amount is R$ 5.00.",
        scheduleRequired:
          "Enter at least one court and valid times for the tournament.",
        shirtSettingsRequired: "Inform whether this event will have shirts.",
        shirtSizesRequired: "Enter at least one shirt size before saving.",
        shirtDeadlineRequired: "Enter the shirt selection deadline.",
        shirtDeadlinePast: "The shirt selection deadline cannot be in the past.",
        shirtQuantityRequired: "Enter the maximum number of shirts.",
        gameCountRequired: "Enter the number of games.",
        gameDurationRequired: "Enter the time per game.",
        courtsCountRequired: "Enter at least 2 courts.",
        playersCountRequired: "Enter at least 12 players.",
        challengeMaxPlayersExceeded:
          "Maximum number exceeded. In custom Challenge, up to 2 waiting players are allowed per court.",
        pocoExactPlayersRequired:
          "In custom Poço, the number of players must be exactly 4 players per court.",
        pocoMinPlayersRequired: "Poço must have at least 12 players.",
        noShirtSizesToExport: "No registrations available to export shirts.",
        categoriesRequired:
          "Create at least one custom tournament category with slots.",
        challengeCategoriesRequired:
          "The challenge must have at least one category.",
        challengeCategoryRequired: "Select a category.",
        categoryTimeRequired: "Enter the category time.",
        eachCategoryNeedsTime: "Each category must have a time.",
        duplicateChallengeCategory: "This category has already been added.",
        challengeCategoryApplied:
          "Category applied. Use Save all on the challenge to persist it.",
        categorySaved: "Category saved successfully.",
        categorySaveError: "Failed to save category.",
        categoryRegistrationTypeSaved: "Registration mode saved.",
        invalidEndDate: "The end date cannot be earlier than the start date.",
        tournamentSaved: "Tournament saved successfully.",
        challengeSaved: "Challenge saved successfully.",
        tournamentSaveError: "Failed to save tournament.",
        challengeSaveError: "Failed to save challenge.",
      },
    },
  },
};

const esOverrides: DeepPartial<SiteTexts> = {
  common: {
    loading: "Cargando...",
    save: "Guardar",
    apply: "Aplicar",
    clear: "Limpiar",
    cancel: "Cancelar",
    remove: "Eliminar",
    edit: "Editar",
    close: "Cerrar",
    confirm: "Confirmar",
    removing: "Eliminando...",
    backToProfile: "Volver al perfil",
    apiError: "Error de API",
    passwordVisibility: {
      show: "Mostrar contraseña",
      hide: "Ocultar contraseña",
    },
    timePicker: {
      open: "Abrir selector de horario",
    },
    locationActions: {
      openMap: "Abrir ubicación en el mapa",
      copyAddress: "Copiar dirección",
      copied: "Dirección copiada.",
      copyError: "No fue posible copiar la dirección.",
    },
    infoTooltip: {
      ariaLabel: "Ver información",
    },
    info: {
      challengeModel:
        "Estándar TNP usa las reglas oficiales de la plataforma. Personalizado permite ajustar jugadores, canchas y formato dentro de los límites.",
      tnpStandard:
        "Estándar TNP utiliza las reglas oficiales definidas por la plataforma.",
      customChallenge:
        "Personalizado permite ajustar cantidad de jugadores, canchas y forma de disputa respetando los límites mínimos.",
      gameType: "Define si el partido será controlado por games o por tiempo.",
      byGames: "Por games termina la disputa cuando se alcanza la puntuación configurada.",
      byTime: "Por tiempo muestra un cronómetro regresivo en la pantalla de ejecución.",
      gameCount: "Cantidad de games que orienta el cierre del partido.",
      gameDuration:
        "Tiempo de duración de cada juego. El cronómetro regresivo usa este valor.",
      courtsCount:
        "Cantidad de canchas disponibles para montar juegos simultáneos.",
      playersCount:
        "Cantidad total de jugadores del desafío, respetando los límites del modelo seleccionado.",
      category:
        "La categoría se usa para validar elegibilidad técnica y organizar inscripciones.",
      openCategory:
        "Categorías Libre no tienen restricción de género, pero respetan la regla técnica de la categoría.",
      ranking:
        "Cuando está activo, el evento suma puntos al ranking según las reglas TNP.",
      organizerRanking:
        "Cuando está activo, el evento suma puntos solo al ranking propio del organizador.",
      eventShirts:
        "Habilita camisetas para permitir elegir tallas durante la inscripción.",
      shirtsByPeriod:
        "Camisetas por periodo quedan disponibles solo hasta la fecha límite configurada.",
      shirtsByQuantity:
        "Camisetas por cantidad quedan disponibles hasta agotar el límite configurado.",
      tournamentCategories:
        "Las categorías separan inscripciones, horarios y plazas dentro del torneo.",
      tournamentFormat:
        "El formato define cómo se organizarán los enfrentamientos del torneo.",
      groupStage:
        "La fase de grupos organiza participantes en grupos antes de la etapa eliminatoria.",
      knockout:
        "Mata-mata elimina participantes a medida que avanzan los enfrentamientos.",
      americanSystem:
        "Sistema americano genera juegos rotativos para sumar desempeño entre participantes.",
      valuePerPlayer:
        "Valor cobrado por jugador. En dupla fija, el total considera a los dos jugadores.",
      slotLimit: "Límite máximo de inscripciones disponibles para esta categoría.",
      categoryTime: "Horario previsto para la categoría dentro del evento.",
      registrationCategory:
        "La categoría se valida según tu perfil y las reglas del evento.",
      fixedPair:
        "Dupla fija exige seleccionar o informar tu pareja antes de concluir la inscripción.",
      externalPayment:
        "Pago externo abre el proveedor de cobro fuera de la plataforma TNP.",
      pix: "PIX suele confirmar más rápido, según el retorno del proveedor de pago.",
      credit:
        "Crédito puede incluir tasa del método y depende de la confirmación del proveedor.",
      discountCoupon:
        "El cupón se aplica al valor total de la inscripción cuando es válido.",
      shirt:
        "La inscripción sigue disponible incluso cuando la camiseta ya no esté disponible.",
      shirtUnavailable:
        "Camiseta indisponible significa que terminó el plazo o se agotó el límite configurado.",
      referral: "Indica quién te invitó a participar del evento.",
      incompatibleCategory:
        "Categoría incompatible indica que la dupla o atleta no cumple las reglas de esta categoría.",
      modality: "Filtra el ranking por el tipo de evento considerado.",
      period: "Define la ventana de eventos usada en el cálculo del ranking.",
      allTime: "Siempre considera todo el historial del ranking.",
      last4:
        "Últimas 4 etapas considera solo los cuatro eventos más recientes de la modalidad y categoría seleccionadas.",
      consideredStages:
        "Etapas consideradas son los eventos usados en la suma actual de puntos.",
      countedEvents:
        "Eventos contabilizados indica cuántos eventos entraron en el cálculo actual.",
      rankedAthletes:
        "Atletas ranqueados muestra cuántas personas aparecen en la selección actual.",
      points:
        "Los puntos se suman por persona dentro de la categoría seleccionada.",
      tiebreakers:
        "En caso de empate, el sistema aplica los criterios de desempate definidos en el reglamento.",
      currentCategory:
        "La categoría actual define en qué eventos puedes inscribirte.",
      rankingPosition:
        "La posición en el ranking considera tu categoría actual en el ranking general.",
      titles: "Títulos conquistados cuentan eventos finalizados como campeón.",
      runnerUps:
        "Vicecampeonatos cuentan eventos finalizados en segundo lugar.",
      categoryChange:
        "El cambio de categoría debe ser aprobado por el equipo TNP.",
      openRegistrations:
        "Liberar inscripciones deja el evento disponible para inscripción pública.",
      closeRegistrations:
        "Cerrar inscripciones impide nuevas inscripciones sin borrar registros existentes.",
      remove: "Eliminar borra el elemento seleccionado. Úsalo solo si tienes certeza.",
      eventStatus: "El estado indica si el evento está por iniciar, en curso o finalizado.",
      eventDateTime:
        "La fecha y hora indican cuándo está previsto que ocurra el evento.",
      participants: "Participantes son los jugadores seleccionados o inscritos en el evento.",
      registrations: "Inscripciones reúne los registros recibidos por el formulario público.",
      split:
        "Split define cómo se dividen los valores recibidos entre plataforma y organizador.",
      users: "Usuarios son cuentas registradas con permisos y datos deportivos.",
      userCategory: "Categoría del usuario usada para validar inscripciones.",
      userRole: "Perfil del usuario define permisos de acceso en el sistema.",
      shareRanking: "Compartir ranking genera una imagen o enlace de la selección actual.",
      shareResult: "Compartir resultado genera una imagen o enlace del resultado exhibido.",
      shareChampionship:
        "Compartir campeonato usa los datos públicos del torneo actual.",
      downloadPng: "Descargar PNG guarda la imagen generada en el dispositivo.",
      copyLink: "Copiar enlace envía la URL de la pantalla actual al portapapeles.",
      methodFee: "La tasa del método varía según la forma de pago elegida.",
      subtotal: "Subtotal antes de descuento y tasas del método de pago.",
      registrationTotal:
        "Total de la inscripción después de descuento y tasa del método, cuando aplique.",
    },
    dateRange: {
      placeholder: "Seleccionar período",
      until: "hasta",
      openEnded: "...",
    },
    userAvatar: {
      sex: {
        female: "femenino",
        male: "masculino",
        other: "otro",
        notInformed: "no informado",
      },
      customAltPrefix: "Foto de perfil de",
      defaultAltPrefix: "Avatar predeterminado",
      defaultAltConnector: "de",
      fallbackUser: "usuario",
    },
    searchInput: {
      clear: "Limpiar búsqueda",
    },
    pageSize: {
      ariaLabel: "Elementos por página",
      perPage: "{count} por página",
      all: "Todos",
    },
    filters: {
      allCategories: "Todas las categorías",
      allSexes: "Mixto",
    },
    sex: {
      notInformed: "Prefiero no informar",
      male: "Masculino",
      female: "Femenino",
      other: "Otro",
    },
    challengeGender: {
      male: "Masculino",
      female: "Femenino",
      mixed: "Mixto",
      open: "Libre",
      maleShort: "Masc.",
      femaleShort: "Fem.",
    },
    category: {
      notInformed: "No informado",
      c7a: "Principiante (7ª)",
      c6a: "6ª",
      c5a: "5ª",
      c4a: "4ª",
      c3a: "3ª",
      c2a: "2ª",
      open: "Open",
      free: "Libre",
    },
    serverUnavailable: {
      title: "No se pudo conectar con nuestro servidor",
      description:
        "Estamos teniendo dificultades para acceder al sistema en este momento. Puede ser temporal; intenta nuevamente en unos instantes.",
      actions: {
        retry: "Intentar de nuevo",
      },
      supportHint: "Si el problema persiste, contacta al soporte.",
    },
    language: {
      label: "Idioma",
      modalTitle: "Elige tu idioma",
      modalDescription:
        "Selecciona cómo quieres navegar por el sitio. Podrás cambiarlo después en el header.",
      options: {
        pt: "Portugués",
        en: "Inglés",
        es: "Español",
      },
    },
  },
  header: {
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    nav: {
      about: "Sobre",
      challenges: "Desafíos",
      tournaments: "Torneos",
      ranking: "Ranking",
      athletes: "Atletas",
      matches: "Partidas",
      clubs: "Clubes",
      admin: "Panel",
      profile: "Perfil",
      createAccount: "Crear cuenta",
      login: "Iniciar sesión",
      logout: "Salir",
    },
    hello: "Hola",
    fallbackPlayerName: "Jugador",
    notifications: {
      ariaLabel: "Abrir notificaciones",
      title: "Notificaciones",
      loading: "Cargando notificaciones...",
      empty: "Ninguna notificación.",
      error: "No se pudieron cargar las notificaciones.",
      markAllRead: "Marcar todas como leídas",
      markRead: "Marcar como leída",
      removeAll: "Eliminar todas",
      remove: "Eliminar",
      actions: {
        paymentPending: "Pago pendiente",
        payNow: "Pagar ahora",
        registrationConfirmed: "Inscripción confirmada",
        viewRegistration: "Ver inscripción",
        viewGames: "Ver juegos",
        acceptInvite: "Aceptar invitación",
        declineInvite: "Rechazar invitación",
      },
    },
  },
  footer: {
    description: "Desafíos, eventos y comunidad conectada.",
    instagramAriaLabel: "Instagram Todos no Padel",
    privacyPolicy: "Política de Privacidad",
    termsOfUse: "Términos de Uso",
  },
  legal: {
    privacyPolicy: {
      title: "Política de Privacidad",
      commitmentTitle: "Compromiso del Usuario",
      moreInfoTitle: "Más información",
      effectiveDate:
        "Esta política entra en vigor el 11 de abril de 2026 a las 19:32.",
      lastUpdatedLabel: "Última actualización",
      lastUpdatedDate: "11 de abril de 2026 a las 19:32",
      introTitle: "Su privacidad es importante",
      introDescription:
        "Respetamos su privacidad y explicamos abajo cómo recopilamos, usamos y protegemos sus datos.",
      collectionTitle: "Recopilación de información",
      usageTitle: "Uso de la información",
      storageSecurityTitle: "Almacenamiento y seguridad",
      dataSharingTitle: "Compartir datos",
      externalLinksTitle: "Enlaces externos",
      userRightsTitle: "Derechos del usuario",
      questionsTitle: "¿Dudas sobre privacidad?",
      questionsText:
        "Si tiene alguna duda sobre esta Política de Privacidad, póngase en contacto con nosotros.",
      contactCta: "Contáctenos",
      expandLabel: "Expandir sección",
      collapseLabel: "Contraer sección",
      paragraphs: [
        "Tu privacidad es importante para nosotros. Todos no Padel respeta tu privacidad respecto a cualquier información que podamos recopilar en este sitio y en otros sitios que poseemos y operamos.",
        "Solicitamos información personal solo cuando es necesaria para ofrecer un servicio, por medios justos y legales, con tu conocimiento y consentimiento.",
        "Conservamos la información recopilada solo durante el tiempo necesario y protegemos los datos almacenados con medidas comercialmente aceptables.",
        "No compartimos información de identificación personal públicamente ni con terceros, excepto cuando la ley lo exija.",
        "Nuestro sitio puede contener enlaces a sitios externos que no operamos. No tenemos control sobre esos sitios y no podemos aceptar responsabilidad por sus respectivas __PRIVACY_LINK__.",
        "Puedes rechazar nuestra solicitud de información personal, entendiendo que algunos servicios pueden no estar disponibles.",
        "El uso continuado de nuestro sitio será considerado aceptación de nuestras prácticas de privacidad e información personal.",
      ],
      commitmentIntro:
        "El usuario se compromete a hacer uso adecuado del contenido y la información ofrecidos por Todos no Padel, incluyendo, pero no limitado a:",
      commitmentItems: [
        "A) No participar en actividades ilegales o contrarias a la buena fe y al orden público.",
        "B) No difundir contenido racista, xenófobo, pornográfico ilegal, de apología al terrorismo o contrario a los derechos humanos.",
        "C) No dañar ni intentar dañar los sistemas de Todos no Padel, sus proveedores o terceros.",
      ],
      moreInfoParagraph:
        "Si no estás seguro de si una función depende de cookies o tecnologías relacionadas, generalmente es más seguro mantenerlas habilitadas mientras usas el sitio.",
      privacyLinkLabel: "políticas de privacidad",
    },
    termsOfUse: {
      title: "Términos de Uso",
      lastUpdatedLabel: "Última actualización",
      lastUpdatedDate: "22 de junio de 2026",
      introTitle: "Bienvenido a Todos no Padel",
      introDescription:
        "Al acceder a nuestro sitio y utilizar nuestros servicios, aceptas los términos y condiciones descritos a continuación.",
      introReadCarefully: "Lea atentamente antes de continuar.",
      questionsTitle: "¿Dudas?",
      questionsText:
        "Si tienes alguna duda sobre estos Términos de Uso, contáctanos a través de nuestros canales oficiales.",
      contactCta: "Contáctenos",
      expandLabel: "Expandir sección",
      collapseLabel: "Contraer sección",
      sections: [
        {
          title: "1. Términos",
          paragraphs: [
            "Al acceder a Todos no Padel, aceptas cumplir estos términos de servicio, las leyes y regulaciones aplicables. Si no estás de acuerdo con algún término, no puedes usar ni acceder a este sitio.",
          ],
        },
        {
          title: "2. Uso de licencia",
          paragraphs: [
            "Se concede permiso para descargar temporalmente una copia de los materiales solo para visualización personal y no comercial.",
            "Esta licencia se rescindirá automáticamente si violas alguna restricción y podrá ser rescindida por Todos no Padel en cualquier momento.",
          ],
          items: [
            "Modificar o copiar los materiales.",
            "Usar los materiales con fines comerciales o para exhibición pública.",
            "Intentar hacer ingeniería inversa de cualquier software contenido en el sitio.",
            "Eliminar avisos de derechos de autor o propiedad.",
            "Transferir o espejar los materiales en otro servidor.",
          ],
        },
        {
          title: "3. Exención de responsabilidad",
          paragraphs: [
            "Los materiales de Todos no Padel se proporcionan tal como están. Todos no Padel no ofrece garantías expresas ni implícitas.",
          ],
        },
        {
          title: "4. Limitaciones",
          paragraphs: [
            "Todos no Padel y sus proveedores no serán responsables por daños derivados del uso o la imposibilidad de usar los materiales del sitio.",
          ],
        },
        {
          title: "5. Precisión de los materiales",
          paragraphs: [
            "Los materiales pueden contener errores técnicos, tipográficos o fotográficos y pueden modificarse sin aviso previo.",
          ],
        },
        {
          title: "6. Enlaces",
          paragraphs: [
            "Todos no Padel no es responsable del contenido de sitios enlazados. El uso de cualquier sitio enlazado es bajo responsabilidad del usuario.",
          ],
        },
        {
          title: "Modificaciones",
          paragraphs: [
            "Todos no Padel puede revisar estos términos en cualquier momento sin aviso previo. Al usar este sitio, aceptas la versión vigente.",
          ],
        },
        {
          title: "Ley aplicable",
          paragraphs: [
            "Estos términos se rigen e interpretan de acuerdo con la ley aplicable.",
          ],
        },
      ],
    },
  },
  about: {
    subtitle: "Conoce la historia y el propósito de TNP.",
    storyAriaLabel: "Historia de TNP",
    featuresAriaLabel: "Pilares de TNP",
    captions: { team: "Stephany y Raphael - Cofundadores" },
    storyTitles: [
      "Pasión que conecta",
      "Comunidad activa",
      "Experiencias únicas",
      "Evolución y crecimiento",
      "Pádel para todos",
    ],
    featureCards: [
      { title: "Desafíos recurrentes", text: "con rankings actualizados" },
      { title: "Eventos presenciales", text: "y torneos especiales" },
      { title: "Comunidad activa", text: "para mejorar en el pádel" },
      { title: "Experiencias seleccionadas", text: "para la comunidad" },
    ],
  },
  auth: {
    login: {
      title: "Iniciar sesión",
      subtitle: "Accede a tu cuenta para participar en los desafíos.",
      submit: "Entrar",
      error: "Error al iniciar sesión. Verifica correo/CPF y contraseña.",
      footerCta: "¿Aún no tienes cuenta?",
      footerLink: "Crear cuenta",
      identifierLabel: "Correo o CPF",
      passwordLabel: "Contraseña",
    },
    register: {
      title: "Crear cuenta",
      subtitle: "Registro inicial con nombre, correo y contraseña.",
      submit: "Crear cuenta",
      error:
        "Error al crear la cuenta. Verifica los datos e inténtalo de nuevo.",
      invalidCpf: "CPF inválido.",
      invalidPhone: "Ingresa el teléfono completo con código de país y área.",
      footerCta: "¿Ya tienes cuenta?",
      footerLink: "Iniciar sesión",
      nameLabel: "Nombre",
      emailLabel: "Correo",
      cpfLabel: "CPF",
      phoneLabel: "Teléfono",
      passwordLabel: "Contraseña",
      sexLabel: "Sexo",
      categoryLabel: "Categoría",
    },
    forgotPassword: {
      title: "Recuperar contraseña",
      link: "Olvidé mi contraseña",
      subtitle: "Informa tu correo o CPF para recibir las instrucciones.",
      submit: "Enviar enlace de recuperación",
      backToLogin: "Volver al login",
      genericMessage:
        "Si los datos informados están registrados, enviaremos un correo con las instrucciones para restablecer tu contraseña.",
      resetSuccess:
        "Contraseña restablecida correctamente. Inicia sesión con tu nueva contraseña.",
    },
    resetPassword: {
      title: "Restablecer contraseña",
      subtitle: "Crea una nueva contraseña para acceder a tu cuenta.",
      submit: "Restablecer contraseña",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar nueva contraseña",
      invalidToken: "Token inválido o expirado.",
      minLength: "La nueva contraseña debe tener al menos {count} caracteres.",
      mismatch: "Las contraseñas informadas no son iguales.",
      success:
        "Contraseña restablecida correctamente. Inicia sesión con tu nueva contraseña.",
      error:
        "No fue posible restablecer tu contraseña. Solicita un nuevo enlace.",
    },
    confirmEmail: {
      title: "Confirmar correo",
      missingToken: "Token de confirmación ausente.",
      success: "Correo confirmado correctamente.",
      error: "No fue posible confirmar el correo.",
      loading: "Confirmando correo...",
      goToProfile: "Ir al perfil",
    },
  },
  paymentSuccess: {
    title: "Pago iniciado",
    description:
      "Recibimos tu retorno. La confirmación oficial de la inscripción se actualizará automáticamente por el webhook de Asaas.",
    viewRegistrations: "Ver mis inscripciones",
    backToChallenges: "Volver a los desafíos",
  },
  publicPlayerProfile: {
    title: "Perfil deportivo",
    subtitle: "Historial público del jugador en TNP.",
    categoryPrefix: "Categoría",
    categoryFallback: "Categoría no informada",
    notFound: "Perfil no encontrado.",
    loadError: "No fue posible cargar este perfil.",
    openPhoto: "Ampliar foto del jugador",
    photoDialogTitle: "Foto del jugador",
    photoAlt: "Foto de perfil de {name}",
    shareProfile: "Compartir perfil",
    shareTitle: "Perfil deportivo de {name}",
    shareText: "Mira el perfil deportivo de {name} en Todos no Padel.",
    ranking: {
      title: "Ranking actual",
      subtitle: "Mejor posición activa encontrada.",
      empty: "Este jugador aún no tiene puntos en el ranking.",
      positionSuffix: "º lugar",
      pointsSuffix: "puntos",
      noPosition: "Sin posición",
      myCategoryRanking: "Mi categoría",
      byTypeTitle: "Posición por tipo",
      openRanking: "Abrir ranking",
    },
    stats: {
      title: "Estadísticas",
      subtitle: "Números consolidados del historial deportivo.",
      participations: "Participaciones",
      points: "Puntos",
      wins: "Victorias",
      losses: "Derrotas",
      titles: "Títulos",
      runnerUps: "Subcampeonatos",
      gamesBalance: "Saldo",
    },
    achievements: {
      title: "Conquistas",
      subtitle: "Badges desbloqueados por el jugador.",
      empty: "Ninguna conquista pública desbloqueada.",
    },
    participations: {
      title: "Historial deportivo",
      subtitle: "Eventos con resultado registrado.",
      empty: "Ninguna participación pública registrada.",
    },
  },
  athletesPage: {
    title: "Atletas",
    subtitle: "Encuentra atletas registrados en TNP.",
    searchPlaceholder: "Buscar por nombre",
    categoryFilter: "Categoría",
    allCategories: "Todas las categorías",
    sexFilter: "Sexo",
    allSexes: "Mixto",
    empty: "No se encontraron atletas.",
    loadError: "No fue posible cargar los atletas.",
  },
  clubs: {
    title: "Clubes",
    subtitle: "Encuentra clubes de pádel para jugar, reservar cancha y ver tus lances.",
    filtersLabel: "Filtros de clubes",
    searchPlaceholder: "Buscar club",
    cityFilter: "Ciudad",
    cityPlaceholder: "Escribe la ciudad",
    stateFilter: "Estado",
    allStates: "Todos",
    listView: "Lista",
    mapView: "Mapa",
    useLocation: "Usar mi ubicación",
    locationUnavailable: "No fue posible usar la ubicación en este dispositivo.",
    locationApplied: "Clubes cercanos cargados.",
    locationDenied: "Permiso de ubicación denegado. La búsqueda manual sigue disponible.",
    loadError: "No fue posible cargar los clubes.",
    empty: "No se encontraron clubes.",
    noMapCoordinates: "Ningún club de esta búsqueda tiene coordenadas registradas.",
    requestClub: {
      action: "Agregar club",
      title: "Solicitar registro de club",
      subtitle:
        "Envía los datos principales para que evaluemos el registro en el directorio.",
      close: "Cerrar solicitud de club",
      success: "Solicitud enviada. Nuestro equipo evaluará el club.",
      error: "No fue posible enviar la solicitud del club.",
      saving: "Enviando...",
      submit: "Enviar solicitud",
      requiredHint: "Nombre, ciudad y estado son obligatorios.",
      contactHint:
        "Agrega un contacto, sitio, Instagram, dirección u observación para ayudar a localizar el club.",
      fields: {
        requesterName: "Tu nombre",
        requesterEmail: "Tu email",
        requesterPhone: "Tu teléfono",
        clubName: "Nombre del club",
        city: "Ciudad",
        state: "Estado",
        address: "Dirección",
        websiteUrl: "Sitio",
        instagramUrl: "Instagram",
        notes: "Observaciones",
      },
      placeholders: {
        requesterName: "Cómo podemos identificarte",
        requesterEmail: "tu@email.com",
        requesterPhone: "(00) 00000-0000",
        clubName: "Nombre público del club",
        city: "Ciudad del club",
        state: "SC",
        address: "Calle, número y barrio",
        websiteUrl: "https://...",
        instagramUrl: "@clubdepadel",
        notes: "Links, contacto del club o detalles útiles",
      },
    },
    actions: {
      viewClub: "Ver club",
      instagram: "Instagram",
      booking: "Reservar cancha",
      lances: "Ver mis lances",
      directions: "Cómo llegar",
      site: "Sitio",
    },
    detail: {
      notFound: "Club no encontrado.",
      back: "Volver a clubes",
      tabs: {
        navigation: "Secciones del club",
        about: "Sobre",
        location: "Dirección y mapa",
        contact: "Contacto",
        matches: "Partidas",
        events: "Eventos",
      },
      about: "Sobre el club",
      noDescription: "Este club aún no tiene descripción registrada.",
      matchesTitle: "Próximas partidas en este club",
      noMatches: "Todavía no hay partidas abiertas publicadas para este club.",
      viewAllMatches: "Ver todas las partidas",
      createMatch: "Crear partida en este club",
      address: "Dirección",
      street: "Calle",
      neighborhood: "Barrio",
      cityState: "Ciudad/estado",
      zipCode: "Código postal",
      contact: "Contacto",
      phone: "Teléfono",
      whatsapp: "WhatsApp",
      email: "Email",
      noContact: "No hay contacto público registrado.",
      upcomingEventsTitle: "Próximos eventos en el club",
      upcomingEventsSubtitle: "Desafíos y torneos programados en este lugar.",
      loadingEvents: "Cargando eventos...",
      noUpcomingEvents: "No hay próximos eventos registrados en este club.",
      dateFallback: "Fecha por definir",
    },
  },
  openMatches: {
    title: "Partidas",
    subtitle:
      "Encuentra plazas abiertas, publica tu cancha reservada y organiza partidos compatibles con el perfil de los jugadores.",
    loadError: "No fue posible cargar las partidas abiertas.",
    emptyTitle: "No se encontraron partidas abiertas.",
    emptyDescription:
      "Ajusta los filtros o publica la primera partida de esta zona.",
    hero: {
      openCount: "Abiertas",
      upcomingCount: "Próximos 7 días",
      clubCount: "Clubes con partidas",
    },
    actions: {
      create: "Crear partida",
      createLogin: "Iniciar sesión para crear",
      viewDetails: "Ver detalles",
      edit: "Editar",
      openMap: "Abrir en el mapa",
      share: "Compartir",
      retry: "Intentar nuevamente",
      clearFilters: "Limpiar filtros",
      showFilters: "Mostrar filtros",
      hideFilters: "Ocultar filtros",
      closeModal: "Cerrar",
    },
    filters: {
      searchPlaceholder: "Buscar por club, ciudad u organizador",
      date: "Fecha",
      club: "Club",
      city: "Ciudad",
      category: "Categoría",
      gender: "Género",
      side: "Lado",
      time: "Horario",
      timeFromShort: "Desde",
      timeToShort: "Hasta",
      timeFrom: "Hora inicial desde",
      timeTo: "Hora inicial hasta",
      anyTime: "Cualquier horario",
      allClubs: "Todos los clubes",
      allCities: "Todas las ciudades",
      allCategories: "Todas las categorías",
      allGenders: "Todos los géneros",
      allSides: "Todos los lados",
      availableOnly: "Solo con plazas",
    },
    card: {
      organizer: "Organizador",
      availableSlots: "plazas disponibles",
      filledSlots: "plazas ocupadas",
      estimatedPerPlayer: "por jugador",
      priceInfo:
        "El valor por jugador depende del número de jugadores confirmados. Con reservas, la división puede variar hasta que la partida sea confirmada.",
      priceInfoAriaLabel: "Entender valor por jugador",
      priceRangeSeparator: "a",
      approvalRequired: "Requiere aprobación",
      instantEntry: "Entrada directa",
      organizerPlays: "El organizador juega",
      organizerOnly: "Solo organiza",
      categories: "Categorías",
      side: "Lado",
      gender: "Preferencia",
      playersLabel: "jugadores",
      slotsPreview: "Vista previa de plazas",
      emptySlot: "Plaza libre",
      pendingSlot: "Por confirmar",
      waitingList: "Reservas",
      waitingListOpen: "Reservas disponibles",
      waitingListClosed: "Sin plaza disponible",
      statusOpen: "Abierta",
      statusFull: "Completa",
      statusApproval: "Requiere aprobación",
      statusCanceled: "Cancelada",
      statusConfirmed: "Confirmada",
      statusFinished: "Finalizada",
    },
    results: {
      title: "Partidas encontradas",
      countSingular: "resultado",
      countPlural: "resultados",
      sortLabel: "Ordenar",
      sortRecent: "Más recientes",
      sortUpcoming: "Próximas fechas",
      sortLowestPrice: "Menor valor",
      sortMostSpots: "Más plazas",
    },
    detail: {
      notFound: "Partida no encontrada.",
      back: "Volver a partidas",
      club: "Club",
      viewClub: "Ver detalle del club",
      map: "Mapa",
      sideRequirementAny: "Cualquier lado",
      leftSidePlayersNeeded: "izquierda(s)",
      rightSidePlayersNeeded: "derecha(s)",
      responsibilityTitle: "Responsabilidad del organizador",
      responsibilityNotice:
        "Esta partida es organizada por un jugador. La reserva de la cancha y el cobro a los participantes no los realiza TNP.",
      payment: "Pago",
      details: "Detalles de la partida",
      notes: "Observaciones",
      description: "Descripción",
      schedule: "Fecha y horario",
      location: "Lugar",
      slots: "Plazas",
      categories: "Categorías aceptadas",
      duration: "Duración",
      join: "Quiero jugar",
      joinCourtAction: "Quiero participar",
      joinReserveAction: "Entrar como reserva",
      matchSoldOut: "Partida completa",
      joinLogin: "Iniciar sesión para jugar",
      joinLoading: "Solicitando...",
      joinPending: "Solicitud enviada al organizador.",
      joinConfirmed: "Participación confirmada.",
      joinWaitlist: "Solicitud enviada.",
      canceledAlertTitle: "Partida cancelada",
      canceledAlertDescription:
        "Esta partida fue cancelada por el organizador. Los jugadores confirmados fueron notificados.",
      joinWaitlistAction: "Quiero participar",
      joinError: "No fue posible solicitar participación.",
      joinCategoryBlocked: "Categoría no permitida.",
      fullNoWaitlist: "Partida completa.",
      acceptInvite: "Aceptar invitación",
      declineInvite: "Rechazar invitación",
      declineInviteSuccess: "Invitación rechazada.",
      confirmMatch: "Confirmar partida",
      confirmMatchLoading: "Confirmando...",
      confirmMatchSuccess: "Partida confirmada.",
      confirmMatchError: "No fue posible confirmar la partida.",
      confirmedMatchNotice: "Partida confirmada por el organizador.",
      finishedMatchNotice: "El horario de esta partida ya terminó.",
      confirmMatchBlocked: "Esta partida no puede confirmarse ahora.",
      participantsTitle: "Participantes y solicitudes",
      confirmedPlayersTitle: "Jugadores confirmados",
      noConfirmedPlayers: "Aún no hay jugadores confirmados.",
      courtPlayersTitle: "Jugadores en cancha",
      reservePlayersTitle: "Reservas",
      reservePlayersDescription:
        "Jugadores que participan de la rotación durante la partida.",
      emptyCourtSlot: "Plaza en cancha",
      reserveSlot: "Plaza para reserva",
      noReserveSlots: "Sin reservas configuradas.",
      summaryTitle: "Resumen",
      participantsSummary: "{filled} de {total} participantes",
      onCourtSummary: "{count} en cancha",
      reserveSummary: "{count} reservas",
      courtVacancies: "{count} plazas en cancha",
      reserveVacancies: "{count} plazas para reserva",
      organizerNotice:
        "El organizador se encarga de la reserva de la cancha y del cobro.",
      organizerPlayer: "Organizador juega",
      manageParticipantsTitle: "Gestionar participantes",
      noParticipants: "Aún no hay participantes en esta partida.",
      participantFallback: "Participante",
      participantNotRegistered: "No registrado",
      addParticipant: "Agregar participante",
      addParticipantLoading: "Agregando...",
      addParticipantSuccess: "Participante agregado.",
      addParticipantError: "No fue posible agregar participante.",
      addParticipantType: "Tipo de participante",
      addParticipantRegistered: "Atleta registrado",
      addParticipantExternal: "Participante externo",
      addParticipantPlaceholder: "Plaza ocupada",
      addParticipantName: "Nombre del participante",
      addParticipantNamePlaceholder: "Nombre de quien jugará",
      addParticipantCpf: "CPF",
      addParticipantCpfPlaceholder: "CPF opcional",
      inviteSearch: "Buscar atleta",
      inviteSearchPlaceholder: "Escribe nombre o categoría",
      inviteAthlete: "Atleta",
      inviteSelect: "Selecciona un atleta",
      inviteNoResults: "No hay atletas disponibles.",
      invite: "Invitar",
      inviting: "Invitando...",
      inviteSuccess: "Invitación enviada.",
      inviteError: "No fue posible enviar la invitación.",
      approveParticipant: "Confirmar",
      waitlistParticipant: "Reserva",
      declineParticipant: "Rechazar",
      cancelParticipant: "Eliminar",
      cancelParticipantSelf: "Cancelar participación",
      cancelParticipantLoading: "Cancelando...",
      cancelParticipantSelfBlocked:
        "La cancelación está disponible hasta 4 horas antes de la partida.",
      cancelParticipantSuccess: "Participación cancelada.",
      cancelParticipantError: "No fue posible cancelar la participación.",
      reviewSuccess: "Participante actualizado.",
      reviewError: "No fue posible actualizar el participante.",
      messageBoardTitle: "Conversación",
      noMessages: "Aún no hay mensajes en esta conversación.",
      messageLabel: "Mensaje",
      messagePlaceholder: "Escribe a los participantes confirmados.",
      messageSend: "Enviar mensaje",
      messageSending: "Enviando...",
      messageError: "No fue posible enviar el mensaje.",
      messageReadOnly:
        "Esta conversación está cerrada. Los mensajes estarán disponibles hasta {date}.",
      messageNoAccess:
        "La conversación aparece solo para el organizador y jugadores confirmados.",
      messageCharacters: "{count}/{limit}",
      messageRemoved: "Mensaje eliminado",
      messageRemove: "Eliminar mensaje",
      messageLoading: "Cargando conversación...",
      messageSystemAuthor: "Sistema",
      organizerBadge: "Organizador",
      participantStatuses: {
        invited: "Invitado",
        pending: "A confirmar",
        confirmed: "Participación confirmada",
        waitlist: "Reserva",
        declined: "Rechazado",
        canceled: "Cancelado",
      },
    },
    form: {
      title: "Crear partida",
      subtitle:
        "Publica una nueva partida abierta usando un club ya registrado en TNP.",
      editTitle: "Editar partida",
      editSubtitle:
        "Actualiza los datos de tu partida directamente desde la lista pública.",
      club: "Club",
      matchTitle: "Nombre de la partida",
      matchTitlePlaceholder: "Ej.: Partido de Stephany",
      date: "Fecha",
      startTime: "Inicio",
      endTime: "Fin",
      duration: "Duración calculada",
      durationPending: "Ingresa inicio y fin",
      durationInvalid: "Horario inválido",
      totalPlayers: "Total de jugadores",
      initialParticipants: "Plazas ya ocupadas",
      initialParticipantsHint:
        "Agrega atletas registrados confirmados, participantes externos o solo bloquea una plaza.",
      editParticipants: "Agregar jugadores",
      editParticipantsHint:
        "Agrega nuevas personas confirmadas a esta partida sin cambiar quienes ya estaban.",
      addInitialParticipant: "Agregar plaza",
      noInitialParticipants: "Ninguna plaza ocupada inicialmente.",
      participantType: "Tipo de plaza",
      participantRegistered: "Atleta registrado",
      participantExternal: "Participante externo",
      participantPlaceholder: "Plaza ocupada sin identificación",
      participantSearch: "Buscar atleta",
      participantSearchPlaceholder: "Escribe nombre o categoría",
      participantSelect: "Seleccionar atleta",
      participantNoResults: "No hay atletas disponibles.",
      participantNotRegistered: "No registrado",
      participantAlreadySelected: "Este atleta ya fue agregado.",
      participantName: "Nombre",
      participantCpf: "CPF",
      removeInitialParticipant: "Eliminar plaza",
      categories: "Categorías aceptadas",
      genderPreference: "Preferencia de género",
      sidePreference: "Preferencia de lado",
      leftPlayersCount: "Cant. izquierdas",
      rightPlayersCount: "Cant. derechas",
      sidePlayersTotalError:
        "La suma de izquierdas y derechas no puede superar el total de atletas configurado.",
      totalPrice: "Valor total de la reserva",
      totalPricePlaceholder: "Opcional",
      totalPriceHint: "Completa solo si quieres mostrar una estimación de división.",
      playerPrice: "Valor por jugador",
      playerPricePlaceholder: "Opcional",
      playerPriceHint:
        "Completa solo si cada jugador paga un valor fijo.",
      priceMode: "Tipo de valor",
      pricePending: "A definir",
      paymentMode: "Forma de pago",
      details: "Detalles de la partida",
      detailsPlaceholder:
        "Agrega aquí observaciones, forma de pago, nivel esperado o cualquier aviso útil para los jugadores.",
      paymentInstructions: "Instrucciones de pago",
      description: "Descripción",
      notes: "Observaciones",
      organizerPlays: "También voy a jugar",
      approvalRequired: "Exigir aprobación para entrar",
      waitlistEnabled: "Permitir reservas",
      responsibility:
        "Confirmo que soy responsable por la reserva de la cancha, la organización de la partida y el cobro a los participantes.",
      selectClub: "Selecciona un club",
      clubSearchPlaceholder: "Escribe el nombre, ciudad o dirección del club",
      clubNoResults: "No se encontraron clubes.",
      dateRequired: "Selecciona una fecha para la partida.",
      categoriesHint: "Elige una o más categorías.",
      submit: "Publicar partida",
      submitting: "Publicando...",
      editSubmit: "Guardar cambios",
      editSubmitting: "Guardando...",
      cancelMatch: "Cancelar partida",
      cancelMatchSubmitting: "Cancelando...",
      cancelMatchConfirm:
        "¿Seguro que deseas cancelar esta partida? Ya no aparecerá en la lista pública.",
      cancelMatchSuccess: "Partida cancelada.",
      cancelMatchError: "No fue posible cancelar la partida.",
      success: "Partida publicada con éxito.",
      editSuccess: "Partida actualizada con éxito.",
      saveError: "No fue posible publicar la partida.",
      editError: "No fue posible actualizar la partida.",
    },
    options: {
      genderAny: "Cualquier género",
      genderFemale: "Femenino",
      genderMale: "Masculino",
      genderMixed: "Mixto",
      genderPreferFemale: "Preferentemente femenino",
      genderPreferMale: "Preferentemente masculino",
      sideAny: "Lado indiferente",
      sideLeft: "Busca izquierda",
      sideRight: "Busca derecha",
      sideBoth: "Busca ambos lados",
      sidePreferLeft: "Preferentemente izquierda",
      sidePreferRight: "Preferentemente derecha",
      paymentOrganizer: "Pago al organizador",
      paymentClub: "Pago al club",
      paymentOnsite: "Pago presencial",
      paymentPix: "Pago por Pix",
      paymentCustom: "A combinar",
      paymentFree: "Partida gratuita",
      paymentUndefined: "Valor por definir",
      priceModeCourt: "Por cancha",
      priceModePlayer: "Por jugador",
    },
  },
  home: {
    hero: {
      title: "Todos no Padel",
      subtitle:
        "Conectamos a la comunidad, creamos desafíos y destacamos los eventos que hacen crecer el pádel.",
      ctaLabel: "Ver próximos eventos",
      ctaLink: "#/desafios",
    },
    summary:
      "Somos un equipo apasionado por el pádel que organiza eventos y crea experiencias para la comunidad.",
    heroKicker: "Comunidad • Eventos • Performance",
    heroFallbackCta: "Ver desafíos",
    loadingContent: "Cargando contenido...",
    aboutFallbackTitle: "Sobre TNP",
    aboutParagraphs: [
      "TNP - Todos no Padel nació de la pasión por el deporte y del deseo de llevar esa energía a más personas. Más que jugar, creemos en el poder del pádel para conectar, desafiar y transformar dentro y fuera de la cancha.",
      "Creamos TNP para formar una comunidad activa, acogedora y competitiva, donde jugadores de distintos niveles puedan evolucionar, desafiarse y divertirse.",
      "Promovemos experiencias a través de formatos como Challenge, Super 8, Poço y Torneos, pensados para incentivar integración, espíritu deportivo y evolución constante.",
      "Nuestro objetivo va más allá de los eventos: queremos difundir el pádel, impulsar el crecimiento del deporte y ayudar a cada jugador a alcanzar su próximo nivel.",
      "Creemos que el pádel es para todos. Nuestra invitación es simple: ven a ser parte de esta comunidad.",
    ],
    aboutFallbackItems: [
      "Desafíos recurrentes con rankings actualizados",
      "Eventos presenciales y torneos especiales",
      "Experiencias seleccionadas para la comunidad",
      "Comunidad activa para evolucionar en el pádel",
    ],
    events: {
      title: "Próximos eventos",
      subtitle: "Torneos, etapas especiales y encuentros de la comunidad.",
      empty: "No hay eventos registrados por ahora.",
      fallbackTag: "Evento",
      fallbackAddress: "Lugar por definir",
      navAria: "Navegación de eventos",
      moveLeft: "Mover eventos hacia la izquierda",
      moveRight: "Mover eventos hacia la derecha",
    },
    clubs: {
      title: "Clubes cercanos",
      subtitle:
        "Encuentra clubes para jugar, reservar cancha y acompañar la comunidad cerca de ti.",
      nearbyTag: "Club",
      fallbackAddress: "Dirección por definir",
      viewMore: "Ver más clubes",
      viewAll: "Ver todos los clubes",
    },
  },
  eventDetails: {
    loading: "Cargando detalles del evento...",
    notFoundTitle: "Evento no encontrado",
    notFoundMessage: "Este evento ya no está disponible.",
    date: "Fecha",
    address: "Dirección",
    amountPerPlayer: "Valor por jugador",
    remainingSlots: "Plazas restantes",
    details: "Detalles",
    howRegistrationWorks: "?Como funciona la inscripción?",
    paymentGuarantee:
      "Tu plaza será garantizada después de la confirmación del pago.",
    fallbackDate: "Por definir",
    fallbackAddress: "Por definir",
    loginToRegister: "Iniciar sesión para inscribirse",
    registrationClosedButton: "Inscripciones próximamente",
    registrationClosedMessage:
      "Las inscripciones de este evento aún no fueron liberadas por el organizador.",
    categories: {
      toBeDefined: "Por definir",
    },
    challengeTypes: {
      super8: "Super 8",
      poco: "Poço",
      tournament: "Torneo",
      challenge: "Challenge",
    },
    registrationStatus: {
      pending: "Pendiente",
      confirmed: "Confirmada",
      waitlist: "Lista de espera",
      canceled: "Cancelada",
      none: "Sin inscripción",
    },
    paymentStatus: {
      pending: "Pendiente",
      confirmed: "Confirmado",
      canceled: "Cancelado",
      refunded: "Reembolsado",
      toBeDefined: "Por definir",
      prefix: "Pago",
    },
    challengeStatus: {
      pending: "Por iniciar",
      started: "En curso",
      finished: "Finalizado",
      canceled: "Cancelado",
      event: "Evento",
    },
    registrations: {
      title: "Inscripciones",
      sortedByPayment:
        "Ordenado por confirmación del pago; si falta, por última actualización de la inscripción.",
      confirmedAtPrefix: "Pago confirmado el",
      confirmedFallbackCreatedAtPrefix:
        "Pago confirmado sin fecha registrada. Inscripción actualizada el",
      confirmedNoDate: "Pago confirmado sin fecha registrada",
    },
    loadingRegistrationStatus: "Cargando tu estado de inscripción...",
    loadingEventInfo: "Cargando información del evento...",
    missingChallengeLink:
      "La inscripción estará disponible después de que el administrador vincule este evento a un desafío.",
  },
  eventRegistration: {
    fallback: {
      toBeDefined: "Por definir",
      player: "Jugador",
    },
    buttons: {
      backToEvents: "Volver a eventos",
      unavailable: "Inscripción no disponible",
      confirmed: "Inscripción confirmada",
      confirmMyRegistration: "Confirmar mi inscripción",
      continueToPayment: "Continuar al pago",
      openPaymentAgain: "Abrir pago nuevamente",
      viewMyRegistrations: "Ver mis inscripciones",
      selectPartner: "Seleccionar",
      unavailablePartner: "No disponible",
    },
    steps: {
      registration: "Inscripción",
      data: "Datos",
      externalPayment: "Pago externo",
      confirmation: "Confirmación",
    },
    linkedChallengeMissing:
      "Este evento aún no tiene un desafío vinculado. Pide al administrador que lo configure.",
    registrationClosed:
      "Las inscripciones aún no fueron liberadas por el organizador.",
    loadingEventInfo: "Cargando información del evento...",
    loadingMyRegistration: "Actualizando tu inscripción...",
    loadingPartners: "Cargando jugadores...",
    emptyPartners: "No se encontraron jugadores.",
    removeSelectedPairError: "No fue posible eliminar la dupla seleccionada.",
    shirts: {
      deadlineClosed:
        "El plazo para elegir camiseta termino. Aun puedes inscribirte sin camiseta.",
      soldOut:
        "Las camisetas disponibles se agotaron. Aun puedes inscribirte sin camiseta.",
      availableCount: "{count} camisetas disponibles.",
      oneAvailable:
        "Queda 1 camiseta disponible. Elige para un jugador o continua sin camiseta.",
      onlyOneAvailable:
        "Queda solo 1 camiseta disponible. Elige camiseta para un jugador o continua sin camiseta.",
    },
    partnerCompatibility: {
      incompatiblePair:
        "Esta dupla es incompatible con la categoría seleccionada.",
      available: "Disponible",
      unavailable: "No disponible",
      undefinedCategory: "Categoría no definida",
      incompatible: "Incompatible",
    },
    form: {
      registrationCategory: "Categoría de inscripción",
      remainingSlots: "plazas restantes",
      profileIncompatible: "incompatible con tu perfil",
      fixedPair: {
        title: "Tu dupla",
        searchLabel: "Buscar por nombre, correo o teléfono",
        searchPlaceholder: "Buscar por nombre, correo o teléfono",
        noCategory: "Sin categoría",
        introFemale: "Selecciona una jugadora",
        introMale: "Selecciona un jugador",
        introAny: "Selecciona una persona",
        introWarning:
          "¿No encontraste a tu dupla? Pídele que finalice el registro.",
        introCategoryPrefix: "de la categoría",
      },
      drawPairSide: {
        noticeTitle: "Duplas por sorteo",
        notice: "Las duplas de este desafío serán formadas por sorteo.",
        question: "¿En qué lado prefieres jugar?",
        both: "Puedo jugar en ambos lados",
        bothSummary: "Ambos",
        summaryLabel: "Preferencia de lado",
      },
      super8Notice:
        "Inscripción individual: no necesitas elegir pareja para participar en este Super 8. Las rondas se sortean automáticamente y todos juegan contra todos.",
      availabilityRestrictionTooltip:
        "Informa si hay un período en el que no podrás jugar este torneo.",
      availabilityRestrictionPeriodsLabel: "Períodos no disponibles",
    },
    summary: {
      title: "Resumen de inscripción",
      date: "Fecha",
      location: "Lugar",
      type: "Tipo",
      format: "Formato",
      rule: "Regla",
      category: "Categoría",
      players: "Jugadores",
      valuePerPlayer: "Valor por jugador",
      subtotal: "Subtotal",
      discount: "Descuento",
      fee: "Tarifa del método",
      total: "Total de la inscripción",
      fixedPair: "Dupla fija",
      individual: "Individual",
      super8Format: "Super 8",
      super8Rule: "Rondas sorteadas • Todos contra todos",
      selectPair: "Selecciona tu dupla",
    },
    paymentMethods: {
      title: "Pago externo",
      pixLabel: "PIX",
      creditLabel: "Tarjeta",
      note: "Las tarifas adicionales se aplican según el método seleccionado.",
    },
    discountCoupon: {
      label: "Cupón de descuento",
      placeholder: "Ej.: TNP10",
      apply: "Aplicar",
      applying: "Aplicando...",
      applied: "Cupón aplicado.",
      invalid: "Cupón inválido.",
      empty: "Informa el código del cupón.",
      successPrefix: "Descuento aplicado con",
    },
    checkout: {
      redirectingTitle: "Redirigiendo al pago seguro...",
      redirectingText:
        "Estamos preparando tu cobro en Asaas. En instantes se abrirá una nueva pestaña para elegir PIX, tarjeta o boleto.",
      confirmedTitle: "Pago confirmado",
      confirmedText:
        "Asaas confirmó el pago y tu inscripción ya está garantizada.",
      pendingTitle: "Pago pendiente",
      pendingText:
        "Tu inscripción fue registrada. Estamos esperando la confirmación del pago por Asaas vía webhook para concluir tu plaza.",
    },
    status: {
      canceledPrefix: "Inscripción cancelada",
      pendingPayment: "Inscripción pendiente de pago.",
      fixedPairPrefix: "Dupla fija:",
      waitlistLabel: "Lista de espera",
      waitlist:
        "Estás en la lista de espera. Cuando se abra una plaza, se promueve el primer pago confirmado.",
      waitlistConfirmation:
        "Las plazas de esta competición ya fueron completadas.\n\nPuedes concluir tu inscripción y entrar en la lista de espera. Tu posición en la fila solo será garantizada después de la confirmación del pago.\n\nSi se libera una plaza, las inscripciones pagadas serán llamadas por orden de fila.",
      paymentLinkPrefix: "Link de pago:",
    },
    toasts: {
      openPaymentSuccess: "Pago abierto en una nueva pestaña.",
      openPopupError:
        "No fue posible abrir una nueva pestaña. Permite pop-ups e inténtalo de nuevo.",
      checkoutStartError: "No fue posible iniciar el checkout ahora.",
    },
    errors: {
      teammateCpfRequired: "Informa el CPF de tu dupla fija.",
      preferredSideRequired: "Selecciona el lado en que prefieres jugar.",
      profileCategoryRequired:
        "Define tu categoría en el perfil para inscribirte en este desafío.",
      categoryMismatch: "No estás en la categoría de este desafío.",
      registrationCategoryRequired:
        "Selecciona la categoría de inscripción para continuar.",
      fullNameRequired: "Informa el nombre completo.",
      emailRequired: "Informa el correo.",
      phoneInvalid: "Informa un WhatsApp/celular válido con código de área.",
      taxIdInvalid: "Informa un CPF o CNPJ válido.",
    },
  },
  challenges: {
    hub: {
      title: "Desafíos",
      subtitle: "Elige desafíos oficiales de TNP o de organizadores.",
      officialCard: {
        title: "Desafíos Oficiales TNP",
        description:
          "Visualiza los desafíos oficiales publicados por el circuito TNP.",
        cta: "Explorar oficiales",
        stats: {
          challenges: "Desafíos",
          season: "Temporada",
          pending: "Por iniciar",
        },
      },
      organizersCard: {
        title: "Desafíos de Organizadores",
        description: "Explora los desafíos de organizadores aliados.",
        cta: "Explorar organizadores",
        stats: {
          organizers: "Organizadores",
          publishedChallenges: "Desafíos publicados",
          inProgress: "Por iniciar",
        },
      },
    },
    organizersDirectory: {
      title: "Seleccionar Organizador",
      subtitle:
        "Elige un organizador para abrir los desafíos correspondientes.",
      loading: "Cargando organizadores...",
      loadError: "No fue posible cargar los organizadores.",
      loadMoreError: "No fue posible cargar más organizadores.",
      empty: "No hay organizadores registrados.",
      searchPlaceholder: "Escribe el nombre del organizador",
      searchAriaLabel: "Buscar organizador por nombre",
      searchButtonAriaLabel: "Buscar organizador",
      loadMore: "Cargar más",
      loadingMore: "Cargando...",
      sortLabel: "Ordenar por",
      sortOptions: {
        name: "Nombre A-Z",
        athletes: "Más jugadores",
        challenges: "Más desafíos",
        updated: "Actualizados recientemente",
      },
      selectedTitle: "Selecciona un Organizador",
      selectedSubtitle:
        "Elige un organizador para ver los desafíos disponibles.",
      searchExpandedPlaceholder: "Buscar organizador, club o arena...",
      featuredTitle: "Más visitados",
      allTitle: "Todos los organizadores",
      emptySearch: "No se encontraron organizadores.",
      official: "Oficial",
      athletes: "jugadores",
      challenges: "desafíos",
      viewChallenges: "Ver desafíos",
      viewChallengesAriaPrefix: "Ver desafíos de",
      openChallengesAriaPrefix: "Abrir desafíos de",
      updatedToday: "Actualizado hoy",
      updatedAtPrefix: "Actualizado el",
      helpTitle: "¿Te gustaría organizar tu torneo?",
      helpText: "Contáctanos por correo:",
      stats: { finished: "finalizados", pending: "por iniciar" },
    },
    publicList: {
      title: "Desafíos",
      subtitle: "Encuentra y sigue los próximos desafíos.",
      subtitleTournament:
        "Encuentra y participa en los próximos torneos de pádel.",
      searchPlaceholder: "Buscar por nombre del desafío u organizador...",
      searchPlaceholderOfficial: "Buscar por nombre del desafío...",
      searchPlaceholderTournament:
        "Buscar por nombre del torneo...",
      searchAriaLabel: "Buscar desafíos",
      filterGroups: {
        searchDate: "Busqueda y fecha",
        general: "General",
        source: "Origen",
        status: "Status",
        type: "Tipo",
      },
      titles: {
        organizers: "Desafíos de Organizadores",
        organizerPrefix: "Desafíos",
        organizerIdPrefix: "Desafíos Organizador #",
        tournaments: "Torneos",
        tnpTournaments: "Torneos TNP",
        organizerTournaments: "Torneos de Organizadores",
      },
      labels: {
        details: "Ver detalles",
        officialTnp: "TNP Oficial",
        viewAll: "Ver todos",
        priceFallback: "Valor por definir",
        moreCategories: "categorias",
        filledSlots: "plazas ocupadas",
        emptyTournaments: "No se encontraron torneos.",
        partnerTournamentNoOfficialRanking:
          "Este torneo es organizado por un socio y no cuenta para el Ranking Oficial TNP.",
        organizerRankingOnly:
          "Este torneo cuenta solo para el ranking del organizador.",
        empty: "No se encontraron desafíos.",
        emptyTournament: "No hay torneos en esta sección.",
        groupPrefix: "Grupo",
        organizerPrefix: "Organizador:",
        locationFallback: "Lugar por definir",
        organizerFallback: "Por definir",
        countTournaments: "torneos",
      },
      summaryCards: {
        upcomingChallenges: "Próximos desafíos",
        upcomingChallengesHint: "Por iniciar en los próximos 7 días",
        availableSlots: "Plazas disponibles",
        availableSlotsHint: "En todos los desafíos abiertos",
        finishedChallenges: "Desafíos finalizados",
        finishedChallengesHint: "Concluidos en el período",
        totalAthletes: "Total de jugadores",
        totalAthletesHint: "Participando en los desafíos",
        activeTournaments: "Torneos activos",
        activeTournamentsHint: "Inscripciones abiertas",
        upcomingTournaments: "Próximos torneos",
        upcomingTournamentsHint: "Próximos 30 días",
        registeredAthletes: "Jugadores inscritos",
        registeredAthletesHint: "En todos los torneos",
        openCategories: "Categorías abiertas",
        openCategoriesHint: "Categorías disponibles",
      },
      filters: {
        all: "Todos",
        officialTnp: "TNP Oficial",
        organizers: "Organizadores",
        organizer: "Organizador",
        city: "Ciudad",
        club: "Club/Sede",
        category: "Categoria",
        date: "Fecha",
        sort: "Ordenar",
        mostRecent: "Mas recientes",
        nearest: "Mas cercanos",
        mostRegistered: "Mas inscritos",
        pending: "Por iniciar",
        started: "En curso",
        finished: "Finalizado",
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Pozo",
        tournament: "Torneo",
      },
      tournamentSections: {
        officialTitle: "Torneos Oficiales TNP",
        officialSubtitle: "Eventos organizados por el circuito TNP.",
        organizersTitle: "Torneos de Organizadores",
        organizersSubtitle: "Eventos organizados por nuestros socios.",
      },
    },
    publicDetail: {
      statuses: {
        pending: "Por iniciar",
        started: "En curso",
        finished: "Finalizado",
        canceled: "Cancelado",
        undefined: "Por iniciar",
      },
      shareAction: "Compartir",
      winnerShare: {
        athleteFallback: "Jugador TNP",
        final: "FINAL",
        female: {
          title: "CAMPEONAS",
          championBadge: "DUPLA CAMPEONA",
          championSideTitle: "CAMPEONAS",
          runnerTitle: "SUBCAMPEONAS",
        },
        male: {
          title: "CAMPEONES",
          championBadge: "DUPLA CAMPEONA",
          championSideTitle: "CAMPEONES",
          runnerTitle: "SUBCAMPEONES",
        },
        mixed: {
          title: "DUPLA CAMPEONA",
          championBadge: "CAMPEONES DE MIXTO",
          championSideTitle: "CAMPEONES",
          runnerTitle: "DUPLA SUBCAMPEONA",
        },
        neutral: {
          title: "DUPLA CAMPEONA",
          championBadge: "DUPLA CAMPEONA",
          championSideTitle: "CAMPEONES",
          runnerTitle: "DUPLA SUBCAMPEONA",
        },
      },
      tournamentProgress: {
        statuses: {
          finished: "Finalizado",
          inProgress: "En cancha",
          scheduled: "Programado",
          pending: "Pendiente",
        },
        categoryFallback: "Categoría",
        group: "Grupo",
        qualifying: "Clasificatorio",
        roundOf32: "Dieciseisavos de final",
        roundOf16: "Octavos de final",
        quarterfinal: "Cuartos de final",
        semifinal: "Semifinal",
        final: "Final",
        knockout: "Eliminatorias",
        startedPrefix: "Iniciado hace",
        startedSuffix: "",
        lessThanMinute: "menos de 1 min",
        courtFallback: "Cancha por definir",
        imageError: "No fue posible generar la imagen.",
        tournamentFallback: "Torneo TNP",
        dateFallback: "Fecha por definir",
        timeFallback: "Horario por definir",
        groupStage: "Fase de grupos",
        noMatchInBracket: "No se generaron enfrentamientos para esta llave.",
        bracketsTitle: "Llaves",
        timelineTitle: "Cronograma del torneo",
        bracketsDescription:
          "Acompaña los enfrentamientos, ganadores y próximos juegos por categoría.",
        timelineDescription:
          "Consulta el orden de los juegos, horarios, canchas y estado en tiempo real.",
        loading: "Cargando torneo...",
        unpublishedTitle: "Llave aún no publicada",
        unpublishedText: "La llave aparecerá aquí cuando sea generada.",
        championPair: "Dupla campeona",
        finalPrefix: "Final:",
        generatingArtwork: "Generando arte...",
        shareResult: "Compartir resultado",
        category: "Categoría",
        allCategories: "Todas las categorías",
        court: "Cancha",
        allCourts: "Todas las canchas",
        previousDayAria: "Día anterior",
        nextDayAria: "Día siguiente",
        noGames: "No se encontraron juegos",
        timelineUnavailable: "El cronograma aún no fue generado",
        filterHelp:
          "Ajusta los filtros de categoría, cancha o fecha para ver los juegos.",
        timelineHelp:
          "La agenda aparecerá aquí cuando se programen los juegos.",
        previewDialogAria: "Vista previa del resultado",
        previewDescription: "Vista previa del arte Story 1080x1920.",
        closePreviewAria: "Cerrar vista previa",
        previewAlt: "Vista previa del resultado final",
        share: "Compartir",
        downloadPng: "Descargar PNG",
        shareTitle: "Resultado TNP",
        winnerText: "venció",
      },
      actions: {
        retry: "Intentar nuevamente",
        back: "Volver",
      },
      labels: {
        locationFallback: "Lugar por definir",
        playerFallback: "Jugador",
        pendingPair: "Dupla pendiente",
        removedPair: "Resultado pendiente",
        toBeDefined: "Por definir",
        challengeFallback: "Desafío",
        categoryFallback: "Categoría",
        categoryFilterAria: "Filtrar inscripciones por categoría",
        format: "Formato",
        groupStage: "Fase de grupos",
        knockoutStage: "Eliminatorias",
        moreInformation: "Más información",
      },
      tabs: {
        ariaLabel: "Secciones del desafío",
        registrations: "Inscritos",
        matches: "Juegos",
        ranking: "Clasificación",
        brackets: "Llaves",
        eventSchedule: "Cronograma",
        timeline: "Cronograma",
      },
      eventSchedule: {
        title: "Cronograma del torneo",
        summaryTitle: "Resumen del día",
        dayTime: "Horario del día",
        activities: "Actividades",
        gamesActivities: "Actividades de juegos",
        courts: "Canchas y lugares",
        legend: "Leyenda",
        now: "Ahora",
        next: "Próxima actividad",
        noLocation: "Lugar por definir",
        noTime: "Horario por definir",
        timeSeparator: "a",
        activityTypes: {
          games: "Juegos",
          opening: "Apertura",
          checkin: "Acreditación",
          food: "Alimentación",
          coffee: "Café",
          cake: "Torta",
          exercise: "Ejercicio",
          draw: "Sorteo",
          awards: "Premiación",
          celebration: "Confraternización",
          break: "Intervalo",
          general: "Actividad general",
          other: "Otro",
        },
      },
      states: {
        loadErrorFallback: "No fue posible cargar este desafío ahora.",
        notFound: "Desafío no encontrado.",
        canceledAlert:
          "Este desafío fue cancelado. Las inscripciones y juegos fueron interrumpidos.",
        noRegistrations: "Aún no hay inscritos.",
        noRegistrationsText: "Sé el primero en asegurar tu plaza.",
        noMatchesGeneratedTitle: "Juegos aún no generados",
        noMatchesGeneratedText:
          "Las rondas se mostrarán aquí cuando el desafío comience.",
        noMatchesTitle: "Sin juegos registrados",
        noMatchesText:
          "Los enfrentamientos aparecerán aquí cuando sean generados.",
        noRankingTitle: "Clasificación aún no disponible",
        noRankingText:
          "La clasificación se calculará automáticamente después del inicio de los juegos.",
        noRankingResultsTitle: "Esperando resultados",
        noRankingResultsText:
          "Cuando los juegos finalicen, la tabla aparecerá aquí.",
      },
      cta: {
        pendingTitle: "El desafío aún no comenzó",
        pendingTextSingle: "¡Asegura tu plaza y prepárate!",
        pendingTextFixedPair: "¡Asegura la plaza de tu dupla y prepárate!",
        registrationClosedTitle: "Inscripciones cerradas",
        registrationClosedButton: "Inscripciones cerradas",
        registrationClosedFooter:
          "Sigue las categorías, llaves y próximos juegos en esta página.",
        eventUnavailable: "Evento aún no disponible",
        eventUnavailableFooter:
          "Esperando el vínculo del evento para inscripción.",
        registrationStartedTitleSingle: "Ya iniciaste tu inscripción",
        registrationStartedTitleFixedPair:
          "Ya iniciaste la inscripción de tu dupla",
        registrationStartedText:
          "Accede a tu área para acompañar pago y estado.",
        viewMyRegistration: "Ver mi inscripción",
        followRegistration: "Acompañar inscripción",
        waitlistMe: "Estás en la lista de espera.",
        mobileRegister: "Inscribirme",
        goToEventSingle: "Ir al evento e inscribirme",
        goToEventFixedPair: "Ir al evento e inscribir mi dupla",
        soldOutTitle: "Torneo completo",
        soldOutText: "En este momento no hay nuevas plazas disponibles.",
        soldOutButton: "Plazas agotadas",
        soldOutFooter: "Sigue esta página para nuevas actualizaciones.",
        waitlistTextSingle: "Aún puedes entrar en la lista de espera.",
        waitlistTextFixedPair:
          "Aún puedes entrar en la lista de espera con tu dupla.",
        waitlistButtonSingle: "Entrar en lista de espera",
        waitlistButtonFixedPair: "Entrar en lista de espera en dupla",
        waitlistFooter: "Sin plazas inmediatas.",
        availableSlotsPrefix: "Plazas disponibles:",
        registerAnotherCategory: "Inscribirme en otra categoría",
        bracketsGeneratedTitle: "Llaves generadas",
        bracketsGeneratedText:
          "Las inscripciones fueron organizadas y los enfrentamientos ya están disponibles.",
        bracketsGeneratedButton: "Ver llaves",
        bracketsGeneratedFooter:
          "Acompaña los juegos y la evolución por categoría.",
        finishedTitle: "Evento finalizado",
        finishedText:
          "Las inscripciones fueron cerradas y este evento ya terminó.",
        finishedFooter: "Consulta inscritos, juegos y clasificación abajo.",
      },
      registration: {
        title: "Inscritos",
        introSingle:
          "Consulta la lista de jugadores ya inscritos en el desafío.",
        introFixedPair:
          "Consulta la lista de duplas ya inscritas en el desafío.",
        showAll: "Ver todos los inscritos",
        showLess: "Mostrar menos",
        myRegistrationPrefix: "Mi inscripción",
        paymentPrefix: "Pago",
        openPayment: "Abrir pago",
        table: {
          position: "Posición",
          player: "Jugador",
          pair: "Dupla",
          registeredAt: "Inscrito en",
          status: "Estado",
        },
        statuses: {
          confirmed: "Confirmado",
          pendingPayment: "Pendiente",
          waitlist: "Lista de espera",
          canceled: "Cancelado",
          refunded: "Reembolsado",
          pending: "Pendiente",
        },
      },
      matches: {
        title: "Juegos",
        round: "Ronda",
        group: "Grupo",
        final: "Final",
        matchResultAria: "Resultado del partido",
        champion: "Campeona",
        loser: "Perdedora",
        awaitingResult: "Esperando resultado",
        pointsSuffix: "pts",
        status: {
          finished: "Finalizado",
          partial: "Parcial",
          waiting: "Esperando",
        },
      },
      myGames: {
        title: "Mis juegos",
        description: "Consulta todos los juegos que disputarás en este evento.",
        closeAria: "Cerrar Mis juegos",
        category: "Categoría",
        yourPair: "Tu dupla",
        nextGame: "Próximo juego",
        gamePrefix: "Juego",
        loading: "Cargando tus juegos...",
        loadError: "No fue posible cargar tus juegos.",
        retry: "Intenta abrir nuevamente en unos instantes.",
        tournamentEmpty: "Los juegos aún no fueron definidos.",
        challengeEmpty:
          "Estás inscrito, pero los horarios aún no fueron definidos.",
        emptyHelp:
          "Aparecerán aquí cuando la organización publique los enfrentamientos.",
        roundOf32: "Dieciseisavos de final",
        roundOf16: "Octavos de final",
        quarterfinal: "Cuartos de final",
        semifinal: "Semifinal",
        final: "Final",
        roundPrefix: "Ronda",
        gameFallback: "Juego",
        courtFallback: "Cancha por definir",
        courtPrefix: "Cancha",
        dateFallback: "Fecha por definir",
        timeFallback: "Horario por definir",
        waiting: "Esperando",
        inProgress: "En curso",
        finished: "Finalizado",
      },
      shareModal: {
        title: "Compartir torneo",
        description:
          "Muestra este torneo a más jugadores y aumenta las inscripciones.",
        closeAria: "Cerrar opciones de compartir",
        dialogAria: "Compartir torneo",
        previewAlt: "Vista previa del arte del torneo",
        generating: "Generando imagen...",
        unavailable: "Imagen no disponible.",
        copyLink: "Copiar link",
        copy: "Copiar",
        share: "Compartir",
        downloadPng: "Descargar PNG",
        linkLabel: "Link del torneo",
        copied: "Link copiado.",
        copyError: "No fue posible copiar el link.",
        generateError: "No fue posible generar la imagen.",
        instagramHint:
          "Link copiado. Para Instagram o Stories, descarga la imagen y publícala desde la app.",
        athleteFallback: "Jugador TNP",
        categoryFallback: "Categoría definida",
        participating: "Estoy participando",
        titleGoal: "¡Y voy en busca del título!",
        alongsidePrefix: "Junto a",
        championship: "TORNEO",
        date: "Fecha",
        location: "Lugar",
        availableSuffix: "disponibles",
        perPlayerSuffix: "por jugador",
        playToo: "¡Ven a jugar también!",
        secureSpot: "¡Asegura tu plaza y participa en este desafío!",
        tnpChampionship: "TORNEO TNP",
        dateTime: "FECHA Y HORARIO",
        organization: "Organización",
        totalSlots: "Plazas totales",
        availableSlots: "Plazas disponibles",
        valuePerPlayer: "Valor por jugador",
        category: "Categoría",
        pairCta: "¡Asegura la plaza de tu dupla y prepárate!",
      },
      canvasUnavailable: "Canvas no disponible.",
      ranking: {
        title: "Clasificación",
        shareResults: "Compartir resultados",
        shareOk: "Link compartido.",
        copyOk: "Link copiado al portapapeles.",
        shareError: "No fue posible compartir ahora.",
        ariaLabel: "Clasificación del desafío",
        rankHeader: "Pos",
        titleHeaderPlayer: "Jugador",
        titleHeaderPair: "Dupla",
        columns: {
          total: "Total",
          roundShort: "R",
          final: "Final",
          matches: "Juegos",
          matchesShort: "Juegos",
          gamesWon: "Games ganados",
          gamesWonShort: "G+",
          gamesLost: "Games perdidos",
          gamesLostShort: "G-",
          balance: "Saldo",
          balanceShort: "Saldo",
          wins: "Victorias",
          winsShort: "Vict",
          losses: "Derrotas",
          lossesShort: "Der",
        },
      },
      about: {
        title: "Sobre el desafío",
        titleTournament: "Sobre el torneo",
        labels: {
          category: "Categoría",
          format: "Formato",
          slots: "Nº de plazas",
          registration: "Inscripción",
          expectedStart: "Inicio previsto",
          location: "Lugar",
          type: "Tipo",
          howItWorks: "¿Cómo funciona?",
          howItWorksText:
            "Los juegos y rondas se generarán automáticamente después del inicio del desafío.",
          availableSuffix: "disponibles",
          registeredOf: "inscritos de",
          totalSlots: "Plazas totales",
          remainingSlots: "Plazas disponibles",
          perPlayer: "Por jugador",
          showMore: "Ver más",
          showLess: "Mostrar menos",
        },
      },
      format: {
        challenge: "Challenge",
        super8: "Super 8",
        poco: "Poço",
        tournament: "Torneo",
      },
      mode: {
        individual: "Individual",
        fixedPair: "Dupla fija",
        players: "jugadores",
        pairs: "duplas",
        registrationPerPlayerFixedPair: "por jugador (dupla fija)",
      },
    },
    publicTournamentProgress: {
      matchResultAria: "Resultado: {score}",
      sideResultAria: "Resultado de la dupla {side}",
      matchesSuffix: "juegos",
      status: {
        finished: "Finalizado",
        inProgress: "En cancha",
        scheduled: "Programado",
        pending: "Pendiente",
      },
      round: {
        group: "Grupo",
        groupStage: "Fase de grupos",
        playIn: "Clasificatorio",
        roundOf32: "Dieciseisavos de final",
        roundOf16: "Octavos de final",
        quarterfinal: "Cuartos de final",
        semifinal: "Semifinal",
        final: "Final",
        knockout: "Eliminatoria",
      },
      elapsed: {
        lessThanMinute: "Iniciado hace menos de 1 min",
        minutes: "Iniciado hace {minutes} min",
        hoursMinutes: "Iniciado hace {hours}h {minutes}min",
        hours: "Iniciado hace {hours}h",
        daysHours: "Iniciado hace {days}d {hours}h",
        days: "Iniciado hace {days}d",
      },
      fallback: {
        category: "Categoría",
        court: "Cancha por definir",
        side: "Por definir",
        date: "Fecha por definir",
        time: "Horario por definir",
      },
      loadingTournament: "Cargando torneo...",
      headers: {
        bracketsTitle: "Llaves",
        timelineTitle: "Timeline del torneo",
        bracketsDescription:
          "Acompaña los cruces, ganadores y próximos juegos por categoría.",
        timelineDescription:
          "Ve el orden de los juegos, horarios, canchas y estado en tiempo real.",
      },
      empty: {
        noBracketMatches: "No se generó ningún cruce para esta llave.",
        bracketTitle: "Llave aún no publicada",
        bracketText:
          "La llave aparecerá aquí cuando la organización genere los cruces.",
        noGamesTitle: "No se encontraron juegos",
        timelineNotGeneratedTitle: "Timeline aún no generado",
        noGamesText:
          "Ajusta los filtros de categoría, cancha o fecha para ver los juegos programados.",
        timelineNotGeneratedText:
          "La agenda aparecerá aquí cuando los juegos sean programados.",
      },
      champion: {
        label: "Dupla campeona",
        finalPrefix: "Final:",
      },
      actions: {
        shareResult: "Compartir resultado",
        generatingArt: "Generando arte...",
        share: "Compartir",
        downloadPng: "Descargar PNG",
      },
      filters: {
        category: "Categoría",
        allCategories: "Todas las categorías",
        court: "Cancha",
        allCourts: "Todas las canchas",
        previousDay: "Día anterior",
        nextDay: "Próximo día",
      },
      timeline: {
        scheduled: "Previsto",
      },
      sharePreview: {
        ariaLabel: "Vista previa del resultado",
        title: "Compartir resultado",
        description: "Vista previa del arte en formato Story 1080x1920.",
        closeAria: "Cerrar vista previa",
        imageAlt: "Vista previa del resultado final",
        nativeTitle: "Resultado TNP",
        nativeText: "{champion} ganó {category}",
      },
      canvas: {
        imageError: "No fue posible generar la imagen.",
        unavailableCanvas: "Canvas no disponible.",
        championLabels: {
          female: {
            title: "CAMPEONAS",
            championBadge: "DUPLA CAMPEONA",
            championSideTitle: "CAMPEONAS",
            runnerTitle: "VICECAMPEONAS",
          },
          male: {
            title: "CAMPEONES",
            championBadge: "DUPLA CAMPEONA",
            championSideTitle: "CAMPEONES",
            runnerTitle: "VICECAMPEONES",
          },
          mixed: {
            title: "DUPLA CAMPEONA",
            championBadge: "CAMPEONES DEL MIXTO",
            championSideTitle: "CAMPEONES",
            runnerTitle: "DUPLA VICECAMPEONA",
          },
          neutral: {
            title: "DUPLA CAMPEONA",
            championBadge: "DUPLA CAMPEONA",
            championSideTitle: "CAMPEONA",
            runnerTitle: "VICECAMPEONA",
          },
        },
        firstPlacePrefix: "1ª",
        shareLine1: "COMPARTE",
        shareLine2: "TU VICTORIA!",
        markInstagram: "MARCA @TODOSNOPADEL",
        experienceLine1: "MÁS QUE UN TORNEO,",
        experienceLine2: "UNA EXPERIENCIA!",
        socialLine: "◎  ♪  ▶  @TODOSNOPADEL",
        athleteFallback: "Atleta TNP",
      },
    },
  },
  profile: {
    user: {
      title: "Perfil del usuario",
      subtitle: "Datos de tu cuenta.",
      emptyMessage: "Necesitas iniciar sesión para acceder a tu perfil.",
      goToLogin: "Ir al login",
      saveError: "No fue posible guardar los datos del perfil.",
      completeProfile: "Completar perfil",
      roleLabels: { admin: "ADM", organizer: "Organizador", user: "Jugador" },
      unconfirmedEmail: "Correo no confirmado",
      avatarAriaLabel: "Foto del perfil",
      editAvatarPhoto: "Editar foto",
      saveAvatarCrop: "Guardar recorte",
      avatarSaveSuccess: "Foto de perfil actualizada correctamente.",
      shareProfile: "Compartir perfil",
      stats: {
        runnerUps: "Subcampeonatos",
        currentCategory: "Categoría actual",
        rankingPosition: "Posición en el ranking",
        memberSince: "Miembro desde",
      },
      tabs: {
        profile: "Mi perfil",
        security: "Seguridad",
        challenges: "Mis desafíos",
        registrations: "Mis inscripciones",
      },
      labels: {
        avatar: "Foto de perfil",
        name: "Nombre",
        email: "Correo",
        cpf: "CPF",
        phone: "Teléfono",
        sex: "Sexo",
        category: "Categoría",
        club: "Club vinculado",
        noClub: "Sin club vinculado",
        sidePreference: "Lado preferido",
      },
      sidePreference: {
        both: "Juego de ambos lados",
        left: "Prefiero izquierda",
        right: "Prefiero derecha",
      },
      cpfInfoAriaLabel: "¿Por qué no puedo editar el CPF?",
      cpfInfo:
        "El CPF no puede ser editado por el usuario porque es un dato sensible. Solo los administradores pueden modificarlo.",
      categoryLocked:
        "La categoría ya está definida. Para cambiarla, envía una solicitud al equipo ADM.",
      loadingCategoryRequests: "Cargando solicitudes...",
      pendingCategoryRequestPrefix: "Solicitud pendiente:",
      pendingCategoryRequestTo: "para",
      requestCategoryChange: "Solicitar cambio de categoría",
      noChanges: "No hay cambios para guardar.",
      saveSuccess: "Datos actualizados correctamente.",
      outdatedServer:
        "Servidor desactualizado. Reinicia el backend (`npm run server`) e inténtalo de nuevo.",
      cancel: "Cancelar",
      saveChanges: "Guardar cambios",
      saving: "Guardando...",
      notProvided: "No informado",
      dashboard: {
        stats: {
          matches: "Partidos disputados",
          playedMatches: "Partidos jugados",
          titles: "Títulos conquistados",
          runnersUp: "Subcampeonatos",
          category: "Categoría actual",
          rankingPosition: "Posición en el ranking",
          events: "Eventos disputados",
        },
        shareProfile: "Compartir perfil",
        eventsTitle: "Mis eventos",
        eventsSubtitle: "Acompaña tu recorrido en TNP.",
        overviewTitle: "Perfil del usuario",
        overviewSubtitle: "Datos de tu cuenta.",
        personalInfo: "Información personal",
        memberSince: "Miembro desde",
        requestReviewHint: "Tu solicitud será analizada por el equipo TNP.",
        requestApprovalHint:
          "El cambio solo será aplicado después de la aprobación.",
        requestReason: "Motivo de la solicitud",
        selectRequestReason: "Selecciona el motivo de la solicitud",
        observationOptional: "Observación (opcional)",
        observationPlaceholder: "Cuéntanos más detalles sobre tu solicitud...",
        searchEvent: "Buscar evento",
        filtersAria: "Filtros",
        eventStatusAria: "Estado del evento",
        eventTypeAria: "Tipo de evento",
        eventEmpty: "No se encontraron eventos.",
        eventFilters: {
          all: "Todos",
          pending: "Por iniciar",
          started: "En curso",
          finished: "Finalizado",
          tournaments: "Torneos",
          challenge: "Challenge",
          super8: "Super8",
          poco: "Poço",
        },
        categoryReasons: [
          "Evolución técnica",
          "Reclasificación por desempeño",
          "Corrección de registro",
          "Orientación de la organización",
          "Otro motivo",
        ],
        requestReasonRequired: "Selecciona el motivo de la solicitud.",
        pendingRequest:
          "Ya tienes una solicitud de cambio de categoría en análisis.",
        share: {
          dialogAria: "Compartir perfil",
          title: "Compartir perfil",
          description: "Arte para Story 1080x1920 con tu recorrido en TNP.",
          closeAria: "Cerrar opciones de compartir",
          previewAlt: "Vista previa del arte del perfil",
          generating: "Generando arte...",
          unavailable: "Arte no disponible.",
          share: "Compartir",
          downloadPng: "Descargar PNG",
          copyLink: "Copiar link",
          generateError: "No fue posible generar el arte del perfil.",
          copied: "Link copiado.",
          copyError: "No fue posible copiar el link.",
          shareTitle: "Mi perfil TNP",
          directUnavailable:
            "La opción de compartir directamente no está disponible. El arte fue descargado.",
          journey: "Mi recorrido en TNP",
          sportsProfile: "PERFIL DEPORTIVO",
          athleteFallback: "Jugador TNP",
          categoryFallback: "Categoría no informada",
          rankingSuffix: "en el ranking",
          rankingProgress: "Ranking en evolución",
          noRankingPosition: "Sin posición",
          noRankingHint: "Aún sin puntos",
          rankingPositionLabel: "posición",
          rankingStatusLabel: "estado",
        },
      },
      achievements: {
        title: "Logros",
        description: "Badges desbloqueados durante tu recorrido en TNP.",
        loading: "Cargando logros...",
        loadError: "No fue posible cargar los logros.",
        unlockedCountPrefix: "Desbloqueadas",
        unlockedAt: "Conquistada el",
        locked: "Bloqueada",
        types: {
          athlete: "Atleta",
          organizer: "Organizador",
          event: "Evento",
          ranking: "Ranking",
          participation: "Participación",
        },
      },
      notificationPreferences: {
        title: "Preferencias de notificaciones",
        description: "Elige qué avisos quieres recibir dentro de TNP.",
        loading: "Cargando preferencias...",
        loadError: "No fue posible cargar las preferencias.",
        saveError: "No fue posible guardar las preferencias.",
        saveSuccess: "Preferencias guardadas.",
        save: "Guardar preferencias",
        saving: "Guardando...",
        options: {
          inApp: "Notificaciones en el sitio",
          email: "Notificaciones por e-mail",
          events: "Notificaciones de eventos",
          ranking: "Notificaciones de ranking",
          payments: "Notificaciones de pagos",
          achievements: "Notificaciones de logros",
        },
      },
      organizerStatistics: {
        title: "Estadísticas del Organizador",
        description: "Acompaña el desempeño de tus eventos en TNP.",
        adminScope: "Todos los organizadores",
        loading: "Cargando estadísticas...",
        loadError: "No fue posible cargar las estadísticas.",
        emptyValue: "Sin datos",
        emptyChart: "Sin datos para este período.",
        dateFrom: "Fecha inicial",
        dateTo: "Fecha final",
        invalidDateRange: "La fecha final debe ser posterior a la fecha inicial.",
        periods: {
          all: "Siempre",
          current_year: "Año actual",
          last_30: "Últimos 30 días",
          last_90: "Últimos 90 días",
          custom: "Período personalizado",
        },
        chartPeriods: {
          lastMonth: "Último mes",
          lastSixMonths: "Últimos 6 meses",
          lastYear: "Último año",
          allTime: "Todo el período",
          allPeriods: "Todos los períodos",
        },
        cards: {
          completedEvents: "Eventos realizados",
          futureEvents: "Eventos futuros",
          uniqueAthletes: "Atletas únicos",
          totalRegistrations: "Total de inscripciones",
          soldOutEvents: "Eventos llenos",
          estimatedRevenue: "Ingresos estimados",
          averageAthletes: "Promedio de atletas por evento",
          popularCategory: "Categoría más popular",
        },
        byTypeTitle: "Estadísticas por tipo de evento",
        internalRankingTitle: "Ranking interno del organizador",
        eventTypes: {
          challenge: "Challenge",
          super8: "Super8",
          poco: "Poço",
          tournament: "Torneos",
        },
        metrics: {
          completed: "Realizados",
          registrations: "Inscritos",
          average: "Promedio",
        },
        ranking: {
          mostParticipations: "Atleta con más participaciones",
          mostTitles: "Atleta con más títulos",
          mostRecurring: "Atleta más recurrente",
          topCategory: "Categoría con más inscritos",
          topEvent: "Evento con mayor número de inscritos",
        },
        charts: {
          registrationsByMonth: "Inscripciones por mes",
          revenueByMonth: "Ingresos estimados por mes",
          eventsByMonth: "Eventos por mes",
          categories: "Categorías más populares",
        },
        chartDescriptions: {
          registrationsByMonth:
            "Inscripciones confirmadas agrupadas por mes.",
          revenueByMonth:
            "Ingresos estimados a partir de las inscripciones confirmadas.",
          eventsByMonth: "Cantidad de eventos realizados en cada mes.",
          categories: "Categorías con mayor volumen de inscritos.",
        },
        chartMetricLabels: {
          registrationsByMonth: "inscripciones por mes",
          revenueByMonth: "ingresos estimados por mes",
          eventsByMonth: "eventos por mes",
          categories: "inscripciones por categoría",
        },
        chartEmptyMessages: {
          insufficientData:
            "No hay datos suficientes para mostrar este gráfico.",
          noData: "No se encontraron datos para este período.",
          noRevenue: "No hay ingresos confirmados en este período.",
        },
        chartNote:
          "Los datos se actualizan en tiempo real a medida que se registran nuevos eventos e inscripciones.",
      },
      organizerRanking: {
        title: "Ranking del Organizador",
        description:
          "Define la tabla de puntuación usada solo en los rankings de tus eventos.",
        info:
          "El Ranking Oficial TNP siempre utiliza la puntuación oficial de la plataforma. Esta configuración altera solo el ranking propio de este organizador.",
        scoringMode: "Modo de puntuación",
        modes: {
          tnp_standard: "Estándar TNP",
          duplicate: "Duplicar estándar TNP",
          custom: "Personalizado",
        },
        modeDescriptions: {
          tnp_standard: "Usa la puntuación oficial, sin edición.",
          custom: "Permite editar la puntuación de tus eventos.",
        },
        modalities: {
          super8: "Super 8",
          challenge: "Challenge",
          poco: "Poço",
          tournament: "Torneos",
        },
        fields: {
          first: "1º Lugar",
          second: "2º Lugar",
          third: "3º Lugar",
          fourth: "4º Lugar",
          fifth: "5º Lugar",
          sixth: "6º Lugar",
          seventh: "7º Lugar",
          eighth: "8º Lugar",
          participation: "Participación",
          champion: "Campeón",
          runnerUp: "Vice",
          semifinal: "Semifinal",
          quarterfinal: "Cuartos",
        },
        loading: "Cargando puntuación...",
        save: "Guardar puntuación",
        saving: "Guardando...",
        restoreDefault: "Restaurar estándar TNP",
        restoreConfirm:
          "¿Deseas restaurar el modo estándar TNP? Tu puntuación personalizada dejará de usarse.",
        duplicateOfficial: "Duplicar puntuación oficial TNP",
        duplicateAgain: "Duplicar nuevamente desde TNP",
        duplicatedNotice:
          "Esta tabla fue creada a partir de la puntuación oficial TNP. Ahora puede modificarse sin afectar el Ranking Oficial.",
        replaceConfirm:
          "¿Deseas sustituir tu puntuación actual por la puntuación oficial TNP?",
        validationError: "Ingresa una puntuación válida.",
        loadError: "No fue posible cargar la puntuación del organizador.",
        saveError: "No fue posible guardar la puntuación del organizador.",
        saveSuccess: "Puntuación del organizador guardada.",
        resetSuccess: "Puntuación restaurada al estándar TNP.",
      },
      visualIdentity: {
        title: "Identidad Visual",
        description:
          "Personaliza los colores usados en los materiales de tus eventos.",
        info:
          "Las configuraciones de esta sección se utilizarán solo en los eventos organizados por ti. El resto de la plataforma seguirá usando la identidad oficial TNP.",
        logoTitle: "Logo del organizador",
        publicName: "Nombre público del organizador",
        publicNamePlaceholder: "Nombre mostrado en la vitrina",
        logoDescription:
          "Usa una imagen PNG, JPG, JPEG o WEBP de hasta 2MB.",
        logoHelp:
          "El logo se guarda en tu perfil y puede reutilizarse en los eventos organizados por ti.",
        logoPreviewAlt: "Vista previa del logo del organizador",
        uploadLogo: "Subir logo",
        replaceLogo: "Cambiar logo",
        removeLogo: "Eliminar logo",
        invalidLogo: "Sube una imagen PNG, JPG, JPEG o WEBP válida.",
        logoTooLarge: "El logo debe tener como máximo 2MB.",
        logoInvalidDimensions:
          "El logo debe tener entre 64 y 4096 píxeles de ancho y alto.",
        mode: "Modo de identidad",
        backgroundNotice:
          "Elige el fondo usado en las pantallas públicas de tus eventos.",
        backgroundTitle: "Fondo de las pantallas",
        backgrounds: {
          blue: "Azul (estándar)",
          black: "Negro",
          white: "Blanco",
        },
        modes: {
          tnp_standard: "Estándar TNP",
          custom: "Personalizado",
        },
        modeDescriptions: {
          tnp_standard:
            "Usa los colores oficiales de TNP en los materiales de tus eventos.",
          custom:
            "Permite elegir tus propios colores para materiales y pantallas vinculadas a tus eventos.",
        },
        fields: {
          primaryColor: "Color Primario",
          secondaryColor: "Color Secundario",
          accentColor: "Color de Destaque",
        },
        usage: {
          primaryColor:
            "Usado en botones, links, títulos, iconos principales y barras de progreso.",
          secondaryColor:
            "Usado en gradientes, cards, botones secundarios y badges.",
          accentColor:
            "Usado en campeón, cronómetro, alertas, últimas plazas, destaques visuales y glow.",
        },
        previewTitle: "Vista previa de la identidad visual",
        previewRanking: "Ranking del Organizador",
        previewShare: "Compartir Ranking",
        previewPlayers: ["João Silva", "Maria Souza", "Pedro Lima"],
        hexPlaceholder: "#2B9CDF",
        loading: "Cargando identidad visual...",
        save: "Guardar identidad",
        saving: "Guardando...",
        restoreDefault: "Restaurar estándar TNP",
        validationError: "Usa colores HEX válidos en el formato #2B9CDF.",
        contrastWarning:
          "Esta combinación puede dificultar la lectura. Recomendamos usar colores con mayor contraste.",
        loadError: "No fue posible cargar la identidad visual.",
        saveError: "No fue posible guardar la identidad visual.",
        saveSuccess: "Identidad visual guardada.",
        resetSuccess: "Identidad visual restaurada al estándar TNP.",
      },
      categoryRequest: {
        title: "Solicitar cambio de categoría",
        newCategory: "Nueva categoría deseada",
        selectCategory: "Selecciona una categoría",
        reason: "Motivo (opcional)",
        reasonLabel: "Motivo de la solicitud",
        reasonSelectPlaceholder: "Selecciona el motivo de la solicitud",
        reasonSelectShortPlaceholder: "Selecciona el motivo",
        observation: "Observación (opcional)",
        observationPlaceholder: "Agrega más detalles sobre tu solicitud...",
        modalObservationPlaceholder:
          "Escribe una observación para ayudar en el análisis.",
        reviewHint: "Tu solicitud será revisada por el equipo TNP.",
        approvalHint: "El cambio solo será aplicado después de la aprobación.",
        currentUserCategory: "Categoría actual del usuario",
        reasonPlaceholder: "Explica brevemente el motivo del cambio.",
        observationPrefix: "Observación:",
        sending: "Enviando...",
        submit: "Enviar solicitud",
        categoryRequired: "Selecciona la categoría deseada.",
        differentCategory:
          "La categoría solicitada debe ser diferente de la actual.",
        success: "Solicitud enviada para revisión de los administradores.",
        error: "No fue posible enviar la solicitud.",
        historyEyebrow: "Historial",
        historyTitle: "Historial de solicitudes",
        historyEmpty: "No hay solicitudes de cambio de categoría registradas.",
        historyTo: "a",
        requestedAt: "Solicitada el",
        resolvedAt: "Respondida el",
        adminResponse: "Respuesta del administrador",
        noAdminResponse: "La solicitud fue rechazada sin un mensaje adicional.",
        statuses: {
          pending: "Pendiente",
          approved: "Aceptada",
          rejected: "Rechazada",
        },
      },
      security: {
        description: "Cambio de contraseña y configuración de acceso.",
        emailTitle: "Correo de acceso",
        pendingEmailPrefix: "Correo pendiente de confirmación:",
        generatingLink: "Reenviando...",
        confirmEmail: "Reenviar correo de confirmación",
        updateEmail: "Actualizar correo",
        emailSaving: "Guardando...",
        emailUpdated: "Correo actualizado.",
        emailUpdateError: "No fue posible actualizar el correo.",
        emailRequestRegisteredPrefix:
          "Solicitud registrada. Enviamos un correo de confirmación a:",
        confirmationLinkSuccess: "Correo de confirmación reenviado.",
        confirmationLinkError:
          "No fue posible reenviar el correo de confirmación.",
        passwordTitle: "Cambiar contraseña",
        currentPassword: "Contraseña actual",
        newPassword: "Nueva contraseña",
        confirmNewPassword: "Confirmar nueva contraseña",
        passwordUpdating: "Actualizando contraseña...",
        updatePassword: "Actualizar contraseña",
        passwordRequired: "Informa la contraseña actual y la nueva contraseña.",
        passwordMinLength:
          "La nueva contraseña debe tener al menos 4 caracteres.",
        passwordMismatch: "La confirmación de la nueva contraseña no coincide.",
        passwordUpdated: "Contraseña cambiada correctamente.",
        passwordUpdateError: "No fue posible cambiar la contraseña.",
      },
      challenges: {
        matchesSuffix: "partidos",
        viewDetails: "Ver detalles",
        openMap: "Abrir ubicación en el mapa",
        copyLocation: "Copiar dirección",
        locationCopied: "Dirección copiada.",
        copyLocationError: "No fue posible copiar la dirección.",
        empty: "No hay desafíos en esta sección.",
        paginationAria: "Paginación de eventos",
        previousPage: "Página anterior",
      },
    },
    myGames: {
      title: "Juegos de torneos y desafíos",
      subtitle:
        "Acompaña tus juegos de torneos y desafíos, horarios, canchas y resultados.",
      empty: "No se encontraron juegos.",
      loadError: "No fue posible cargar tus juegos.",
      modalSubtitle: "Juegos liberados para esta inscripción.",
      closeModal: "Cerrar juegos",
      upcomingTitle: "Próximos juegos",
      confirmedOpenMatchesTitle: "Partidas abiertas confirmadas",
      historyTitle: "Historial y resultados",
      noUpcoming: "No tienes próximos juegos programados.",
      noConfirmedOpenMatches:
        "Ninguna partida abierta confirmada por el organizador.",
      openMatchConfirmed: "Participación confirmada por el organizador",
      noHistory: "Aún no hay resultados publicados.",
      categoryFallback: "Categoría",
      courtFallback: "Cancha a definir",
      viewTournament: "Ver torneo",
      scorePending: "Resultado pendiente",
      unscheduled: "Horario a definir",
      result: {
        win: "Victoria",
        loss: "Derrota",
        finished: "Finalizado",
        pending: "Pendiente",
      },
    },
    openMatches: {
      title: "Partidas abiertas",
      subtitle:
        "Gestiona partidas que creaste y acompaña tus invitaciones y solicitudes.",
      empty: "No se encontraron partidas abiertas.",
      emptyHint:
        "Cuando crees o participes en una partida abierta, aparecerá aquí.",
      loadError: "No fue posible cargar tus partidas abiertas.",
      groupEmpty: "No hay partidas en esta sección.",
      view: "Ver partida",
      edit: "Editar",
      updateSuccess: "Partida actualizada.",
      clubFallback: "Club a definir",
      slotsSuffix: "cupos disponibles",
      requestsTitle: "Solicitudes e invitaciones",
      groups: {
        created: "Creadas por mí",
        confirmed: "Confirmadas",
        invites: "Invitaciones",
        pending: "Solicitudes pendientes",
        waitlist: "Reservas",
        history: "Historial",
        canceled: "Canceladas",
      },
    },
    registrations: {
      title: "Mis inscripciones",
      subtitle: "Acompaña el estado de tus inscripciones en los eventos.",
      filters: {
        all: "Todas",
        confirmed: "Confirmadas",
        pending: "Pendientes",
        waitlist: "Lista de espera",
        canceled: "Canceladas",
        overdue: "Vencidas",
      },
      statuses: {
        confirmed: "Confirmada",
        pending: "Pendiente",
        waitlist: "Lista de espera",
        canceled: "Cancelada",
        overdue: "Vencida",
      },
      hints: {
        confirmedDefault: "Pago confirmado",
        confirmedAtPrefix: "Pagado en",
        waitlistDefault: "Esperando apertura de plaza",
        waitlistPaid: "Pago confirmado, esperando plaza",
        overdueDefault: "Cobro vencido",
        overdueAtPrefix: "Vencida en",
        canceledDefault: "Inscripción cancelada",
        canceledAtPrefix: "Cancelada en",
        pendingPairPrefix: "Esperando pago de la dupla",
        pendingDefault: "Esperando confirmación del pago",
      },
      mode: {
        individual: "Individual",
        fixedPair: "Dupla",
      },
      actions: {
        payNow: "Pagar ahora",
        viewGames: "Ver juegos",
        viewDetails: "Ver detalles",
        cancel: "Cancelar inscripción",
        remove: "Eliminar inscripción",
        canceling: "Cancelando...",
        removing: "Eliminando...",
      },
      filtersAriaLabel: "Filtro de inscripciones",
      toasts: {
        cancelSuccess: "Inscripción cancelada.",
        cancelError: "No fue posible cancelar la inscripción.",
        deleteSuccess: "Inscripción eliminada de tu lista.",
        deleteError: "No fue posible eliminar la inscripción.",
      },
      teammatePrefix: "Tú y",
      empty: "No se encontraron inscripciones.",
      emptyByFilter: "No hay inscripciones para este filtro.",
    },
  },
  ranking: {
    hub: {
      title: "Rankings",
      subtitle: "Acompaña la evolución de jugadores y organizadores de TNP.",
      officialCard: {
        title: "Ranking Oficial TNP",
        description:
          "Acompaña el ranking general de todos los jugadores del circuito TNP.",
        cta: "Ver Ranking",
        stats: {
          players: "Jugadores",
          season: "Temporada",
          continuousUpdateLine1: "Actualización",
          continuousUpdateLine2: "continua",
        },
      },
      organizersCard: {
        title: "Rankings de Organizadores",
        description:
          "Explora rankings personalizados de organizadores aliados.",
        cta: "Explorar Organizadores",
        stats: {
          organizers: "Organizadores",
          players: "Jugadores",
          events: "Eventos",
        },
      },
    },
    organizersDirectory: {
      title: "Seleccionar Organizador",
      subtitle: "Elige un organizador para abrir el ranking correspondiente.",
      loading: "Cargando organizadores...",
      loadError: "No fue posible cargar los organizadores.",
      loadMoreError: "No fue posible cargar más organizadores.",
      empty: "No hay organizadores registrados.",
      searchPlaceholder: "Escribe el nombre del organizador",
      searchAriaLabel: "Buscar organizador por nombre",
      searchButtonAriaLabel: "Buscar organizador",
      loadMore: "Cargar más",
      loadingMore: "Cargando...",
      sortLabel: "Ordenar por",
      sortOptions: {
        name: "Nombre A-Z",
        athletes: "Más jugadores",
        events: "Más eventos",
        updated: "Actualizados recientemente",
      },
      selectedTitle: "Selecciona un Ranking",
      selectedSubtitle:
        "Elige el organizador o club para ver el ranking correspondiente.",
      searchExpandedPlaceholder: "Buscar organizador, club o arena...",
      featuredTitle: "Más visitados",
      allTitle: "Todos los organizadores",
      emptySearch: "No se encontraron rankings.",
      rankingCountSuffix: "rankings",
      athletes: "jugadores",
      events: "eventos",
      viewRanking: "Ver ranking",
      viewRankingAriaPrefix: "Ver ranking de",
      openRankingAriaPrefix: "Abrir ranking de",
      updatedAtPrefix: "Actualizado el",
    },
    page: {
      modeTabs: {
        all: "General",
        super8: "Super8",
        challenge: "Challenge",
        poco: "Pozo",
        tournament: "Torneo",
      },
      sourceTabs: { official: "Oficiales", organizer: "Organizadores" },
      categoryTabs: {
        open: "Open",
        c2a: "2ª",
        c3a: "3ª",
        c4a: "4ª",
        c5a: "5ª",
        c6a: "6ª",
        c7a: "Iniciante",
      },
      labels: {
        source: "Origen",
        modality: "Modalidad",
        organizer: "Organizador",
        allOrganizers: "Todos",
        disabledOrganizerOption: "—",
        category: "Categoría",
        period: "Período",
        points: "Puntos",
        scoringStandard: "Patron de puntuacion",
        uncategorized: "Sin categoría",
        rank: "Pos",
        name: "Nombre",
        filters: "Filtros",
        moreInformation: "Más información",
        mobileControls: "Controles de filtros e información",
        dateFrom: "Fecha inicial",
        dateTo: "Fecha final",
        consideredStages: "Etapas consideradas",
        selectAll: "Seleccionar todas",
        stageFallback: "Etapa",
      },
      periodOptions: {
        allTime: {
          label: "Siempre",
          description: "Ranking histórico completo",
        },
        last4: {
          label: "Últimas 4 etapas",
          description: "Considera solo las últimas 4 etapas",
        },
        last8: {
          label: "Últimas 8 etapas",
          description: "Considera solo las últimas 8 etapas",
        },
        last30: {
          label: "Últimos 30 días",
          description: "Considera eventos de los últimos 30 días",
        },
        last90: {
          label: "Últimos 90 días",
          description: "Considera eventos de los últimos 90 días",
        },
        currentYear: {
          label: "Año actual",
          description: "Considera eventos del año actual",
        },
        custom: {
          label: "Personalizado",
          description: "Elige un período específico",
        },
      },
      summaryCards: {
        leader: "Líder actual",
        noLeader: "Sin líder",
        waitingRanking: "Esperando ranking",
        countedEvents: "Eventos contabilizados",
        allHistory: "En todo el historial",
        periodEvents: "Eventos en el período",
        rankedAthletes: "Jugadores rankeados",
        currentSelection: "En la selección actual",
        currentPeriod: "Período actual",
      },
      messages: {
        noOrganizerRankings:
          "Aún no hay rankings de organizadores para mostrar.",
        hint: "El ranking suma puntos por persona dentro de la categoría seleccionada.",
        availableCategoriesOnly:
          "Mostramos solo las categorías con ranking publicado. Las demás aún no tienen datos disponibles.",
        customScoringInfo:
          "Este ranking utiliza una tabla de puntuacion configurada por el organizador y puede ser diferente del Ranking Oficial TNP.",
        empty: "No hay resultados finalizados para esta categoría.",
        loadError: "No fue posible cargar el ranking.",
        historyLoadError: "No fue posible cargar el historial del jugador.",
        genderTooltip:
          "Filtra el ranking por género: todos, femenino o masculino.",
        invalidDateRange:
          "La fecha final debe ser posterior a la fecha inicial.",
        noStagesForPeriod:
          "No se encontraron etapas para este período.",
        viewHistoryPrefix: "Ver historial deportivo de",
        athleteFallback: "jugador",
        emptyFinishedTitle: "No hay resultados finalizados",
        emptyFinishedHint:
          "Ajusta los filtros o espera la finalización de eventos para esta categoría.",
        historyAriaPrefix: "Historial de",
        historyTitle: "Historial deportivo",
        closeHistory: "Cerrar historial",
        emptyHistory:
          "Este jugador aún no tiene participaciones registradas en este ranking.",
      },
      titleFallbacks: {
        ranking: "Ranking",
        organizerRanking: "Ranking Organizadores",
        organizerById: "Ranking Organizador #",
      },
      ariaLabel: "Ranking general",
    },
    shareModal: {
      shareAction: "Compartir",
      title: "Compartir ranking",
      closeAria: "Cerrar compartir",
      previewAlt: "Vista previa del arte de ranking",
      generatingImage: "Generando imagen...",
      imageUnavailable: "Imagen no disponible.",
      whatsapp: "WhatsApp",
      instagramStories: "Instagram/Stories",
      copyLink: "Copiar link",
      downloadImage: "Descargar imagen",
      copiedLink: "Link copiado.",
      copyError: "No fue posible copiar el link.",
      generateError: "No fue posible generar la imagen del ranking.",
      directUnavailable:
        "Compartir directamente no está disponible. La imagen fue descargada.",
      storiesHint: "Para Stories, descarga la imagen y publícala en Instagram.",
      shareTitle: "Ranking TNP",
      shareTextPrefix: "Consulta el Ranking",
      athleteFallback: "Atleta",
      canvas: {
        positionLabel: "TU POSICIÓN",
        currentUserTop: "¡Estás en {position}º lugar!",
        topCategoryMessage:
          "Felicitaciones por estar entre los mejores de la categoría!",
        pointsSuffix: "pts",
        unavailableCanvas: "Canvas no disponible.",
        imageError: "No fue posible generar la imagen.",
      },
    },
  },
  imageUpload: {
    change: "Cambiar",
    edit: "Editar",
    remove: "Eliminar",
    noImageSelected: "Ninguna imagen seleccionada.",
    helpText:
      "PNG/JPG recomendado. En el modal, usa scroll o el control de zoom y arrastra para reposicionar.",
    cropTitle: "Ajuste de foto",
    horizontalAdjust: "Ajuste horizontal",
    verticalAdjust: "Ajuste vertical",
    applyCrop: "Aplicar recorte",
    cropError:
      "No fue posible recortar esta imagen. Intenta cambiarla por un archivo JPG/PNG local.",
    selectImageFor: "Seleccionar imagen para",
    cropImageOf: "Ajuste de foto de",
    previewSuffix: "vista previa",
  },
  challengeEngine: {
    labels: {
      right: "Derecha",
      left: "Izquierda",
      rightAndLeft: "Derecha + Izquierda",
      sidePreferenceMissing: "Preferencia no informada (ambos)",
      registeredPlayers: "Jugadores registrados",
      playerPlaceholder: "Documento o nombre del jugador",
      player: "Jugador",
      nonePairDrawn: "Ninguna dupla sorteada.",
      saveDrawPairs: "Guardar sorteo",
      savingDrawPairs: "Guardando sorteo...",
      drawPairsSaved: "Sorteo de duplas guardado con éxito.",
      drawPairsSaveError: "No fue posible guardar el sorteo de duplas.",
      pairNumber: "Dupla",
      sidePrefix: "Lado",
      openRegistrationsBeforeParticipants:
        "Abra las inscripciones antes de agregar participantes.",
      closeRegistrationsBeforeStructure:
        "Cierre las inscripciones antes de generar llaves o rondas.",
      competitionAlreadyStarted:
        "La competición ya fue iniciada o finalizada.",
      generateStructureBeforeStart:
        "Genere las llaves o rondas antes de iniciar la competición.",
      remove: "Eliminar",
      drawPairs: "Sortear duplas",
      drawedPairs: "Duplas sorteadas",
      drawedPairsHint:
        "Revise las duplas sorteadas. Luego genere las rondas del grupo.",
      generateRounds: "Generar rondas del grupo",
      startSuper8Message:
        "Registra 8 jugadores y genera las rondas para comenzar.",
      adminLoginToPersist:
        "Para guardar en la base de datos, inicia sesión como admin (token tnp-token). Sin eso, queda guardado solo en este navegador.",
      playerAlreadySelected:
        "Este jugador ya fue seleccionado y no puede entrar en más de una dupla.",
      sidePreferenceAria: "Preferencia de lado",
      round: "Ronda",
    },
    checkIn: {
      confirm: "Confirmar llegada",
      undo: "Deshacer llegada",
      present: "Presente",
      waitingArrival: "Esperando llegada",
      waitingParticipants: "Esperando participantes",
      waitingOpponents: "Esperando adversarios",
      readyToCall: "Listo para llamar",
      confirmError: "No se pudo confirmar la llegada.",
      undoError: "No se pudo deshacer la llegada.",
    },
    courtStatus: {
      putOnCourt: "Poner en Cancha",
      removeFromCourt: "Retirar de la Cancha",
      onCourt: "En Cancha",
      onCourtGames: "Juegos en Cancha",
      waiting: "Esperando",
      finished: "Finalizado",
      addResult: "Agregar Resultado",
      resultRequiresCourt: "Esta partida aún no está en cancha.",
      resultRequiresCourtLong:
        "No se puede agregar el resultado porque esta partida aún no está en cancha.",
      updateError: "No se pudo actualizar el estado de la partida.",
      uncheckedParticipants: "Hay participantes sin check-in confirmado.",
      confirmStartWithUnchecked:
        "Hay participantes sin check-in confirmado.\n\n¿Desea poner esta partida en cancha de todos modos?",
      undefinedParticipants:
        "Defina los participantes antes de poner la partida en cancha.",
      courtCapacityWarning:
        "Hay más partidas en cancha que canchas registradas.",
      registeredCourts: "canchas registradas",
      court: "Cancha",
    },
  },
  admin: {
    pageTitle: "Panel del administrador",
    pageTitleOrganizer: "Panel del organizador",
    pageSubtitle:
      "Gestiona sitio, usuarios, desafíos e histórico en un solo lugar.",
    pageSubtitleOrganizer:
      "Gestiona tus desafíos, inscripciones y usuarios vinculados a tus eventos.",
    tabs: {
      content: "Contenido",
      users: "Usuarios",
      history: "Desafíos",
      tournaments: "Torneos",
      clubs: "Clubes",
      categoryRequests: "Cambios de categoría",
      registrations: "Inscripciones",
      payments: "Split",
      coupons: "Cupones",
    },
    clubs: {
      eyebrow: "Directorio público",
      title: "Clubes",
      subtitle: "Registra y mantiene los clubes mostrados en el directorio público.",
      newClub: "Agregar club",
      listTitle: "Clubes registrados",
      searchPlaceholder: "Buscar club",
      loading: "Cargando clubes...",
      empty: "No se encontraron clubes.",
      loadError: "No fue posible cargar los clubes.",
      imageError: "No fue posible cargar la imagen.",
      imageTooLargeError:
        "Las imágenes enviadas deben ser válidas y tener hasta 3 MB.",
      requiredFieldsError: "Completa nombre, logo, dirección, ciudad y estado.",
      cepLookup: "Buscar CP",
      cepLookupLoading: "Buscando...",
      cepLookupInvalid: "Informa un código postal de 8 dígitos.",
      cepLookupSuccess: "Dirección encontrada por código postal.",
      cepLookupSuccessWithCoordinates:
        "Dirección y coordenadas encontradas por código postal.",
      cepLookupError: "No fue posible buscar la dirección por código postal.",
      selectOnMap: "Seleccionar punto en el mapa",
      mapLookupLoading: "Localizando...",
      mapLookupSuccess: "Ubicación sugerida por la dirección.",
      mapLookupError:
        "No fue posible localizar esta dirección automáticamente. Ajusta el punto en el mapa.",
      closeMapPicker: "Cerrar selector de mapa",
      mapPickerTitle: "Seleccionar punto del club",
      mapPickerDescription:
        "Haz clic en el mapa o arrastra el marcador para definir latitud y longitud.",
      mapPickerAria: "Mapa para seleccionar latitud y longitud del club",
      useMapPoint: "Usar este punto",
      createSuccess: "Club creado.",
      updateSuccess: "Club actualizado.",
      saveError: "No fue posible guardar el club.",
      activated: "Club activado.",
      deactivated: "Club desactivado.",
      deleteConfirm: "¿Eliminar este club?",
      deleteSuccess: "Club eliminado.",
      viewPublic: "Ver público",
      activate: "Activar",
      deactivate: "Desactivar",
      delete: "Eliminar",
      closeModal: "Cerrar formulario de club",
      logo: "Logo",
      createTitle: "Registrar club",
      editTitle: "Editar club",
      active: "Activo",
      save: "Guardar club",
      saving: "Guardando...",
      fields: {
        name: "Nombre",
        logo: "Logo",
        cover: "Foto principal",
        description: "Descripción",
        address: "Dirección",
        city: "Ciudad",
        state: "Estado",
        zipCode: "Código postal",
        number: "Número",
        complement: "Complemento",
        neighborhood: "Barrio",
        phone: "Teléfono",
        whatsapp: "WhatsApp",
        email: "Email",
        site: "Sitio",
        instagram: "Instagram",
        bookingUrl: "Link de reserva",
        lancesUrl: "Link de lances",
        lancesPlatformName: "Nombre de la plataforma de lances",
        latitude: "Latitud",
        longitude: "Longitud",
      },
    },
    misc: {
      athlete: "Atleta",
      currentCategory: "Categoría actual",
      requestedCategory: "Categoría solicitada",
      requestDate: "Fecha de la solicitud",
      noReason: "Sin motivo informado.",
      rejectionNote: "Motivo del rechazo / observación ADM (opcional)",
      rejectionNotePlaceholder:
        "Informa el motivo del rechazo o una observación de aprobación.",
      noUsersHint: "Intenta otro filtro o término de búsqueda.",
      scheduledTime: "Horario previsto",
      startedPrefix: "Iniciado:",
      finishedPrefix: "Finalizado:",
      dailyStart: "Inicio diario",
      dailyEnd: "Fin diario",
      matchDuration: "Duración por partido",
      addSet: "Agregar set",
      registrationsCenter: "Central de Inscripciones",
      registrationsDescription:
        "Gestiona pagos, confirmaciones y lista de espera.",
      billingMethod: "Forma de cobro",
      billingMethodHint: "Usada al enviar cobro",
      unavailableAutomaticBilling: "No disponible para cobro automático",
      emptyRegistrationsHintLine1: "Cuando se realicen nuevas inscripciones,",
      emptyRegistrationsHintLine2: "aparecerón aquí.",
      refreshList: "Actualizar lista",
    },
    actions: {
      createChallenge: "Crear desafío",
      startChallenge: "Iniciar",
      finishChallenge: "Finalizar",
      generateUsersSearchPlaceholder: "Nombre o CPF",
    },
    labels: {
      title: "Título",
      description: "Descripción",
      image: "Imagen",
      date: "Fecha",
      time: "Hora (24h)",
      address: "Dirección",
      challengeName: "Nombre del desafío",
      scheduledAt: "Fecha y hora",
      participants: "Participantes",
      durationSeconds: "Duración (HH:MM)",
      status: "Estado",
    },
    statuses: {
      loadingHistory: "Cargando histórico...",
      pending: "Por iniciar",
      started: "En curso",
      finished: "Finalizado",
      selected: "Seleccionado",
      edit: "Editar",
      user: "Usuario",
      organizer: "Organizador",
      administrator: "Administrador",
    },
    historyTable: {
      id: "ID",
      group: "Desafío",
      status: "Estado",
      scheduledAt: "Fecha/Hora",
      participants: "Participantes",
      action: "Acción",
    },
    sidebar: {
      selectedChallengeEdit: "Edición del desafío seleccionado.",
      contentConfig: "Configuración de contenido de la aplicación.",
      backToPanel: "Volver al panel",
      closePanelMenu: "Cerrar menú del panel",
      adminMenu: "Menú del panel administrativo",
      openSideMenu: "Abrir menú lateral",
      closeSideMenu: "Cerrar menú lateral",
      kicker: "Panel",
      adminTitle: "Administración",
      organizerTitle: "Organización",
      description: "Navegación principal y módulos de gestión.",
      soon: "Próximamente",
      dashboard: "Dashboard",
      finance: "Finanzas",
      notifications: "Notificaciones",
      stockAndPayments: "Stock y pagos",
    },
    usersTab: {
      selfPermissionHint: "No puedes cambiar tu propio permiso de acceso.",
      noUsersFound: "No se encontraron usuarios.",
    },
    tournamentCategoryEditor: {
      title: "Categorías del torneo",
      addCategory: "Agregar categoría",
      fallbackCategory: "Categoría",
      categoryName: "Nombre de la categoría",
      boysCategory: "Categoría niños",
      girlsCategory: "Categoría niñas",
      gender: "Rama",
      registrationMode: "Modo de inscripción",
      individual: "Sorteo de duplas",
      fixedPair: "Dupla fija",
      categoryLocation: "Lugar de la categoría",
      categoryLocationPlaceholder: "Ej.: Club X (opcional)",
      shirtSizesEnabled: "Camiseta",
      shirtSizesEnabledOption: "Habilitar camiseta",
      shirtSizesDisabled: "No usar camiseta",
      shirtSizes: "Tallas de camiseta",
      shirtSizesPlaceholder: "Ej.: S, M, L, XL, Babylook S, Babylook M",
      slotsInCategory: "Plazas en esta categoría",
      fixedPairSlotInfo:
        "En este modo, cada plaza representa 1 dupla (2 jugadores).",
      individualSlotInfo:
        "En este modo, cada plaza representa 1 jugador (las duplas serán sorteadas).",
      categoryActions: "Acciones de la categoría",
      removeCategory: "Eliminar categoría",
      editCategory: "Editar",
      editSelectedCategory: "Editar categoría seleccionada",
    },
    registrationsTab: {
      title: "Inscripciones en eventos",
      refresh: "Actualizar",
      manualRegistrationHint:
        "El registro manual ahora está dentro del desafío (Histórico -> abrir desafío), respetando modo individual o dupla fija.",
      paymentMethod: "Tipo de pago para generar cobro",
      debitCard: "Tarjeta de débito (+3%)",
      creditCard: "Tarjeta de crédito (+7%)",
      loading: "Cargando inscripciones...",
      empty: "No se encontraron inscripciones.",
      statusFilters: {
        pending: "Pendientes",
        confirmed: "Confirmadas",
        waitlist: "Lista de espera",
        canceled: "Canceladas",
        all: "Todas",
      },
      eventPrefix: "evento",
      pair: "Dupla",
      shirtSizes: "Camisetas",
      shirtSizePlayer: "Titular",
      shirtSizePartner: "Dupla",
      status: "Estado",
      payment: "pago",
      player: "Jugador con",
      notFound: "no encontrado",
      notRequired: "no obligatorio",
      paymentLink: "Link de pago",
      open: "abrir",
      copyLink: "Copiar link",
      confirmPayment: "Confirmar pago",
    },
    categoryRequestsTab: {
      title: "Solicitudes de cambio de categoría",
      refresh: "Actualizar",
      loading: "Cargando solicitudes...",
      empty: "No se encontraron solicitudes.",
      playerFallback: "Jugador",
      noEmail: "sin correo",
      to: "para",
      reason: "Motivo",
      status: "Estado",
      adminNote: "Observación ADM",
      adminNoteOptional: "Observación ADM (opcional)",
      processedBy: "Procesado por",
      processedAtPrefix: "en",
      processing: "Procesando...",
      approve: "Aprobar",
      reject: "Rechazar",
      athlete: "Jugador",
      currentCategory: "Categoría actual",
      requestedCategory: "Categoría solicitada",
      requestedAt: "Fecha de la solicitud",
      noReason: "No se informó un motivo.",
      decisionNoteLabel: "Motivo del rechazo / observación ADM (opcional)",
      decisionNotePlaceholder:
        "Informa el motivo del rechazo o una observación de aprobación.",
      decisionNotePrefix: "Motivo del rechazo / observación ADM:",
      singularStatus: {
        pending: "Pendiente",
        approved: "Aprobada",
        rejected: "Rechazada",
      },
      filters: {
        pending: "Pendientes",
        approved: "Aprobadas",
        rejected: "Rechazadas",
        all: "Todas",
      },
      toasts: {
        approved: "Solicitud aprobada y categoría actualizada.",
        rejected: "Solicitud rechazada.",
        error: "No fue posible procesar la solicitud.",
      },
    },
    paymentsTab: {
      splitTitle: "Split ASAAS",
      save: "Guardar",
      secretsHint:
        "API key, webhook token y URLs de ASAAS son gestionados por secrets en el backend.",
      environment: "Ambiente",
      production: "Producción",
      platformWallet: "Wallet plataforma",
      platformFeeType: "Tipo de tasa plataforma",
      percent: "Porcentaje",
      fixedFee: "Fija (R$)",
      feeValue: "Valor de tasa",
      splitEnabled: "Split activo",
      active: "Activo",
      inactive: "Inactivo",
      organizerWallets: "Wallets de organizadores",
      loadingSettings: "Cargando configuraciones...",
      walletId: "Wallet ID",
      organizerSplit: "Split del organizador",
      saveWallet: "Guardar wallet",
      noOrganizers: "No se encontraron organizadores.",
      myWallet: "Mi wallet ASAAS",
      toasts: {
        settingsSaved: "Configuración ASAAS guardada.",
        settingsError: "Error al guardar configuración ASAAS.",
        organizerWalletSaved: "Wallet del organizador actualizada.",
        organizerWalletError: "No fue posible guardar wallet del organizador.",
        myWalletSaved: "Tu wallet fue actualizada.",
        myWalletError: "No fue posible guardar tu wallet.",
      },
    },
    historyList: {
      tournamentsHistory: "Histórico de torneos",
      createTournament: "Crear torneo",
      challengesTitle: "Desafíos",
      createChallenge: "+ Crear desafío",
      challengesSubtitle:
        "Gestiona y acompaña todos los desafíos de tu organización.",
      challengeSearchPlaceholder: "Buscar por nombre del desafío...",
      moreOptionsAria: "Más opciones",
      paginationAria: "Paginación",
      previousPageAria: "Página anterior",
      nextPageAria: "Página siguiente",
      showing: "Mostrando",
      rangeTo: "a",
      rangeOf: "de",
      challengeListKind: "desafíos",
      tournamentListKind: "torneos",
      perPage: "por página",
      organization: "Organización",
      all: "Todos",
      official: "Oficial",
      tnp: "TNP",
      otherOrganizer: "Otro organizador",
      organizer: "Organizador",
      ranking: "Ranking",
      registrationsOpen: "Liberar inscripciones",
      registrationsClose: "Cerrar inscripciones",
      registrationsStateOpen: "Inscripciones abiertas",
      registrationsStateClosed: "Inscripciones cerradas",
      saving: "Guardando...",
      emptyTournament: "No hay torneos en esta sección.",
      emptyChallenge: "No hay desafíos en esta sección.",
      loadingTournament: "Cargando torneo...",
      loadingChallenge: "Cargando desafío...",
      back: "Volver",
      editResults: "Editar resultados",
      saveResults: "Guardar resultados",
      final: "Final",
      activeCategoryForRegistrations: "Categoría activa para inscripciones",
      playerAlreadySelected:
        "Este jugador ya fue seleccionado y no puede entrar en más de una dupla.",
      sidePreference: "Preferencia de lado",
      refreshRegistrations: "Actualizar inscripciones",
      loadingChallengeRegistrations: "Cargando inscripciones del desafío...",
    },
    validation: {
      invalidCpf: "CPF inválido.",
      invalidPhone: "Ingresa el teléfono completo con código de país y área.",
      duplicateCpf: "Este CPF ya está registrado.",
      invalidDateTime: "Informa una fecha/hora válida.",
      invalidEndDate: "Informa una fecha final válida.",
      endDateBeforeStart: "La fecha final no puede ser anterior a la inicial.",
      invalidDuration: "Informa una duración válida en formato HH:MM.",
      organizerRequired: "Selecciona un organizador para este desafío.",
      evenParticipantsRequired:
        "La lista de participantes debe tener cantidad par.",
      super8ParticipantsRequired:
        "Super 8 necesita exactamente 8 participantes.",
      super8PlayersRequired: "Super 8 necesita exactamente 8 jugadores.",
      super8CombinedPlayersRequired:
        "Super 8 debe tener exactamente 8 participantes para generar rondas.",
      cannotStartCurrentConfig:
        "No fue posible iniciar con la configuración actual.",
      super8GroupSplit:
        "Este desafío usa la configuración antigua de Super 8 con 16 participantes y está disponible solo para consulta.",
      invalidChallengeId: "Informa un ID de desafío válido para vincular.",
      maxTrackingIds: "Informa hasta 2 IDs de rastreo (separados por coma).",
      maxTrackingIdsError: "Informa como máximo 2 IDs de rastreo.",
    },
    eventLink: {
      eventCode: "Código del evento (ID)",
      registration: "Inscripción",
      challengeLink: "Vínculo con desafío",
      selectChallenge: "Seleccionar desafío…",
      challengeIdPlaceholder: "ID del desafío",
      defineEventId: "Define un ID del evento para poder vincular.",
      invalidEventId:
        "ID del evento inválido. Usa solo letras, números, _ y - (máx 80).",
      noLink: "Sin vínculo configurado.",
      historyTabName: "Histórico",
      historyHintPrefix: "Abre la pestaña",
      historyHintSuffix: "para poder vincular.",
      registrationHint:
        "El botón de inscripción abre la pantalla de la app para este evento.",
      link: "Vincular",
      removeLink: "Eliminar vínculo",
      linkedToChallengePrefix: "Vinculado al desafío",
      noChallengeFound:
        "No se encontró ningún desafío. Crea un desafío en la pestaña Histórico para vincularlo aquí.",
      toasts: {
        saved: "Vínculo guardado correctamente.",
        saveError: "No fue posible guardar el vínculo.",
        removed: "Vínculo eliminado.",
        removeError: "No fue posible eliminar el vínculo.",
        eventNotFound: "No fue posible identificar el evento de este desafío.",
        registrationsOpened: "Inscripciones liberadas.",
        registrationsClosed: "Inscripciones cerradas.",
        registrationsUpdateError:
          "No fue posible actualizar las inscripciones.",
        rejected: "Inscripción rechazada.",
        rejectError: "No fue posible rechazar la inscripción.",
        paid: "Pago marcado como pagado.",
        paidError: "No fue posible marcar como pagado.",
        paymentLinkCopied: "Link de pago copiado.",
        paymentAlreadyConfirmed: "Pago ya confirmado.",
        noPaymentLink: "No hay link de pago disponible para copiar.",
        copyError: "No fue posible copiar el link.",
        registrationRemoved: "Inscripción eliminada.",
        registrationRemoveError: "No fue posible eliminar la inscripción.",
      },
    },
    createChallengePage: {
      createTournamentTitle: "Crear torneo",
      createChallengeTitle: "Crear desafío",
      editTournamentTitle: "Editar torneo",
      editChallengeTitle: "Editar desafío",
      pageSubtitleTournament:
        "Configura la información principal del torneo.",
      pageSubtitleChallenge:
        "Configura la información principal del desafío.",
      editSubtitleTournament:
        "Actualiza la información principal del torneo.",
      editSubtitleChallenge:
        "Actualiza la información principal del desafío.",
      back: "Volver",
      gender: "Rama",
      maleCategory: "Categoría masculina",
      femaleCategory: "Categoría femenina",
      category: "Categoría",
      organization: "Organización",
      official: "Oficial",
      organizer: "Organizador",
      select: "Seleccionar",
      currentAdmin: "Mi perfil ADM",
      emptyOption: "—",
      includeRanking: "Contabilizar en el ranking oficial",
      includeOrganizerRanking: "Contabilizar en el ranking del organizador",
      includeOfficialRanking: "¿Cuenta para el Ranking Oficial TNP?",
      yes: "Sí",
      no: "No",
      eventIdentity: {
        title: "Identidad del evento",
        info:
          "Elige qué imagen representa este evento en compartidos, cards y pantallas vinculadas al organizador.",
        description:
          "Esta elección aplica solo a este evento y no cambia la identidad global de TNP.",
        mode: "Modo de identidad",
        photo: "Foto del organizador",
        logo: "Logo del organizador",
        tnp: "Estándar TNP",
        photoHelp: "Usa la foto de perfil del organizador en formato circular.",
        logoHelp: "Usa el logo guardado en el perfil del organizador.",
        tnpHelp: "Usa la marca oficial de TNP.",
        logoMissing:
          "Para usar Logo del organizador, agrega un logo al perfil del organizador en Identidad visual.",
        uploadLogo: "Subir logo",
        replaceLogo: "Cambiar logo",
        savingLogo: "Guardando logo...",
        logoSaved: "Logo guardado en tu perfil.",
        logoUploadHelp:
          "El logo subido aquí queda vinculado a tu perfil de organizador.",
        logoInvalid: "Usa PNG, JPG, JPEG o WEBP de hasta 2MB.",
        preview: "Vista previa de la identidad del evento",
        logoPreviewAlt: "Logo del organizador",
        organizerFallback: "Organizador",
      },
      tournamentCategoriesTitle: "Categorías e inscripciones",
      tournamentCategoriesEditDescription:
        "Gestiona categorías, inscripciones, duplas y jugadores.",
      tournamentCategoriesDescription:
        "Configura las categorías del torneo, el modo de inscripción por categoría y el total de plazas.",
      challengeCategoriesTitle: "Categorias del desafio",
      challengeCategoriesDescription:
        "Configura las categorias del desafio, el modo de inscripcion y el horario de cada categoria.",
      challengeCategory: "Categoria del desafio",
      selectCategory: "Seleccione una categoria",
      categoryTime: "Horario de la categoria",
      totalSlots: "Plazas totales configuradas",
      totalSlotsDescription:
        "Suma de las plazas definidas en todas las categorías.",
      generalInfoTitle: "Información general",
      generalInfoDescription:
        "Define el nombre y la descripción que se mostrarán en el torneo.",
      tournamentName: "Nombre del torneo",
      city: "Ciudad",
      state: "Estado",
      clubVenue: "Club/Sede",
      selectCity: "Seleccione una ciudad",
      selectClubVenue: "Seleccione un club/sede",
      manualVenueOption: "Completar manualmente",
      loadingClubs: "Cargando clubes...",
      noRegisteredClubs: "Ningún club registrado",
      eventCityPlaceholder: "Informe la ciudad del evento",
      eventClubVenuePlaceholder: "Informe el club/sede del evento",
      locationPeriodTitle: "Lugar y período",
      locationScheduleTitle: "Lugar y horarios",
      locationPeriodDescription:
        "Configura el lugar predeterminado del torneo y el rango de fechas.",
      locationScheduleDescription:
        "Lugar, período y horario de inicio y fin por día.",
      courtsTitle: "Cancha y nombres de canchas",
      courtsDescription:
        "Registra las canchas disponibles para la programación.",
      organizationRankingTitle: "Organización y ranking",
      organizationRankingDescription:
        "Elige el organizador y la participación en el ranking.",
      tournamentAddressPlaceholder:
        "Lugar predeterminado del torneo (ciudad/club)",
      tournamentStart: "Inicio del torneo",
      tournamentEnd: "Fin del torneo",
      registrationTypeInfoPrefix: "Tipo de inscripción del evento:",
      registrationIndividualSuper8: "individual (Super 8 siempre individual)",
      registrationFixedPairByCategory:
        "dupla fija (definido por la categoría seleccionada)",
      registrationIndividualByCategory:
        "individual (definido por la categoría seleccionada)",
      registrationFixedPairPoco: "dupla fija (Poço siempre dupla fija)",
      registrationFixedPairByMode:
        "dupla fija (definido por el modo de duplas)",
      registrationIndividualByMode:
        "individual (definido por el modo de duplas)",
      pricePerPlayer: "Valor por jugador (R$)",
      fixedPairPriceHint:
        "Para inscripción en dupla fija, el cobro final será este valor x 2.",
      eventSettingsTitle: "Imagen, valor e inscripciones",
      eventSettingsDescription:
        "Configura la imagen pública, el valor, camiseta y apertura de inscripciones.",
      visualIdentityTitle: "Identidad visual",
      visualIdentityDescription:
        "Personalización del organizador y foto del torneo.",
      advancedSettingsTitle: "Configuraciones avanzadas del torneo",
      advancedSettingsDescription:
        "Agrupa reglas opcionales de logística, operación y disponibilidad.",
      tournamentOperationsTitle: "Llaves y cronograma",
      tournamentOperationsDescription:
        "Configura llaves, programación, cronograma y resultados.",
      tournamentEventScheduleTitle: "Cronograma del torneo",
      tournamentEventScheduleDescription:
        "Configura la programación pública por día, horario y actividad.",
      generalRequiredDescription: "Nombre, descripción y valor obligatorio.",
      summary: {
        format: "Formato",
        date: "Fecha",
        categories: "Categorías",
        city: "Ciudad",
        tournament: "Torneo",
        challenge: "Desafío",
        toBeDefined: "Por definir",
        slotsSuffix: "plazas",
        definedByFormat: "Definido por el formato",
        tnpStandard: "Estándar TNP",
        organizerLogo: "Logo del organizador",
        organizerPhoto: "Foto del organizador",
        countsRanking: "Cuenta para ranking",
        countsMyRanking: "Cuenta para mi ranking",
        notRanking: "No cuenta para ranking",
        tournamentSummary: "Resumen del torneo",
        challengeSummary: "Resumen del desafío",
        locationFallback: "Lugar por definir",
        participantsSuffix: "participante(s)",
        changes: "Cambios:",
        pending: "Pendientes:",
        saveChanges: "Guardar cambios",
        pendingSchedule: "programación",
        pendingGeneralInfo: "información general",
        pendingShirts: "camisetas",
        pendingParticipants: "categorías y participantes",
        pendingRounds: "rondas y resultados",
      },
      operations: {
        registrations: "Inscripciones",
        registrationsOpen: "Abiertas",
        registrationsClosed: "Cerradas",
        openRegistrations: "Abrir inscripciones",
        closeRegistrations: "Cerrar inscripciones",
        closeRegistrationsMessage: '¿Cerrar las inscripciones de "{name}"?',
        closingRegistrations: "Cerrando...",
        redrawPairs: "Sortear duplas nuevamente",
        regenerateRounds: "Generar rondas nuevamente",
        closeBeforeStart: "Cierra las inscripciones antes de iniciar.",
        generateBeforeStart: "Genera las rondas antes de iniciar.",
      },
      sectionStatus: {
        complete: "Completo",
        attention: "Atención",
        pending: "Pendiente",
      },
      downloadShirtSizes: "Descargar planilla de camisetas",
      shirts: {
        eventShirts: "Camisetas del evento",
        availabilityType: "Disponibilidad de camisetas",
        availabilityNone: "Sin limite",
        availabilityPeriod: "Por periodo",
        availabilityQuantity: "Por cantidad",
        deadline: "Plazo para elegir camiseta",
        quantityLimit: "Cantidad maxima de camisetas",
        quantitySummary:
          "Total: {total} | Confirmadas: {confirmed} | Disponibles: {available}",
      },
      customSettings: {
        challengeModel: "Modelo del desafio",
        tnpStandard: "Estandar TNP",
        custom: "Personalizado",
        gameType: "Tipo de juego",
        byGames: "Por games",
        byTime: "Por tiempo",
        gameCount: "Cantidad de games",
        gameDurationMinutes: "Tiempo por juego",
        courtsCount: "Cantidad de canchas",
        defaultCourtsCount: "Canchas predeterminadas para nuevas categorías",
        categoryCourtsCount: "Canchas de esta categoría",
        playersCount: "Cantidad de jugadores",
        challengeWaitingPlayersHelp:
          "En Challenge, se permiten hasta 2 jugadores en espera por cancha.",
        pocoExactPlayersHelp:
          "En Poço, cada cancha debe tener exactamente 4 jugadores.",
        timeOver: "Tiempo finalizado.",
        startTimer: "Iniciar tiempo",
        pauseTimer: "Pausar tiempo",
        resetTimer: "Reiniciar tiempo",
      },
      submitTournament: "Crear torneo",
      submitChallenge: "Crear desafío",
      saving: "Guardando...",
      defaultCategoryPrefix: "Categoría",
      toasts: {
        organizersLoadError: "Error al cargar organizadores.",
        organizerRequiredTournament:
          "Selecciona un organizador para este torneo.",
        organizerRequiredChallenge:
          "Selecciona un organizador para este desafío.",
        invalidSlots: "Informa un número válido de plazas (mínimo 2).",
        imageRequired: "Agrega una imagen antes de guardar.",
        cityRequired: "Informe la ciudad del evento.",
        clubVenueRequired: "Informe el club/sede del evento.",
        priceRequired:
          "Informa un valor por jugador mayor que cero antes de guardar.",
        priceMinimum: "El valor mínimo permitido es de R$ 5,00.",
        scheduleRequired:
          "Informa al menos una cancha y horarios válidos para el torneo.",
        shirtSettingsRequired: "Informa si habrá camisetas en el evento.",
        shirtSizesRequired:
          "Informa al menos una talla de camiseta antes de guardar.",
        shirtDeadlineRequired:
          "Informe el plazo limite para elegir camiseta.",
        shirtDeadlinePast:
          "El plazo para elegir camiseta no puede estar en el pasado.",
        shirtQuantityRequired: "Informe la cantidad maxima de camisetas.",
        gameCountRequired: "Informe la cantidad de games.",
        gameDurationRequired: "Informe el tiempo por juego.",
        courtsCountRequired: "Informe al menos 2 canchas.",
        playersCountRequired: "Informe al menos 12 jugadores.",
        challengeMaxPlayersExceeded:
          "Cantidad máxima excedida. En Challenge personalizado, se permiten hasta 2 jugadores en espera por cancha.",
        pocoExactPlayersRequired:
          "En Poço personalizado, la cantidad de jugadores debe ser exactamente 4 jugadores por cancha.",
        pocoMinPlayersRequired: "El Poço debe tener al menos 12 jugadores.",
        noShirtSizesToExport:
          "No hay inscripciones disponibles para exportar camisetas.",
        categoriesRequired:
          "Crea al menos una categoría personalizada del torneo con plazas.",
        challengeCategoriesRequired:
          "El desafio debe tener al menos una categoria.",
        challengeCategoryRequired: "Seleccione una categoria.",
        categoryTimeRequired: "Informe el horario de la categoria.",
        eachCategoryNeedsTime: "Cada categoria debe tener un horario.",
        duplicateChallengeCategory: "Esta categoria ya fue agregada.",
        challengeCategoryApplied:
          "Categoria aplicada. Usa Guardar todo del desafio para persistir.",
        categorySaved: "Categoría guardada correctamente.",
        categorySaveError: "Error al guardar la categoría.",
        categoryRegistrationTypeSaved: "Modo de inscripción guardado.",
        invalidEndDate:
          "La fecha final no puede ser anterior a la fecha inicial.",
        tournamentSaved: "Torneo guardado correctamente.",
        challengeSaved: "Desafío guardado correctamente.",
        tournamentSaveError: "Error al guardar el torneo.",
        challengeSaveError: "Error al guardar el desafío.",
      },
    },
  },
};

function isObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function deepMerge<T>(base: T, override?: DeepPartial<T>): T {
  if (!override) return base;
  if (Array.isArray(base) || Array.isArray(override)) {
    return (override ?? base) as T;
  }
  if (!isObject(base) || !isObject(override)) {
    return (override ?? base) as T;
  }

  const result: Record<string, unknown> = { ...base } as Record<
    string,
    unknown
  >;
  Object.keys(override).forEach((key) => {
    const overrideValue = (override as Record<string, unknown>)[key];
    if (overrideValue === undefined) return;
    const baseValue = (base as Record<string, unknown>)[key];
    result[key] = deepMerge(baseValue, overrideValue as never);
  });
  return result as T;
}

const siteTextsByLanguage: Record<SiteLanguage, SiteTexts> = {
  pt: siteTextsPt,
  en: deepMerge(siteTextsPt, enOverrides),
  es: deepMerge(siteTextsPt, esOverrides),
};

function resolveSiteTexts() {
  return siteTextsByLanguage[getSiteLanguage()] || siteTextsPt;
}

export const siteTexts: SiteTexts = new Proxy({} as SiteTexts, {
  get(_target, prop: keyof SiteTexts) {
    return resolveSiteTexts()[prop];
  },
  has(_target, prop) {
    return prop in resolveSiteTexts();
  },
  ownKeys() {
    return Reflect.ownKeys(resolveSiteTexts());
  },
  getOwnPropertyDescriptor(_target, prop) {
    return Object.getOwnPropertyDescriptor(resolveSiteTexts(), prop);
  },
});
